import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  NgModel,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material";
import { EditCustomerDialogComponent } from "../dialogs/edit-customer-dialog/edit-customer-dialog.component";
import { AddCustomerDialogComponent } from "../dialogs/add-customer-dialog/add-customer-dialog.component";
import { ActivatedRoute, Router } from "@angular/router";
import {
  addMonths,
  differenceInCalendarMonths,
  format,
  getDate,
  isValid,
  lastDayOfMonth,
  parse,
  setDate,
} from "date-fns";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { forkJoin } from "rxjs/observable/forkJoin";
import { Lightbox } from "ngx-lightbox";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import { ProjectsService } from "../services/projects/projects.service";
import { environment } from "./../../environments/environment";
import { LeadsService } from "./../services/lead-service/lead-service.service";
import { MarketingService } from "./../services/marketing/marketing.service";
import { ReservationService } from "./../services/reservation-service/reservation.service";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { UserServiceService } from "./../services/user-service/user-service.service";
import { print_template } from "../shared/helpers/print_helpers";
import { printSaleReservationFile } from "./prints/sale-reservation-file";
import { printReceiptPdf, resolvePaymentMethod } from "./prints/receipt-pdf";
import { of } from "rxjs/observable/of";
import { map } from "rxjs/operators";
import { PaymentService } from "../services/payment/payment.service";

declare var Tafgeet: any;

interface TransferToContractedUnitReservation {
  id: number;
  sharing_leads?: any[];
  serial: string;
  customerName?: string;
  amount: number | null;
  amountDisplay: string;
}

@Component({
  selector: "app-reservation-view",
  templateUrl: "./reservation-view.component.html",
  styleUrls: ["./reservation-view.component.css"],
})
export class ReservationViewComponent implements OnInit {
  @ViewChild("collectCheque") collectCheque: ElementRef;
  readonly DATE_FORMAT_STANDARD = 1;
  readonly DATE_FORMAT_SPACED_DDMMYYYY = 2;
  readonly DEFAULT_DATE_DIGIT_SPACING_PX = 1;
  readonly PX_PER_CM = 37.7952755906;
  readonly defaultLinearText = "يصرف للمستفيد الأول";
  ListEdits_inputs = false;
  DeveloperEdits_inputs = false;
  SharingEdits_inputs = false;
  methods: any;
  reservation_details: any;
  userProfile: any;
  chosenAgent: any;
  dataFromSearch: any;
  arrSearch: any;
  selling_price: any;
  selling_date: any;
  delivery_date: any;
  confirmation_date: any;
  commentReservation: any;
  installmentForm: FormGroup;
  installmentMethods: any;
  installmentDays: any = [];
  is_refreshing = false;
  doc_type_installment_modal: any = ["PDF", "Excel"];
  is_installment_modal_loading = false;
  isReservationGiftLoading = false;
  isShareHolderReservationLoading = false;
  payments_option = ["Quarter", "Semi-annual", "Annual"];
  last_price: any;
  cfo_pin: any;
  filesForm: FormGroup;
  filterForm: FormGroup;
  uploadExcel: FormGroup;
  file_name: any;
  file: any;
  file_name2: any;
  signature_date: any;
  chosenLeadID: any;
  leadArrSerach: any;
  chosenLead: any;
  chosenClient: any = {};
  chosenLeadReason: any;
  chosenLeadPhone: any;
  chosenLeadName: any;
  chosenLeadNationalityID: any;
  chosenLeadNationality: any;
  chosenLeadDistrict: any;
  chosenLeadIssueDate: any;
  chosenLeadCivilRegistery: any;
  chosenLeadBirthday: any;
  chosenLeadAddress: any;
  filterAgentByWordText: any;
  percentage: any;
  refundReason: any;
  type_extra_discount: any = "percentage";
  value_extra_discount: any;
  reason: any;
  down_payment: any;
  deal_types: any = ["Direct", "In-Direct"];
  direct_option: any = ["Individual"];
  ambassadors: any;
  brokers: any;
  partner_brokers: any[] = [];
  deal_type: any;
  commission_date: any;
  active_cheque_book_row: any;

  claim_form = {
    claim_date: "",
    claim_from: "",
  };

  // ------------add-customer decl------------
  customersData: any;
  chosenCustomer;
  addCustomerForm = {
    lead_id: "",
    lead_name: "",
    lead_phone: "",
    lead_home_phone: "",
    lead_email: "",
    lead_national_id: "",
    lead_nationality: "",
    lead_other_phone: "",
    lead_birthday: "",
    lead_address: "",
    lead_district: "",
    sharing_percentage: "",
    customer_type: "",
    phone_without_code: '',
    code: '',
    phone_3_without_code: '',
    code_3: '',
    phone_2_without_code: '',
    code_2: '',
  };
  staticLeads = [
    {
      created_at: "2021-12-01 13:44:03",
      id: 225,
      lead_address: null,
      lead_birthday: null,
      lead_district: null,
      lead_email: null,
      lead_fax_number: null,
      lead_home_phone: null,
      lead_issue_date: null,
      lead_job_title: null,
      lead_marital_status: null,
      lead_name: "Ali .syed",
      lead_national_id: null,
      lead_nationality: null,
      lead_other_phone: null,
      lead_phone: "96550747384",
      lead_work_address: null,
      lead_workplace: null,
      reservation_id: 250,
      sharing_percentage: 100,
      updated_at: "2021-12-01 13:44:03",
    },
    {
      created_at: "2021-12-01 13:44:03",
      id: 225,
      lead_address: null,
      lead_birthday: null,
      lead_district: null,
      lead_email: null,
      lead_fax_number: null,
      lead_home_phone: null,
      lead_issue_date: null,
      lead_job_title: null,
      lead_marital_status: null,
      lead_name: "Ali .syed",
      lead_national_id: null,
      lead_nationality: null,
      lead_other_phone: null,
      lead_phone: "96550747384",
      lead_work_address: null,
      lead_workplace: null,
      reservation_id: 250,
      sharing_percentage: 100,
      updated_at: "2021-12-01 13:44:03",
    },
    {
      created_at: "2021-12-01 13:44:03",
      id: 225,
      lead_address: null,
      lead_birthday: null,
      lead_district: null,
      lead_email: null,
      lead_fax_number: null,
      lead_home_phone: null,
      lead_issue_date: null,
      lead_job_title: null,
      lead_marital_status: null,
      lead_name: "Ali .syed",
      lead_national_id: null,
      lead_nationality: null,
      lead_other_phone: null,
      lead_phone: "96550747384",
      lead_work_address: null,
      lead_workplace: null,
      reservation_id: 250,
      sharing_percentage: 100,
      updated_at: "2021-12-01 13:44:03",
    },
  ];
  customer_id;
  single_customer;
  garageSlots: any;
  slots = {
    service_room_slots: 0,
    service_room_with_bathroom_slots: 0,
  };
  last_payment_type: any;
  is_overseas: any;
  slip_number: any;
  cheque_number: any;
  due_date: any;
  commission_to: any;
  cash: any;
  ev: any;
  installment_delay: any;
  type = "6 years";
  paymentForm: FormGroup;
  payment_term_id: any;

  selling_price_in_modal: any;
  discount_on: any;

  pcIncentiveType: any;
  pcIncentiveAmount: any;
  isPcIncentiveModalLoading = false;

  edit_lead_data = {
    lead_id: "",
    lead_name: "",
    lead_phone: "",
    lead_email: "",
    lead_national_id: "",
    lead_nationality: "",
    lead_other_phone: "",
    lead_birthday: "",
    lead_address: "",
    lead_district: "",
    lead_phone2: "",
    sharing_percentage: "",
    customer_type: "",
    lead_phone_without_code: "",
    lead_code: "",
    lead_home_phone_without_code: "",
    lead_home_code: "",
    lead_other_phone_without_code: "",
    lead_other_code: "",
  };

  contractForm: FormGroup;

  cancel_reason: any;
  cancel_date: any;

  agents: any;

  agent_in_charge: any;

  contract_type_details = {
    contract_type: "",
    rent_value: "",
    rent_start_date: "",
    rent_end_date: "",
    rent_years_num: "",
    payment_type: "",
    is_overseas: "",
    installment_years: "",
    // installment_fees: "",
  };
  payment_plans: any;
  _staticMasterPlanImages: any;

  currentSlide: any;

  payment_collections_list = [
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: true,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: true,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
  ];

  partially_methods = [
    {
      name: "Cash",
      id: 1,
    },
    {
      name: "Visa",
      id: 2,
    },
    {
      name: "Transfer",
      id: 3,
    },
    {
      name: "Cheque",
      id: 4,
    },
    // {
    //   name: "Commission Settlement",
    //   id: 5,
    // },
    {
      name: "Share Holder Settlement",
      id: 6,
    },
    {
      name: "Vendor Settlement",
      id: 7,
    },
  ];
  todayDate = new Date();

  sharedAgentsCommissionsView: any;
  sharedAgentsCommissions: FormArray = new FormArray([]);
  disable_save_shared_comission = false;

  oversea_contract_sent_date: any = new Date();

  payment_type: any = "down_payment";
  slip_type: any;
  slip_customer: any;
  deposit_amount: any;

  complete_down_payment_amount: any;

  banks: any;
  bank_id: any;
  chequeTemplatesByBank: any[] = [];
  selectedChequeTemplateId: number = null;
  selectedPrintBankId: number = null;
  selectedPrintBankName: string = "";
  selectedPrintTemplatePreviewUrl: string = null;
  selectedChequePrintIds: number[] = [];
  selectedChequePrintRows: any[] = [];
  selectedChequeTemplateDetails: any = null;
  selectedChequeTemplateDimensions: { width: number; height: number } | null =
    null;
  selectedChequeTemplateImageDimensions: { width: number; height: number } | null =
    null;
  isChequeTemplateDetailsLoading = false;
  store_status: any;

  documentForm: FormGroup;
  documents: any;
  residenceDocumentUrl = "";
  types: any = [
    {
      id: 1,
      name: "MAINTENANCE",
    },
    {
      id: 2,
      name: "CUSTOM MAINTENANCE",
    },
    {
      id: 3,
      name: "GAS",
    },
    {
      id: 5,
      name: "SERVICE ROOM",
    },
    {
      id: 6,
      name: "SERVICE ROOM WITH BATHROOM",
    },
    {
      id: 7,
      name: "FACILITIES",
    },
  ];

  add_cheque = {
    name: "",
    bank_id: null, // done
    store_status: null, // done
    cheque_number: "", // done
    cheque_book_name: "",
    name_on_cheques: "",
    amount: "", // done
    due_date: null,
    amount_received: "0",
    transaction_number: "", // done
    date: new Date(), // done
    type: 1,
    sharing_type: 2,
    maintenance_type: 1,
    count: 1,
    interval: 1,
    partially_method: null,
    // fixed
    status: "under-collection",
    send_reminder: 1, // done
    print_status: 1, // done
  };

  contract_signed_by_client_date: any;
  reservation_form_signed_date: any;
  contract_approve_date: any;
  contract_dilever_date: any;

  cheque_recieved_date: any;

  /*Payment collection variables Start*/
  payment_collections: any;
  pageTest = 1;
  /*Payment collection variables End*/

  reservationFiles = [];
  finalPaymentPlanFile;
  isReadonlyMode = false;
  reservationId;
  currentRole = "";
  isAccountant = false;
  divisionForm: any = {};

  /** RF Viewer: see all tabs, no actions */
  get isRfViewer(): boolean {
    return !!(this.userProfile && this.userProfile.role === "RF Viewer");
  }

  // cheques book
  enable_edit_payment_collections = false;
  disableSavePaymentCollection = false;
  check_all = false;
  current_active_cheque: number;
  current_active_full_cheque: any;
  enableRemiderType: string;
  disableReminderType: string;
  chequeCollectType: any;
  chequeCollectCustomer: any;
  collect_type = "fully-collected";
  collection_date = "";
  chequeRejectType: any;

  developer_id: number;
  name_on_cheques: string;
  cheque_book_name: string;

  reminder_reason: string;

  uploadScannedChequeForm: FormGroup;

  reject_reason: any;
  reject_comment: string;
  cheque_amount: any;

  partially_method: any;
  partially_data: any;
  exchange_rate: any;

  addContractLog = {
    reservation_id: "",
    agent_id: "",
    delivered_at: "",
    status: "",
    details: "",
  };

  developers: any;
  events = [];

  store_banks: any;

  fines: any;
  collect_type_fines = "fully-collected";
  collection_date_fines = "";
  chequeCollectTypeFine: any;
  chequeCollectCustomerFines: any;
  current_active_cheque_fine: number;
  partially_method_fines: any;
  partially_data_fines: any;
  cheque_amount_fines: any;
  currency_code: any = "EGP";

  currencies_list = [];

  chequeRejectTypeFine: any;

  cheque_amount_fine = null;
  reject_reason_fine = null;
  reject_comment_fine = null;

  totalChequeBookAmount = 0;
  totalCDBAmount = 0;
  intialTotalChequeSharingAmount = 0;
  intialTotalChequeDeveloperAmount = 0;
  totalChequeSharingAmount = 0;
  totalChequeDeveloperAmount = 0;
  partnerCommissionBasePercent = 10;
  partnerCommissionUi: any = {
    agentPercent: null,
    brokerPercent: null,
    ambassadorPercent: null,
    externalTotalPercent: null,
    partnerPercent: null,
    partnerAmount: null,
    isExceeded: false,
    hasData: false,
  };

  eoiDataFromSearch: any;
  eoisArrSearch: any;
  chosen_eoi: any;
  chosenEoi: any;

  location_bounce;

  transaction_number: any;

  add_bulk_cheque_amount: string;

  commission_settlement_user_id: number;
  share_holder_name: string;

  redeposit_date: string;

  request_reason: string;
  request_date: string;
  request_type: string;
  request_ids: number[];

  reject_reasons: any;

  bounce_date: any;

  reason_exclude_from_calculation: string[] = [
    "Cancelation-Visa Payment",
    "Cancelation-Cash Payment",
    "Cancelation-Transfer Payment",
    "Transfer of ownership",
    "Client Death",
    "Early Payment",
    "Cheques replacement",
  ];

  current_edit_lead_data: any = {};
  printSharingType: number;
  eoiValue: number;
  reservation_activity_logs: any;
  list: any;
  final_cheque_received_date: any;

  incentive_users: any[] = [];
  broker_incentive_id: any;
  partner_broker_id: any;
  partner_broker_name: string = "";
  refund_company_amount: any;
  total_amount: any;
  refund_discount_amount: any;
  fines_amount_returned: any;
  approve_refund_date: any;
  equivalent_in_currency: string;
  reservationDataFromSearch: any;
  reservationsArrSearch: any;
  chosen_reservation: any;
  chosenReservation: any;
  unit_type: string;
  terminationReasons: string[] = ["Legal Case", "Rejected Cheques"];
  refundReasons: any = [
    "Cancellation Unit",
    "Termination Unit",
    "Financial issue",
    "Return to Company",
    "Personal issue",
    "Legal action",
    "Activate by Mistake",
    "Contract details",
    "Rejected Cheques",
    "transfer to another unit",
  ];
  refundRequestReasons: any = [
    {
      value: "transfer to another unit",
      lable: "Transfer To Another Unit",
    },
    {
      value: "termination",
      lable: "Termination",
    },
    {
      value: "return to company",
      lable: "Return To Company",
    },
    {
      value: "customer cancelled",
      lable: "Customer Cancelled",
    },
    {
      value: "transfer to contracted unit",
      lable: "Transfer To Contracted Unit",
    },
  ];
  terminationReason: any;
  change_reservation_fine: any = {
    fine_type: null,
    fine_percentage: null,
    is_fine_calc: false,
  };
  fine_types = [
    {
      id: 1,
      name: "Day",
    },
    {
      id: 2,
      name: "Month",
    },
  ];
  approveCollect: any = {
    collection_date: null,
    bank_id: null,
    cheque_number: null,
    transaction_number: null,
    store_status: null,
    partially_method: null,
  };
  disable_collect_action: boolean;
  disable_submit_action: boolean;
  rentDetailsForm: FormGroup;

  // Collect from CDB properties
  collectFromCDB = {
    collection_date: "",
    cdb_id: null,
  };
  availableCDBPayments: any[] = [];
  activeCollectFromCDBPayment: any;
  collectFromCDBSubmitting = false;
  is_collect_fine: any;

  ownerArrSearch: any;
  ownersData: any;
  chosenOwner: any;
  addOwnerForm: any = {};
  ownershipTransfers: any;
  ownershipTransfersRequests: any;
  ownership_id: any;
  approveOwnerTransferRequestIsLoading: boolean = false;
  disabledOwnerTransferRequestIsLoading: boolean = false;
  disabledApprovePaymentOwnerTransferRequestIsLoading: boolean = false;
  isApproveSaving: boolean = false;
  isRefundRequestLoading: boolean = false;
  isApproveRefundRequestLoading: boolean = false;
  isFinalApproveRefundRequestLoading: boolean = false;
  final_approve_refund_date: any;
  transferToContractedUnitSelection: string | null = null;
  transferToContractedUnitReservations: TransferToContractedUnitReservation[] =
    [];
  transfer_payment_as: string = null;
  activeRefundPayment: any;
  approvePaymentRefundDate = "";
  rejectPaymentRefundDate = "";
  paymentRefundRequestSubmitting = false;
  paymentRefundRequestData = {
    date: "",
    refund_amount: null,
  };
  private readonly transferAmountTolerance = 0.01;
  vendorArrSearch: any;
  vendors: any[] = [];
  vendor_code: string;
  vendor_name: string;
  shareholderArrSearch: any;
  shareholders: any[] = [];
  shareholder_code: string;
  splitCDBAmount: any;
  shareholder_name: any;

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private reservationService: ReservationService,
    private paymentService: PaymentService,
    private errorHandlerService: ErrorHandlerService,
    private http: HttpClient,
    private fb: FormBuilder,
    private userService: UserServiceService,
    private leadsService: LeadsService,
    private _lightbox: Lightbox,
    private projectsService: ProjectsService,
    private marketingService: MarketingService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.createDivisionForm();
  }

  ngOnInit() {
    this.getRejectReaasons();
    this.getdevelopers();
    this.getChannels();
    this.getEvents();
    this.getStoreBanks();
    this.getAllCurrencies();
    this.userProfile = JSON.parse(window.localStorage.getItem("userProfile"));
    this.currentRole = window.localStorage.getItem("role");
    if (
      this.currentRole &&
      (this.currentRole == "A.R Accountant" ||
        this.currentRole == "G.L Accountant" ||
        this.currentRole == "Treasury Accountant")
    )
      this.isAccountant = true;
    this.getQParams();
    this.getParams();
  }

  getFilteredStoreBanks(list: any) {
    if (!this.store_banks) return [];
    const developerId = this.getReservationDeveloperId();
    const allowedLocationTypes = this.getEditableLocationTypesForCollectMethod(
      list && list.partially_method
    );
    let storeBanks = this.store_banks;

    if (developerId) {
      storeBanks = storeBanks.filter(
        (bank) => bank.developer_id === developerId
      );
    }

    if (allowedLocationTypes.length) {
      storeBanks = storeBanks.filter(
        (bank) =>
          bank.type &&
          allowedLocationTypes.includes(String(bank.type).toLowerCase())
      );
    }

    return storeBanks;
  }

  getCollectStoreBanks() {
    if (!this.store_banks) return [];
    const developerId = this.getReservationDeveloperId();
    const requiredLocationType = this.getLocationTypeForCollectMethod(
      this.partially_method
    );
    let storeBanks = this.store_banks;

    if (developerId) {
      storeBanks = storeBanks.filter(
        (bank) => bank.developer_id === developerId
      );
    }

    if (requiredLocationType) {
      storeBanks = storeBanks.filter(
        (bank) =>
          bank.type &&
          String(bank.type).toLowerCase() ===
            requiredLocationType.toLowerCase()
      );
    }

    return storeBanks;
  }

  isCollectLocationDisabled() {
    if (
      !this.active_cheque_book_row ||
      !this.active_cheque_book_row.store_status
    ) {
      return false;
    }

    return this.isAllowedCollectLocation(
      this.active_cheque_book_row.store_status
    );
  }

  private getEditableLocationTypesForCollectMethod(
    partiallyMethod: any
  ): string[] {
    if (String(partiallyMethod) === "4") {
      return ["bank", "treasury"];
    }

    const locationType = this.getLocationTypeForCollectMethod(partiallyMethod);
    return locationType ? [locationType.toLowerCase()] : [];
  }

  private getLocationTypeForCollectMethod(partiallyMethod: any): string {
    switch (String(partiallyMethod)) {
      case "1":
        return "Treasury";
      case "2":
      case "3":
      case "4":
        return "Bank";
      default:
        return null;
    }
  }

  private isAllowedCollectLocation(locationId: any) {
    return this.getCollectStoreBanks().some(
      (bank) => String(bank.id) === String(locationId)
    );
  }

  private requireValidCollectLocation() {
    if (this.store_status && !this.isAllowedCollectLocation(this.store_status)) {
      this.store_status = null;
    }
  }

  onStoreBankChange(storeBankId: any) {
    const selectedBank = (this.store_banks || []).find(
      (bank) => String(bank.id) === String(storeBankId)
    );

    if (
      !selectedBank ||
      selectedBank.currency_id === undefined ||
      selectedBank.currency_id === null
    ) {
      return;
    }

    const selectedCurrency = (this.currencies_list || []).find(
      (currency) => String(currency.id) === String(selectedBank.currency_id)
    );

    if (!selectedCurrency || !selectedCurrency.code) {
      return;
    }

    if (this.currency_code !== selectedCurrency.code) {
      this.currency_code = selectedCurrency.code;
      this.exchange_rate = null;
      this.equivalent_in_currency = null;
    }
  }

  getStoreBankLabel(bank: any) {
    if (bank && bank.developer && bank.developer.name) {
      return bank.developer.name;
    }

    return bank ? bank.name : "";
  }

  private getReservationDeveloperId() {
    if (this.reservation_details && this.reservation_details.project) {
      return this.reservation_details.project.developer_id;
    }

    if (
      this.reservation_details &&
      this.reservation_details.unit &&
      this.reservation_details.unit.project
    ) {
      return this.reservation_details.unit.project.developer_id;
    }

    return null;
  }

  private toNumber(value: any): number {
    if (value === undefined || value === null || value === "") {
      return 0;
    }
    const parsedValue = Number(value);
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
  }

  private roundCurrency(value: number): number {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  get transferTotalCollectedAmount(): number {
    const totalCollected = this.reservation_details
      ? this.reservation_details.total_collected
      : null;
    return this.toNumber(totalCollected);
  }

  get transferAllocatedAmount(): number {
    return this.transferToContractedUnitReservations.reduce(
      (sum, reservation) => sum + (reservation.amount || 0),
      0
    );
  }

  get transferRemainingAmount(): number {
    const discountAmount =
      this.reservation_details && this.reservation_details.refund_discount_amount
        ? this.reservation_details.refund_discount_amount
        : 0;
    return this.roundCurrency(
      this.transferTotalCollectedAmount -
        this.transferAllocatedAmount -
        this.toNumber(discountAmount)
    );
  }

  get canAddSelectedTransferReservation(): boolean {
    const reservationId = this.parseReservationSelection(
      this.transferToContractedUnitSelection
    );
    if (!reservationId) {
      return false;
    }
    return !this.transferToContractedUnitReservations.some(
      (reservation) => reservation.id === reservationId
    );
  }

  get isTransferToContractedUnitSubmitDisabled(): boolean {
    if (!this.transferToContractedUnitReservations.length) {
      return true;
    }
    const hasInvalidAmount = this.transferToContractedUnitReservations.some(
      (reservation) => reservation.amount === null || reservation.amount <= 0
    );
    if (hasInvalidAmount) {
      return true;
    }
    return (
      Math.abs(this.transferRemainingAmount) >= this.transferAmountTolerance
    );
  }


  compareByValueFn(item1: any, item2: any) {
    if (item1 == null || item2 == null) {
      return item1 == item2;
    }

    const item1IsObject = typeof item1 === "object";
    const item2IsObject = typeof item2 === "object";

    if (
      item1IsObject &&
      item2IsObject &&
      item1.hasOwnProperty("value") &&
      item2.hasOwnProperty("value")
    ) {
      return item1.value == item2.value;
    }

    if (
      item1IsObject &&
      item2IsObject &&
      item1.hasOwnProperty("id") &&
      item2.hasOwnProperty("id")
    ) {
      return item1.id == item2.id;
    }

    return item1 == item2;
  }


  onEditsChange(type) {
    if (type == "SharingEdits_inputs") {
      this.DeveloperEdits_inputs = false;
      this.ListEdits_inputs = false;
    } else if (type == "DeveloperEdits_inputs") {
      this.SharingEdits_inputs = false;
      this.ListEdits_inputs = false;
    } else {
      this.SharingEdits_inputs = false;
      this.DeveloperEdits_inputs = false;
    }
  }

  getIncentiveUsers(broker_id: number) {
    this.userService.get_incentive_users(broker_id).subscribe(
      (res: any) => {
        this.incentive_users = res;
        console.log(this.agents);
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getAllCurrencies() {
    this.slimLoadingBarService.start();
    this.reservationService.getAllCurrencies().subscribe(
      (data: any) => {
        this.currencies_list = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }
  getStoreBanks() {
    this.slimLoadingBarService.start();
    this.userService.getBanks().subscribe(
      (data: any) => {
        this.store_banks = data;
        console.log(this.banks);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getEvents() {
    this.slimLoadingBarService.start();
    this.reservationService.getAllEvents().subscribe(
      (res: any) => {
        console.log(res);
        this.events = res;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getParams() {
    this.createInstallmentForm();
    this.activatedRoute.params.subscribe((res) => {
      if (res["id"]) this.reservationId = res["id"];
      else {
        this.reservationId = JSON.parse(
          window.localStorage.getItem("reservationDetails")
        ).id;
      }
      !this.userProfile.is_sales_team &&
        this.userProfile.role != "Legal and Technical" &&
        this.userProfile.role != "Contractor" &&
        this.getOwnershipTransfers(this.reservationId);
      !this.userProfile.is_sales_team &&
        this.userProfile.role != "Legal and Technical" &&
        this.userProfile.role != "Contractor" &&
        this.getOwnershipTransfersRequests(this.reservationId);
      this.createDocumentForm();
      this.createPaymentForm();
      this.createFilesUploadForm();
      this.getReservation();
    });
  }

  getQParams() {
    this.activatedRoute.queryParams.subscribe((res) => {
      // one flag only: query ro=1 OR RF Viewer role
      this.isReadonlyMode = res["ro"] == 1 || this.isRfViewer;
    });
  }

  channels: any;
  leadSources = [];

  require_channels = [];
  getChannels() {
    this.slimLoadingBarService.start();
    this.marketingService.getChannels().subscribe(
      (res: any) => {
        this.channels = res;
        this.require_channels.map((a) => a());
        this.require_channels = null;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  receivePhone(event, obj, phone, code, err) {
    this[obj][err] = event.phoneError;
    this[obj][phone] = event.phone;
    this[obj][code] = event.code;
  }

  getReservationActivityLogs(id) {
    this.reservationService
      .getReservationActivityLogs(id)
      .subscribe((res: any) => {
        this.reservation_activity_logs = res;
      });
  }

  channelChange(change = true) {
    if (change) {
      this.divisionForm.lead_source = -1;
    }
    if (Array.isArray(this.require_channels)) {
      this.require_channels.push(() => {
        this.channels.forEach((e) => {
          if (e.name == this.divisionForm.deal_type) {
            this.leadSources = [];
            if (change) {
              this.divisionForm.deal_category = "";
              this.divisionForm.deal_source = "";
            }
            this.leadSources = e.sources;
            if (change && e.name != "Direct") {
              if (this.divisionForm.broker_id) {
                this.divisionForm.broker_id = null;
              } else if (this.divisionForm.ambassador_id) {
                this.divisionForm.ambassador_id = null;
              }
            }
          }
        });
      });
    } else {
      this.channels.forEach((e) => {
        if (e.name == this.divisionForm.deal_type) {
          this.leadSources = [];
          if (change) {
            this.divisionForm.deal_category = "";
            this.divisionForm.deal_source = "";
          }
          this.leadSources = e.sources;
          if (change && e.name != "Direct") {
            if (this.divisionForm.broker_id) {
              this.divisionForm.broker_id = null;
            } else if (this.divisionForm.ambassador_id) {
              this.divisionForm.ambassador_id = null;
            }
          }
        }
      });
    }
  }

  createPaymentForm() {
    this.paymentForm = this.fb.group({
      percentage: [{ value: "", disabled: true }, Validators.required],
      payment_term_id: ["", Validators.required],
    });
  }
  createDocumentForm() {
    this.documentForm = this.fb.group({
      name: ["", Validators.required],
      document_value: [null],
      document_name: [null],
    });
  }

  onDocumentSubmit() {
    const payload = this.documentForm.value;
    console.log(payload);
    this.slimLoadingBarService.start();
    this.reservationService
      .addDocument(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          swal("Success", "added document successfully", "success");
          this.documentForm.reset();
          this.getReservationsDocuments();
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  getReservationsDocuments() {
    this.slimLoadingBarService.start();
    this.reservationService
      .getReservationDocuments(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.documents = res;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  deleteDocument(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this document!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .deleteReservationDocument(this.reservation_details.id, id)
          .subscribe(
            (res: any) => {
              swal("Success", "Deleted document successfully", "success");
              this.slimLoadingBarService.complete();
              this.getReservationsDocuments();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  onFileChange(event) {
    // residence_image: ['', Validators.required],
    //   residence_name: ['', Validators.required]
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      this.file_name = file.name;
      reader.onload = () => {
        // this.documentForm.get('image').setValue({
        //   filename: file.name,
        //   filetype: file.type,
        //   value: ((reader.result as any) as any).split(',')[1]
        // });
        this.documentForm
          .get("document_value")
          .patchValue((reader.result as any as any).split(",")[1]);
        this.documentForm.get("document_name").patchValue(file.name);
      };
    }
  }

  createContractForm(data?) {
    if (data.contract_type == "rent") {
      this.contractForm = this.fb.group({
        contract_type: [data.contract_type || ""],
        //rent
        rent_value: [data.rent_details.rent_value || ""],
        rent_start_date: [data.rent_details.rent_start_date || ""],
        rent_end_date: [data.rent_details.rent_end_date || ""],
        rent_years_num: [data.rent_details.rent_years_num || ""],
        // sale
        payment_type: [data.payment_type || ""],
        is_overseas: [data.is_overseas],
        installment_years: [data.installment_years || ""],
        // installment_fees: [data.installment_fees || ""],
      });
    } else {
      this.contractForm = this.fb.group({
        contract_type: [data.contract_type || ""],
        //rent
        rent_value: [""],
        rent_start_date: [""],
        rent_end_date: [""],
        rent_years_num: [""],
        // sale
        payment_type: [data.payment_type || ""],
        is_overseas: [data.is_overseas],
        installment_years: [data.installment_years || ""],
        // installment_fees: [data.installment_fees || ""],
      });
    }
    console.log(this.contractForm.value);
  }

  deleteControl(index) {}

  getSharedComission(id) {
    this.reservationService.getSharedComissions(id).subscribe(
      (res: any) => {
        console.log({ res });
        this.sharedAgentsCommissionsView = res;
        res.forEach((element) => {
          this.addInputsForSharedComissions(element);
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  addInputsForSharedComissions(element?) {
    if (element) {
      const group = new FormGroup({
        user_id: new FormControl(element.user_id || null),
        comission_percentage: new FormControl(
          element.comission_percentage || null
        ),
      });
      this.sharedAgentsCommissions.push(group);
    } else {
      const group = new FormGroup({
        user_id: new FormControl(null),
        comission_percentage: new FormControl(null),
      });
      this.sharedAgentsCommissions.push(group);
    }
  }

  saveSharedCommission() {
    console.log(this.sharedAgentsCommissions.value);
    let all_comissions_value = 0;
    const sharedAgentsCommissionsValue = this.sharedAgentsCommissions.value;
    if (sharedAgentsCommissionsValue) {
      sharedAgentsCommissionsValue.forEach((agnet_commision) => {
        all_comissions_value += +agnet_commision.comission_percentage;
      });
    }
    console.log(all_comissions_value);
    if (+all_comissions_value != 100) {
      swal("error", "Total Commission is not equal to 100", "error");
      return;
    } else {
      this.disable_save_shared_comission = true;
      this.slimLoadingBarService.start();
      this.reservationService
        .addShareComission(
          this.reservation_details.id,
          sharedAgentsCommissionsValue
        )
        .subscribe(
          (res: any) => {
            swal("success", "Commissions updated successfully", "success");
            this.disable_save_shared_comission = false;
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.disable_save_shared_comission = false;
            this.slimLoadingBarService.complete();
            this.errorHandlerService.handleErorr(err);
            console.log(err);
          }
        );
    }
  }

  getAllAgents() {
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        this.agents = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  onAgentInChargeSelected(event) {
    const payload = {
      agent_in_charge: this.agent_in_charge,
    };
    this.leadsService
      .changeAgentInCharge(this.reservation_details.id, payload)
      .subscribe(
        (res) => {
          swal("Success", "Agent in charge changed successfully", "success");
          this.getReservation();
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getPaymentTerms() {
    this.userService
      .getPaymentTermsByProject(this.reservation_details.unit.project.id)
      .subscribe(
        (res) => {
          this.methods = res;
        },
        (err) => this.errorHandlerService.handleErorr(err)
      );
  }

  getReservation() {
    this.slimLoadingBarService.start();
    this.reservationService.getSingleReservation(this.reservationId).subscribe(
      (data: any) => {
        this.sharedAgentsCommissions = new FormArray([]);
        console.log("reservation", data.data[0]);
        this.reservation_details = data.data[0];
        this.setResidenceDocumentState();
        this.refreshPartnerCommissionUi();
        this.setPartnerBrokerName();
        if (
          this.reservation_details &&
          this.reservation_details.partner_broker_id &&
          !this.partner_broker_name
        ) {
          this.getPartnerBrokers();
        }
        this.getSharedComission(this.reservation_details.id);
        this.cheque_recieved_date =
          this.reservation_details.cheque_recieved_date;
        this.cancel_reason = this.reservation_details.cancel_reason;
        this.cancel_date = this.reservation_details.cancel_date;
        this.totalChequeSharingAmount =
          this.reservation_details.percentage_value["sharing_percentage"];
        this.totalChequeDeveloperAmount =
          this.reservation_details.percentage_value["developer_percentage"];
        this.getChequesTempaltes();
        // this.deal_type_change();
        this.getAmbassadors();
        this.getBrokers();
        this.getAllAgents();
        this.getReservationsDocuments();
        this.getReservationActivityLogs(this.reservation_details.id);
        this.down_payment =
          this.reservation_details.unit_price *
          (this.reservation_details.percentage / 100);
        this.getPaymentTerms();
        if (this.reservation_details.unit.layout_images) {
          if (this.reservation_details.unit.layout_images.length) {
            this.currentSlide = 0;
          }
        }
        this.createContractForm(this.reservation_details);
        const payload = {
          project_id: this.reservation_details.project_id,
          phase_id: this.reservation_details.phase_id,
          finishing_type_id: this.reservation_details.finishing_type_id,
        };
        this.getPaymentTermsByProjectId(
          this.reservation_details.unit.project_id
        );
        this.edit_lead_data.lead_address =
          this.reservation_details.lead_address;
        this.edit_lead_data.lead_birthday =
          this.reservation_details.lead_birthday;
        this.edit_lead_data.lead_district =
          this.reservation_details.lead_district;
        this.edit_lead_data.lead_national_id =
          this.reservation_details.lead_national_id;
        this.edit_lead_data.lead_nationality =
          this.reservation_details.lead_nationality;
        if (this.reservation_details.lead) {
          this.edit_lead_data.lead_name = this.reservation_details.lead.name;
          this.edit_lead_data.lead_email = this.reservation_details.lead.email;
          this.edit_lead_data.lead_phone = this.reservation_details.lead.phone;
          this.edit_lead_data.lead_phone2 =
            this.reservation_details.lead.phone_2;
          this.edit_lead_data.customer_type =
            this.reservation_details.lead.customer_type;
        }
        this.selling_price_in_modal = this.reservation_details.unit_price;
        this.installmentDays = [];
        this.agent_in_charge = this.reservation_details.agent_in_charge;
        this.reservation_details.broker_id &&
          this.getIncentiveUsers(this.reservation_details.broker_id);

        //   let agentsArr = [];
        //   this.leadsService.getAgents().subscribe(
        //     (data: any) => {
        //       agentsArr = data;
        //     });
        //   for (let i = 0; i <= agentsArr.length; i++) {
        //     if (agentsArr[i].id === 1) {
        //         this.agents.push({ label: this.agents[i].name, value: this.agents[i].id });
        //     }
        // }

        //   this.agents.forEach(
        //     (agent)=> {
        //         this.agents.push({label: agent.name, value: agent.id});
        //         console.log(agent);
        //         this.agent_in_charge = agent.id;
        //     }
        // );

        console.log("sasa", this.agent_in_charge);

        for (let i = 1; i < 29; i++) {
          this.installmentDays.push(i);
        }
        this.down_payment =
          this.reservation_details.unit_price *
          (this.reservation_details.percentage / 100);
        console.log(this.reservation_details);
        console.log(this.installmentMethods);
        this.last_payment_type = this.reservation_details.payment_type;
        this.is_overseas = this.reservation_details.is_overseas;
        this.getPaymentCollection(this.reservation_details.id);
        this.getFines(this.reservation_details.id);
        this.installmentForm.patchValue({
          type: this.reservation_details.installment_years,
          percentage: this.reservation_details.percentage,
        });
        console.log(this.installmentForm.value);
        this.syncDivisionFormWithReservation();

        this.reservation_details.users = this.sortUsers(
          this.reservation_details.users
        );
        this.slots = {
          service_room_slots: this.reservation_details.service_room_slots,
          service_room_with_bathroom_slots:
            this.reservation_details.service_room_with_bathroom_slots,
        };
        this.cheque_book_name = this.reservation_details.unit.serial;
        this.name_on_cheques = "";
        this.reservation_details.sharing_leads.map((lead, i) => {
          if (i == this.reservation_details.sharing_leads.length - 1) {
            this.name_on_cheques += lead.lead_name;
          } else {
            this.name_on_cheques += lead.lead_name + " - ";
          }
        });
        this.selling_date = format(
          parse(
            this.reservation_details.selling_date,
            "dd/MM/yyyy",
            new Date()
          ),
          "yyyy-MM-dd"
        );
        this.delivery_date = this.reservation_details.delivery_date;
        console.log(this.delivery_date);
        this.reservation_details.sharing_leads.forEach((lead) => {
          lead.lead_name = lead.lead_name.trim();
        });
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  isReservationGift() {
    return (
      this.reservation_details &&
      (this.reservation_details.is_gift === true ||
        this.reservation_details.is_gift === 1 ||
        this.reservation_details.is_gift === "1")
    );
  }

  toggleReservationGift(isGift) {
    if (!this.reservation_details || this.isReservationGiftLoading) {
      return;
    }

    this.isReservationGiftLoading = true;
    this.slimLoadingBarService.start();
    this.reservationService
      .toggleReservationGift(this.reservation_details.id, isGift.checked)
      .subscribe(
        (res: any) => {
          if (res && res.data && res.data.id) {
            this.reservation_details = res.data;
          } else {
            this.reservation_details.is_gift = isGift.checked;
          }
          swal("Success", "Reservation gift updated successfully", "success");
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        },
        () => {
          this.isReservationGiftLoading = false;
          this.slimLoadingBarService.complete();
        }
      );
  }

  isShareHolderReservation() {
    return (this.reservation_details && (this.reservation_details.is_shareholder === true));
  }

  toggleShareHolderReservation(isShareholder: any) {
    if (!this.reservation_details || this.isShareHolderReservationLoading) {
      return;
    }

    this.isShareHolderReservationLoading = true;
    this.slimLoadingBarService.start();
    this.reservationService
      .toggleShareHolderReservation(this.reservation_details.id, isShareholder.checked)
      .subscribe(
        (res: any) => {
          if (res && res.data && res.data.id) {
            this.reservation_details = res.data;
          } else {
            this.reservation_details.is_shareholder = isShareholder.checked;
          }
          swal("Success", "Reservation shareholder updated successfully", "success");
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        },
        () => {
          this.isShareHolderReservationLoading = false;
          this.slimLoadingBarService.complete();
        }
      );
  }

  sortUsers(users) {
    const sorted = [];
    ["Property Consultant", "Team Leader"].map((title) => {
      const index = users.findIndex((user) => user.role === title);
      if (index > -1) {
        sorted.push(users[index]);
        users.splice(index, 1);
      }
    });

    sorted.push(...users);
    return sorted;
  }

  createFilesUploadForm() {
    this.filesForm = this.fb.group({
      receipt: [null, Validators.required],
      signed: [null, Validators.required],
      date: [null, Validators.required],
    });

    this.uploadScannedChequeForm = this.fb.group({
      scannedCheque: [null, Validators.required],
    });

    this.filterForm = this.fb.group({
      serial: [""],
      agent: [""],
      lead_name: [""],
    });

    this.uploadExcel = this.fb.group({
      file: [null, Validators.required],
    });
  }

  filterLeadObservable = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    console.log(baseUrl);
    if (keyword) {
      return this.http
        .get(`${baseUrl}users/search?keyword=${keyword}`)
        .map((res: any) => {
          console.log(res.length);
          if (res.length == 0) {
            return Observable.of([]);
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res;
            res.forEach((e) => {
              this.arrSearch.push(e.name);
            });
            console.log(this.arrSearch);
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  valueChanged(event) {
    this.dataFromSearch.forEach((e) => {
      if (e.name == event) this.chosenAgent = e;
    });
  }

  contractSignedByClientModalSubmit(modal) {
    if (!this.contract_signed_by_client_date) {
      swal("Error", "Please select a date", "error");
      return;
    }
    const selectedDate = new Date(this.contract_signed_by_client_date);
    const today = new Date();
    today.setHours(23, 59, 59, 999);

    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 15);
    minDate.setHours(0, 0, 0, 0);

    if (selectedDate > today || selectedDate < minDate) {
      swal("Error", "Contract date must be within the last 15 days up to today.", "error");
      return;
    }

    const payload = {
      date: this.contract_signed_by_client_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .contract_sign_by_client(this.reservation_details.id, payload)
      .subscribe(
        (data) => {
          this.getReservation();
          swal("Woohoo!", "Contract signed by client succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  reservation_form_signedSubmit(modal) {
    const payload = {
      date: this.reservation_form_signed_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .reservation_form_signed(this.reservation_details.id, payload)
      .subscribe(
        (data) => {
          this.getReservation();
          swal("Woohoo!", "Reservation Form signed succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }
  contractApproveModalSubmit(modal) {
    const payload = {
      date: this.contract_approve_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .contract_approve(this.reservation_details.id, payload)
      .subscribe(
        (data) => {
          this.getReservation();
          swal("Woohoo!", "Contract approved succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  contractDileveredModalSubmit(modal) {
    const payload = {
      date: this.contract_dilever_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .contract_delivered(this.reservation_details.id, payload)
      .subscribe(
        (data) => {
          this.getReservation();
          swal("Woohoo!", "Contract delivered succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  adminDecline(reservationId, modal) {
    swal({
      title: "Are you sure?",
      text: "You will decline the reservation!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, decline it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        if (this.reservation_details.authorization.can_refund_reason == 1) {
          modal.open();
          console.log("success");
        } else {
          console.log("err");
          // this.reservationService.adminDecline(reservationId, {}).subscribe(data => {
          //   swal('Woohoo!', 'Declined Successfully!', 'success');
          //   this.getReservation();
          // }, err => this.errorHandlerService.handleErorr(err));
        }
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  swalDelete(res_id) {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this reservation!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService.deleteReservation(res_id).subscribe(
          (data) => {
            this.slimLoadingBarService.complete();
            swal("Deleted!", "Reservation has been deleted.", "success");
            // this.getReservation();
            this.router.navigateByUrl("/pages/reservations");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  accountDecline(reservationId) {
    swal({
      title: "Are you sure?",
      text: "You will decline the reservation!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, decline it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .accountDeclineReservation(reservationId)
          .subscribe(
            (data) => {
              console.log(data);
              this.getReservation();
              swal("Woohoo!", "Declined succesfully!", "success");
            },
            (err) => this.errorHandlerService.handleErorr(err),
            () => this.slimLoadingBarService.complete()
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cheque_recieved_submit(modal) {
    const data = {
      date: this.cheque_recieved_date,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .cheque_recieved(this.reservation_details.id, data)
      .subscribe(
        () => {
          modal.close();
          this.getReservation();
          swal("Woohoo!", "cheque Recieved succesfully!", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  cancel_cheque_recieved(reservation_id) {
    swal({
      title: "Are you sure?",
      text: "cheque Recieved Will be Cancelled!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancel_cheque_recieved(reservation_id)
          .subscribe(
            (data) => {
              this.getReservation();
              swal(
                "Woohoo!",
                "cheque Recieved Cancelled succesfully!",
                "success"
              );
            },
            (err) => console.log(err),
            () => this.slimLoadingBarService.complete()
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  /***
   * start of assign modal
   */

  closeAssignModal() {}

  submitAssignModal(res_id, modal) {
    this.slimLoadingBarService.start();
    if (!this.chosenAgent) {
      swal("You must chose a property consultant", "", "error");
    } else {
      this.reservationService
        .assignToLead(res_id, this.chosenAgent.id)
        .subscribe(
          (data) => {
            console.log(data);
            swal("Woohoo!", "Assigned to user successfully!", "success");
            this.getReservation();
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
    }
  }

  openAssignModal(unit_id) {}

  /***
   * end of assign modal
   */

  /***
   * start of PC Incentive Extra Commission modal
   */

  openPcIncentiveModal() {
    // Initialize/reset modal values
    this.pcIncentiveType = null;
    this.pcIncentiveAmount = null;
  }

  closePcIncentiveModal(modal) {
    // Reset modal values on close
    this.pcIncentiveType = null;
    this.pcIncentiveAmount = null;
    modal.close();
  }

  submitPcIncentiveModal(reservation_id, modal) {
    this.slimLoadingBarService.start();
    this.isPcIncentiveModalLoading = true;

    if (!this.pcIncentiveType || !this.pcIncentiveAmount) {
      swal("Error", "Both fields are required", "error");
      this.isPcIncentiveModalLoading = false;
      this.slimLoadingBarService.complete();
      return;
    }

    const payload = {
      pc_incentive_type: this.pcIncentiveType,
      pc_incentive_amount: this.pcIncentiveAmount,
    };

    this.reservationService
      .pcIncentiveExtraCommission(reservation_id, payload)
      .subscribe(
        (data) => {
          console.log(data);
          swal("Success!", "PC Incentive Extra Commission added successfully!", "success");
          modal.close();
          this.getReservation();
          this.isPcIncentiveModalLoading = false;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.isPcIncentiveModalLoading = false;
          this.slimLoadingBarService.complete();
        }
      );
  }

  /***
   * end of PC Incentive Extra Commission modal
   */

  /**
   * start of edit selling price
   */

  openEditSellingPriceModal(reservation) {}

  closeEditSellingPriceModal(modal) {
    // this.selling_price_in_modal = '';
    this.selling_price_in_modal = this.reservation_details.unit_price;
    modal.close();
  }

  submiteditSellingPriceModal(reservation, modal) {
    // this.percentage = this.price_precentage;
    // this.reason = this.reason;
    // if (!this.percentage) swal("percentage can not be empty", "", "error");
    if (
      this.value_extra_discount > 100 &&
      this.type_extra_discount == "percentage"
    ) {
      swal("percentage can not be greater than 100", "", "error");
      return;
    }
    if (!this.reason) swal("reason can not be empty", "", "error");
    else {
      modal.close();
      const data = {
        type: this.type_extra_discount,
        value: this.value_extra_discount,
        reason: this.reason,
        selling_price: this.selling_price_in_modal,
        discount_on: this.discount_on,
      };
      this.slimLoadingBarService.start();
      this.reservationService.editSellingPrice(reservation.id, data).subscribe(
        (data: any) => {
          swal("Selling price changes successfully", "", "success");
          this.type_extra_discount = "percentage";
          this.value_extra_discount = "";
          this.reason = "";
          this.getReservation();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  /**
   * end of selling price
   */

  /**
   * Start of change selling date modal
   */

  openChangeSellingDateModal(reservation) {}

  closeChangeSellingDateModal() {}

  submitChangeSellingDateModal(reservation, modal) {
    if (!this.selling_date) swal("Selling date can not be empty", "", "error");
    else {
      const data = {
        selling_date: this.selling_date,
      };
      this.slimLoadingBarService.start();
      this.reservationService.changeSellingDate(reservation.id, data).subscribe(
        (data) => {
          modal.close();
          swal("Selling date changed successfully", "", "success");
          this.getReservation();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  /**
   * End of change selling date modal
   */

  /**
   * Start of change selling date modal
   */

  openChangeConfirmationDateModal(reservation) {}

  closeChangeConfirmationDateModal() {}

  submitConfirmationDateModal(reservation, modal) {
    if (!this.confirmation_date)
      swal("Confirmation date can not be empty", "", "error");
    else {
      const data = {
        confirmation_date: this.confirmation_date,
      };
      this.slimLoadingBarService.start();
      this.reservationService
        .changeConfirmationDate(reservation.id, data)
        .subscribe(
          (data) => {
            modal.close();
            swal("Confirmation date changed successfully", "", "success");
            this.getReservation();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  /**
   * End of change selling date modal
   */

  /**
   * Start of Comment Modal
   * */
  openCommentModal(reservation) {}

  submitCommentModal(reservation_id, modal) {
    if (!this.commentReservation)
      swal("Error", "Comment can not be empty", "error");
    else {
      this.slimLoadingBarService.start();
      this.reservationService
        .addReservationComment(reservation_id, this.commentReservation)
        .subscribe(
          (data) => {
            modal.close();
            this.getReservation();
            swal("Woohoo!", "Comment have added succesfully!", "success");
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  closeCommentModal() {}

  openViewCommentModal(reservation) {}

  closeViewCommentModal() {}

  /**
   * End of Comment Modal
   */

  /**
   * Start of Installment Modal
   */

  createInstallmentForm() {
    this.installmentForm = this.fb.group({
      percentage: ["", Validators.required],
      slots: ["0", Validators.required],
      service_room_slots: ["0", Validators.required],
      service_room_with_bathroom_slots: ["0", Validators.required],
      type: ["", Validators.required],
      day: ["5", Validators.required],
      doc_type: ["PDF", Validators.required],
      installment_plan: ["Quarter", Validators.required],
      installment_delay: [""],
    });
  }

  openInstallmentModal(reservation) {}

  closeInstallmentModal() {}

  submitInstallmentModal(reservation, modal) {
    const data = this.installmentForm.value;
    data.r_serial = reservation.id;
    console.log(data);
    /* call back end point here and dismiss loader in success */
    // this.is_installment_modal_loading = true;
    modal.close();
    this.reservationService.installmentPdf(data).subscribe(
      (res: any) => {
        modal.close();
        console.log(res.url);
        window.open(res.url);
        this.getPaymentCollection(this.reservation_details.id);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  /**
   * End of Installment Modal
   */

  /**
   * Start of accountant approve modal
   */

  accountantApproveModalOpen(reservation) {
    this.slip_customer = null;
  }

  accountantApproveModalClose() {}

  accountApprove() {
    swal({
      title: "Are you sure?",
      text: "You will approve this reservation!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      console.log(result);
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .accountantApprove(this.reservation_details.id, {})
          .subscribe(
            (res: any) => {
              this.getReservation();
              this.slimLoadingBarService.complete();
              swal("success", "Accountant approved successfully", "success");
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      }
    });
  }

  // accountApprove(reservation, modal) {
  //   const isValid = this.validatingPayloadForAccountantApproveAndAddFine();
  //   if (!isValid) return;
  //   if (this.slip_type == "2" || this.slip_type == "3") {
  //     if (!this.transaction_number) {
  //       swal("error", "Transaction Number is required", "error");
  //       return;
  //     }
  //   }
  //   let payload: any = {
  //     amount_received:
  //       this.payment_type == "deposit"
  //         ? this.deposit_amount
  //         : this.reservation_details.total_down_payment,
  //     type: this.slip_type,
  //     lead_id: this.slip_customer,
  //     cheque_number: this.cheque_number,
  //     currency_code: this.currency_code,
  //     exchange_rate: this.exchange_rate,
  //     transaction_number: this.transaction_number,
  //   };
  //   console.log(this.slip_type);
  //   payload = {
  //     ...this.getPaylodForAccountantApproveAndAddFine(),
  //     ...payload,
  //   };
  //   if (this.isDateGreaterThanToday(this.collection_date)) {
  //     swal("request date can not be greater than today", "", "error");
  //     return;
  //   }
  //   if (
  //     this.reservation_details.remaining_down_payment &&
  //     this.payment_type != "deposit"
  //   ) {
  //     payload.amount_received = this.reservation_details.remaining_down_payment;
  //   } else if (
  //     !this.reservation_details.remaining_down_payment &&
  //     this.payment_type != "deposit"
  //   ) {
  //     payload.amount_received = this.reservation_details.total_down_payment;
  //   }
  //   console.log(payload);
  //   this.slimLoadingBarService.start();
  //   this.reservationService
  //     .accountantApprove(this.reservation_details.id, payload)
  //     .subscribe(
  //       (res: any) => {
  //         this.getReservation();
  //         this.payment_type = "down_payment";
  //         this.deposit_amount = null;
  //         this.slimLoadingBarService.complete();
  //         modal.close();
  //         swal("success", "Accountant approved successfully", "success");
  //       },
  //       (err) => {
  //         this.slimLoadingBarService.reset();
  //         this.errorHandlerService.handleErorr(err);
  //       }
  //     );
  // }

  changeMarketingStatus(id) {
    swal({
      title: "Are you sure?",
      text: "You will change marketing status!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService.changeMarketingStatus(id).subscribe(
          (res: any) => {
            this.getReservation();
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
      }
    });
  }

  getPaylodForAccountantApproveAndAddFine() {
    let payload: any = {};
    // The selected customer is required to create the cheque book payment
    // that holds a fine paid by cheque.
    if (this.slip_customer) {
      payload.lead_id = this.slip_customer;
    }
    if (
      this.slip_type == 1 ||
      this.slip_type == 4 ||
      this.slip_type == 2 ||
      this.slip_type == 3
    ) {
      payload.store_status = this.store_status;
    }

    if (this.slip_type == 4 || this.slip_type == 2 || this.slip_type == 3) {
      payload.bank_id = this.bank_id;
    }
    if (this.slip_type == 2) {
      payload.transaction_number = this.transaction_number;
      payload.due_date = this.due_date;
      payload.collection_date = this.collection_date;
    } else if (this.slip_type == 4) {
      payload.due_date = this.due_date;
    } else {
      payload.collection_date = this.collection_date;
    }
    if (this.payment_type == "deposit") {
      if (this.deposit_amount > this.reservation_details.total_down_payment) {
        swal(
          "error",
          "deposit amount is bigger than the down payment amount",
          "error"
        );
        return;
      } else if (!this.deposit_amount) {
        swal("error", "you must enter a deposit amount", "error");
        return;
      } else {
        payload.amount_received = this.deposit_amount;
      }
    }
    if (this.slip_type == 5) {
      payload.commission_settlement_user_id =
        this.commission_settlement_user_id;
    }
    if (this.slip_type == 6) {
      payload.share_holder_name = this.share_holder_name;
    }
    if (this.file) {
      payload.file = this.file;
      payload.file_name = this.file_name;
    }
    return payload;
  }

  validatingPayloadForAccountantApproveAndAddFine() {
    if (this.currency_code != "EGP" && !this.exchange_rate) {
      swal(
        "error",
        "Exchange Rate is needed if the currency is not EGP",
        "error"
      );
      return false;
    }
    if (this.slip_type == "5") {
      if (!this.commission_settlement_user_id) {
        swal(
          "Error",
          "Missing data, commission settlement user is a mandatory",
          "error"
        );
        return false;
      }
    }
    if (this.slip_type == "6") {
      if (!this.share_holder_name) {
        swal("Error", "Missing data, share holder is a mandatory", "error");
        return false;
      }
    }
    if (this.slip_type === "1") {
      if (!this.store_status) {
        console.log("1");
        console.log(this.collection_date);
        console.log(this.slip_customer);
        swal("Error", "Missing data, please Select The Bank", "error");
        return false;
      }
    } else if (this.slip_type === "2") {
      if (
        !this.transaction_number ||
        !this.store_status ||
        !this.collection_date ||
        !this.slip_customer ||
        !this.bank_id
      ) {
        swal(
          "Error",
          "Missing data, please fill all the required data",
          "error"
        );
        return false;
      }
    } else if (this.slip_type === "3") {
      if (
        !this.bank_id ||
        !this.store_status ||
        !this.collection_date ||
        !this.slip_customer
      ) {
        swal(
          "Error",
          "Missing data, please fill all the required data",
          "error"
        );
        return false;
      }
    } else if (this.slip_type === "4") {
      if (
        !this.cheque_number ||
        !this.bank_id ||
        !this.due_date ||
        !this.slip_customer
      ) {
        swal(
          "Error",
          "Missing data, please fill all the required data",
          "error"
        );
        return false;
      }
    }
    return true;
  }

  addBankTransferFormData = {
    transfer_by: "",
    document_name: "",
    document_value: null,
  };

  addBankTransferModalOpen(form) {
    form.reset();
    this.addBankTransferFormData = {
      transfer_by: "",
      document_name: "",
      document_value: null,
    };
  }

  onBankTransferFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      this.file_name = file.name;
      reader.onload = () => {
        this.addBankTransferFormData.document_name = file.name;
        this.addBankTransferFormData.document_value = (
          reader.result as any as any
        ).split(",")[1];
      };
    }
  }

  addBankTransfer(modal) {
    if (
      !(
        this.addBankTransferFormData.transfer_by &&
        this.addBankTransferFormData.document_name &&
        this.addBankTransferFormData.document_value
      )
    ) {
      swal("error", "Please fill the form.", "error");
      return;
    }
    this.slimLoadingBarService.start();
    this.reservationService
      .addBankTransfer(
        this.reservation_details.id,
        this.addBankTransferFormData
      )
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          modal.close();
          swal("success", "Bank Transfer Added Successfully.", "success");
        },
        (err) => {
          this.slimLoadingBarService.reset();
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  BanksTransfersFiles = [];

  ViewBankTransferModalOpen() {
    this.BanksTransfersFiles = [];
    this.slimLoadingBarService.start();
    this.reservationService
      .getBankTransfer(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.BanksTransfersFiles = res;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.slimLoadingBarService.reset();
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  // editPrice(last_price) {
  //   this.last_price = last_price;
  //   this.is_edit_mode_account_approve = true;
  // }

  // closeEditPrice(reservation_details) {
  //   console.log(reservation_details);
  //   reservation_details.unit_price = this.last_price;
  //   this.is_edit_mode_account_approve = false;
  // }

  editPriceUsingPercentage(event) {
    // console.log(+this.selling_price_in_modal);
    // if (this.price_precentage > 0) {
    //   this.selling_price_in_modal =
    //     ((+this.reservation_details.unit_price * +this.price_precentage) / 100) - +this.reservation_details.unit_price;
    // } else {
    //   this.selling_price_in_modal = this.reservation_details.unit_price;
    // }
  }

  sellingPriceChange(event) {
    console.log(event);
    switch (event) {
      case "garage":
        this.selling_price_in_modal =
          this.reservation_details.unit_garage_price;
        break;
      case "maintenance":
        this.selling_price_in_modal =
          this.reservation_details.unit_maintenance_price;
        break;
      case "unit":
        this.selling_price_in_modal = this.reservation_details.unit_price;
        break;
      case "service_room":
        this.selling_price_in_modal =
          this.reservation_details.unit_service_room_price;
        break;
      case "service_room_with_bathroom":
        this.selling_price_in_modal =
          this.reservation_details.unit_service_room_with_bathroom_price;
        break;
    }
  }

  changeSettlementStatus(id) {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.value) {
        this.reservationService.changeSettlementStatus(id).subscribe(
          (res: any) => {
            swal("success", res.message, "success");
            this.getReservation();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        );
      }
    });
  }

  checkNumber(event) {
    const arr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    console.log(event.key);
    if (arr.indexOf(+event.key) == -1) event.preventDefault();
  }

  /**
   * End of accountant approve modal
   */

  /***
   * start of first modal
   * */

  handleReceiptFile(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      this.file_name = file.name;
      reader.onload = () => {
        this.filesForm.get("receipt").patchValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any as any).split(",")[1],
        });
      };
    }
  }

  handleSignedFile(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      this.file_name2 = file.name;
      reader.onload = () => {
        this.filesForm.get("signed").patchValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any as any).split(",")[1],
        });
      };
    }
  }

  actionOnOpen(reservationId) {
    console.log(reservationId);
  }

  actionOnClose() {}

  actionOnSubmit(reservationId, modal) {
    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    const formModel = this.filesForm.value;
    console.log(formModel);
    const data: any = {
      id: reservationId,
      date: formModel.date,
    };
    if (formModel.receipt) {
      data.receipt = formModel.receipt.value;
      data.file_name = formModel.receipt.filename;
    }
    if (formModel.signed) {
      data.scan_url = formModel.signed.value;
      data.file_name2 = formModel.signed.filename;
    }
    console.log(data);
    this.reservationService.contractorApproved(data).subscribe(
      (data) => {
        console.log(data);
        this.getReservation();
        this.slimLoadingBarService.complete();
        modal.close();
        swal("Woohoo!", "Contractor Approved!", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  private setResidenceDocumentState(): void {
    var rawResidenceDocumentUrl =
      (this.reservation_details && this.reservation_details.residence_url) ||
      (this.reservation_details &&
        this.reservation_details.lead &&
        this.reservation_details.lead.residence_url) ||
      "";

    if (
      !rawResidenceDocumentUrl ||
      rawResidenceDocumentUrl === "null" ||
      rawResidenceDocumentUrl === "undefined"
    ) {
      this.residenceDocumentUrl = "";
      return;
    }

    this.residenceDocumentUrl = rawResidenceDocumentUrl;
  }

  /***
   * end of first modal
   */

  /**
   * Start of Change Signature Modal
   */

  openChangeSignatureModal(reservation) {}

  closeChangeSignatureModal() {}

  submitChangeSignatureModal(reservation, modal) {
    if (!this.signature_date)
      swal("Signature date can not be empty", "", "error");
    else {
      this.slimLoadingBarService.start();
      this.reservationService
        .changeSignatureDate(reservation.id, this.submitCommentModal)
        .subscribe(
          (data: any) => {
            swal("Signature date Changed successfully", "", "success");
            modal.close();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  /**
   * End of Change Signature Modal
   */

  /**
   * start of re-assign client modal
   */

  reAssignClientModalOpen(reservation) {}

  observableSource = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    const data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}leads?keyword=${keyword}`)
        .map((res: any) => {
          console.log(res.data.length);
          if (res.data.length == 0) {
            const arr = [];
            return arr;
          } else {
            this.leadArrSerach = [];
            this.dataFromSearch = res.data;
            res.data.forEach((e) => {
              this.leadArrSerach.push(e.name);
            });
            return this.leadArrSerach;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  getLeadDetails(): any {
    console.log(this.chosenLead);
    if (!this.chosenLead) {
      swal("Lead name can not be empty!");
    } else {
      if (this.dataFromSearch.length == 0) {
        swal("No Lead with that name.");
      } else {
        let found = false;
        console.log(this.dataFromSearch);
        this.dataFromSearch.forEach((element) => {
          if (element.name == this.chosenLead) {
            this.chosenClient = {
              lead_id: element.id,
              lead_name: element.name,
              lead_address: element.address,
              lead_home_phone: element.phone_2,
              lead_phone: element.phone,
              lead_birthday: element.date_of_birth,
              lead_email: element.email,
              lead_work_address: element.work_address,
              lead_national_id: element.national_num,
              lead_is_residence: element.is_residence,
              // deal_type: element.lead_channel.name,
              deal_type: element.lead_channel
                ? element.lead_channel.name
                : null,
              lead_source: element.lead_source,
              ambassador_id: element.ambassador_id,
              broker_id: element.broker_id,
            };

            if (element.broker_id) {
              this.chosenClient = element.broker_id;
              delete this.chosenClient.ambassador_id;
            }
            if (element.ambassador_id) {
              this.chosenClient = element.ambassador_id;
              delete this.chosenClient.broker_id;
            }
            console.log(this.documentForm.value);
            if (!element.ambassador_id && element.broker_id) {
              this.chosenClient.deal_category = "Individual";
            }

            console.log(element, this.chosenLead);
            this.chosenLeadID = element.id;
            found = true;
            this.chosenLeadName = element.name;
            this.chosenLeadPhone = element.phone;
            this.chosenLeadAddress = element.address;
            this.chosenLeadBirthday = element.date_of_birth;
            // this.chosenLeadCivilRegistery =
            this.chosenLeadIssueDate = element.national_issue_date;
            // this.chosenLeadDistrict = element.
          }
        });
        if (!found) swal("No Lead with that name.");
      }
    }
  }

  searchLeadSelected(event) {
    console.log(event);
  }

  reAssignClientModalClose() {}

  reAssignClientSubmit(reservation, modal) {
    if (!this.chosenLeadID)
      swal(
        "Lead ID can not be empty",
        "click on get info button to get the lead id.",
        "error"
      );
    else if (!this.chosenLeadPhone)
      swal("Client Phone can not be empty", "", "error");
    else if (!this.chosenLeadName)
      swal("Client Name can not be empty", "", "error");
    else if (!this.chosenLeadReason)
      swal("Reason can not be empty", "", "error");
    else if (!this.chosenLeadNationalityID)
      swal("Client Nationality can not be empty", "", "error");
    else if (!this.chosenLeadNationality)
      swal("Client Nationality ID can not be empty", "", "error");
    else if (!this.chosenLeadDistrict)
      swal("Client Lead District can not be empty", "", "error");
    else if (!this.chosenLeadIssueDate)
      swal("Client Issue Date can not be empty", "", "error");
    else if (!this.chosenLeadCivilRegistery)
      swal("Client Civil Registery can not be empty", "", "error");
    else if (!this.chosenLeadBirthday)
      swal("Client Birthday can not be empty", "", "error");
    else if (!this.chosenLeadAddress)
      swal("Client Address can not be empty", "", "error");
    else {
      //call the back end point
      // let data = {
      //   lead_id: this.chosenLeadID,
      //   reservation_id: reservation.id,
      //   reason: this.chosenLeadReason,
      //   ...this.chosenClient
      // };
      // let data = {
      //   lead_id: this.chosenLeadID,
      //   reservation_id: reservation.id,
      //   reason: this.chosenLeadReason,
      //   lead_name: this.chosenLeadName,
      //   lead_phone: this.chosenLeadPhone,
      //   lead_national_id: this.chosenLeadNationalityID,
      //   lead_nationality: this.chosenLeadNationality,
      //   lead_district: this.chosenLeadDistrict,
      //   lead_issue_date: this.chosenLeadIssueDate,
      //   lead_civil_registry: this.chosenLeadCivilRegistery,
      //   lead_birthday: this.chosenLeadBirthday,
      //   lead_address: this.chosenLeadAddress,
      // };
      this.slimLoadingBarService.start();
      this.reservationService.reAssignToLead(this.chosenClient).subscribe(
        (res) => {
          this.getReservation();
          swal("Re-assign reservation to client successfully", "", "success");
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  /**
   * end of re-assign client modal
   */

  /***
   * start of Refund Admin Decline Modal
   */

  refundAdminDeclineModalSubmit(modal) {
    const payload = {
      refund_reason: this.refundReason,
    };
    if (!this.refundReason)
      swal("You have to provide a refund reason", "", "error");
    else {
      this.slimLoadingBarService.start();
      this.reservationService
        .adminDecline(this.reservation_details.id, JSON.stringify(payload))
        .subscribe(
          (data) => {
            swal("Woohoo!", "Declined Successfully!", "success");
            this.getReservation();
            modal.close();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  /***
   * End of Refund Admin Decline Modal
   */

  /***
   * Start of division modal
   */

  createDivisionForm() {
    // this.divisionForm = this.fb.group({
    //   deal_type: ["", Validators.required],
    //   deal_source: [""],
    //   broker_id: [''],
    //   ambassador_id: ['']
    // });
  }

  deal_type_change() {
    // this.divisionForm.get("deal_type").valueChanges.subscribe((val) => {
    //   console.log(val);
    //   if (val == "Direct") {
    //     if (this.divisionForm.get("broker_id"))
    //       this.divisionForm.removeControl("broker_id");
    //     this.divisionForm.addControl(
    //       "deal_category",
    //       new FormControl("", Validators.required)
    //     );
    //     this.division_type_change();
    //     console.log(this.divisionForm.value);
    //   } else if (val == "In-Direct") {
    //     console.log(val);
    //     if (this.divisionForm.get("deal_category"))
    //       this.divisionForm.removeControl("deal_category");
    //     if (this.divisionForm.get("ambassador_id"))
    //       this.divisionForm.removeControl("ambassador_id");
    //     this.divisionForm.addControl(
    //       "broker_id",
    //       new FormControl("", Validators.required)
    //     );
    //   }
    // });
  }

  getAmbassadors() {
    let params = {
      paginate: false,
    };
    this.slimLoadingBarService.start();
    this.userService.getAmbasdors(params).subscribe(
      (data: any) => {
        this.ambassadors = data;
        console.log(this.ambassadors);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getBrokers() {
    this.slimLoadingBarService.start();
    this.userService.getBorkers({ is_select_form: true }).subscribe(
      (data: any) => {
        this.brokers = data;
        console.log(this.brokers);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getPartnerBrokers() {
    this.slimLoadingBarService.start();
    this.userService
      .getBorkers({ is_select_form: true, is_partner: true })
      .subscribe(
        (data: any) => {
          this.partner_brokers = data || [];
          this.setPartnerBrokerName();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  getDefaultPartnerBrokerId() {
    if (!this.reservation_details) {
      return null;
    }
    if (this.reservation_details.partner_broker_id) {
      return this.reservation_details.partner_broker_id;
    }
    if (
      this.reservation_details.project &&
      this.reservation_details.project.partner_broker_id
    ) {
      return this.reservation_details.project.partner_broker_id;
    }
    return null;
  }

  setPartnerBrokerName() {
    const partnerBrokerId = this.getDefaultPartnerBrokerId();
    if (!partnerBrokerId) {
      this.partner_broker_name = "";
      return;
    }

    if (
      this.reservation_details.partner_broker &&
      this.reservation_details.partner_broker.name
    ) {
      this.partner_broker_name = this.reservation_details.partner_broker.name;
      return;
    }

    const selectedPartnerBroker = this.partner_brokers.find(
      (broker) => broker.id == partnerBrokerId
    );
    this.partner_broker_name = selectedPartnerBroker
      ? selectedPartnerBroker.name
      : "";
  }

  assignBrokerPartnerModalOpen() {
    this.partner_broker_id = this.getDefaultPartnerBrokerId();
    this.getPartnerBrokers();
  }

  changeEventModalSubmit(modal, event_id) {
    const payload = {
      event_id,
    };

    this.slimLoadingBarService.start();
    this.reservationService
      .changeEvent(this.reservation_details.id, payload)
      .subscribe(
        (res) => {
          swal("Event changes successfully", "", "success");
          modal.close();
          this.getReservation();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  division_type_change() {
    // console.log("division_type_change changed");
    // this.divisionForm.get("deal_category").valueChanges.subscribe((val) => {
    //   if (val == "Ambassador") {
    //     console.log("Ambassador");
    //     this.divisionForm.addControl(
    //       "ambassador_id",
    //       new FormControl("", Validators.required)
    //     );
    //   } else if (val == "Individual") {
    //     console.log("Individual");
    //     // if (this.divisionForm.removeControl('ambassador_id'))
    //     //   this.divisionForm.removeControl('ambassador_id');
    //   }
    // });
  }

  divisionModalSubmit(modal) {
    const payload = this.divisionForm;
    const normalizedDealSource = (this.divisionForm.deal_source || "")
      .toString()
      .toLowerCase();
    // console.log(payload);
    payload.reservation_id = this.reservation_details.id;
    if (this.divisionForm.deal_type == "Direct") {
      this.divisionForm.broker_id = "";
      this.divisionForm.broker_incentive_id = "";
      this.divisionForm.partner_broker_id = "";
    } else {
      if (normalizedDealSource == "broker") {
        this.divisionForm.ambassador_id = "";
        const selectedBroker = this.brokers && this.brokers.find(b => b.id == this.divisionForm.broker_id);
        if (selectedBroker && selectedBroker.is_partner) {
          this.divisionForm.partner_broker_id = this.divisionForm.broker_id;
        } else {
          this.divisionForm.partner_broker_id = "";
        }
      } else if (normalizedDealSource == "ambassador") {
        this.divisionForm.broker_id = "";
        this.divisionForm.broker_incentive_id = "";
        this.divisionForm.partner_broker_id = "";
      }
    }
    this.slimLoadingBarService.start();
    this.reservationService.changeDealType(payload).subscribe(
      (res) => {
        swal("Division changes successfully", "", "success");
        modal.close();
        this.getReservation();
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );

    // if (this.divisionForm)
    //   swal("Division can not be empty", "", "error");
    // else {
    //   this.slimLoadingBarService.start();
    //   this.reservationService.changeDealType(payload).subscribe(
    //     (res) => {
    //       swal("Division changes successfully", "", "success");
    //       modal.close();
    //       this.getReservation();
    //     },
    //     (err) => this.errorHandlerService.handleErorr(err),
    //     () => this.slimLoadingBarService.complete()
    //   );
    // }
  }

  divisionModalClose() {}

  divisionModalOpen() {
    this.syncDivisionFormWithReservation();
  }

  syncDivisionFormWithReservation() {
    if (!this.reservation_details) {
      return;
    }

    this.divisionForm.deal_type = this.reservation_details.deal_type;
    this.divisionForm.deal_category = this.reservation_details.deal_category;

    const normalizedLeadSource = (this.reservation_details.lead_source || "")
      .toString()
      .toLowerCase();
    const reservationAmbassadorId =
      this.reservation_details.ambassador_id ||
      (this.reservation_details.ambassador &&
        this.reservation_details.ambassador.id) ||
      "";
    const reservationBrokerId =
      this.reservation_details.broker_id ||
      (this.reservation_details.broker && this.reservation_details.broker.id) ||
      "";

    if (normalizedLeadSource == "ambassador" || reservationAmbassadorId) {
      this.divisionForm.deal_type = "In-Direct";
      this.divisionForm.deal_category = "";
      this.divisionForm.deal_source = "Ambassador";
      this.divisionForm.ambassador_id = reservationAmbassadorId;
      this.divisionForm.broker_id = "";
      this.divisionForm.broker_incentive_id = "";
      this.divisionForm.partner_broker_id = "";
    } else if (normalizedLeadSource == "broker" || reservationBrokerId) {
      this.divisionForm.deal_type = "In-Direct";
      this.divisionForm.deal_category = "";
      this.divisionForm.deal_source = "Broker";
      this.divisionForm.broker_id = reservationBrokerId;
      this.divisionForm.broker_incentive_id =
        this.reservation_details.broker_incentive_id || "";
      this.divisionForm.partner_broker_id =
        this.reservation_details.partner_broker_id || "";
      this.divisionForm.ambassador_id = "";
    } else {
      this.divisionForm.deal_source = this.reservation_details.lead_source || "";
      this.divisionForm.ambassador_id = "";
      this.divisionForm.broker_id = "";
      this.divisionForm.broker_incentive_id = "";
      this.divisionForm.partner_broker_id = "";
    }

    this.channelChange(false);
  }

  /***
   * End of division modal
   */

  /**
   * start of comission modal
   */

  commissionModalSubmit(modal) {
    if (!this.commission_date)
      swal("Commission date can not be empty", "", "error");
    else {
      const payload = {
        commission_date: this.commission_date,
        commission_to: this.commission_to,
      };
      this.slimLoadingBarService.start();
      this.reservationService
        .makeCommission(this.reservation_details.id, payload)
        .subscribe(
          (res) => {
            swal("Comission submited successfully", "", "success");
            modal.close();
            this.getReservation();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  calcReservationSalesCommission() {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, do it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .calcReservationSalesCommission(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "success",
                (res && res.message) || "Sales commission calculated successfully",
                "success"
              );
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            },
            () => this.slimLoadingBarService.complete()
          );
      } else {
        swal("Cancelled", "", "error");
      }
    })
  }

  calcReservationIndirectCommission() {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, do it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .calcReservationIndirectCommission(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "success",
                (res && res.message) || "Indirect commission calculated successfully",
                "success"
              );
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            },
            () => this.slimLoadingBarService.complete()
          );
      } else {
        swal("Cancelled", "", "error");
      }
    })
  }

  /**
   * end of comission modal
   */

  /**
   * start of Claim modal
   */

  claimModalSubmit(modal) {
    if (!this.claim_form.claim_date)
      swal("Claim date can not be empty", "", "error");
    else {
      const payload = {
        claim_date: this.claim_form.claim_date,
        claim_from: this.claim_form.claim_from,
      };
      this.slimLoadingBarService.start();
      this.reservationService
        .makeClaim(this.reservation_details.id, payload)
        .subscribe(
          (res) => {
            swal("Claim submited successfully", "", "success");
            modal.close();
            this.getReservation();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  /**
   * end of Claim modal
   */

  garageSlotsModalOpen() {}

  garageSlotsModalClose() {}

  garageSlotsSubmit(modal) {
    if (!this.garageSlots)
      swal("Number of Garage slots must be entered", "", "error");
    else {
      const payload = {
        slots: this.garageSlots,
        rf_id: this.reservation_details.id,
      };
      this.slimLoadingBarService.start();
      this.reservationService.changeGarageSlots(payload).subscribe(
        (res: any) => {
          modal.close();
          swal("Chanegd number of Garage slots successfully", "", "success");
          this.getReservation();
        },
        (err) => console.log(err)
      );
    }
  }

  grantCommissionSubmit(value, modal) {
    const payload = {
      grant_commission: value,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .changeGrantCommission(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          swal("Chanegd Grant Commission successfully", "", "success");
          this.getReservation();
        },
        (err) => console.log(err)
      );
  }

  SlotsModalOpen() {}

  SlotsModalClose() {}

  SlotsSubmit(modal) {
    if (!this.slots) swal("Number of slots must be entered", "", "error");
    else {
      const payload = {
        service_room_slots: this.slots.service_room_slots,
        service_room_with_bathroom_slots:
          this.slots.service_room_with_bathroom_slots,
        rf_id: this.reservation_details.id,
      };
      this.slimLoadingBarService.start();
      this.reservationService.changeSlots(payload).subscribe(
        (res: any) => {
          modal.close();
          swal("Chanegd number of slots successfully", "", "success");
          this.getReservation();
        },
        (err) => console.log(err)
      );
    }
  }

  addContractLogModalSubmit(modal, valid) {
    if (!valid) swal("Please fill the form", "", "error");
    else {
      this.addContractLog.reservation_id = this.reservationId;
      this.slimLoadingBarService.start();
      this.reservationService.addContractLog(this.addContractLog).subscribe(
        (res: any) => {
          modal.close();
          swal("Log Added", "", "success");
          this.getReservation();
        },
        (err) => console.log(err)
      );
    }
  }

  paymentTypeModalOpen() {}

  paymentTypeModalClose() {}

  paymentTypeSubmit(modal) {
    const payload = {
      payment_type: this.last_payment_type,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .changePaymentType(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }
  paymentTermModalOpen() {}

  paymentTermModalClose() {}
  paymentTermSubmit(modal) {
    const payload = this.paymentForm.value;
    console.log(payload);
    this.slimLoadingBarService.start();
    this.reservationService
      .changePaymentTerm(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  changePaymentMethod(event) {
    const paymentTermId = this.paymentForm.value.payment_term_id;
    console.log(this.methods, this.paymentForm.value.payment_term_id);
    const percentage = this.methods.find((meth) => {
      if (meth.id == paymentTermId) return meth;
    });
    console.log(percentage);
    this.percentage = percentage.downpayment_percentage;
  }

  overseasModalModalOpen() {}

  overseasModalModalClose() {}

  overseasModalSubmit(modal) {
    const payload = {
      is_overseas: this.is_overseas,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .changeOverseas(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  editLeadModalModalOpen(leadId) {
    this.customer_id = leadId;
    this.reservation_details.sharing_leads.forEach((lead) => {
      if (lead.lead_id == this.customer_id) {
        this.single_customer = lead;

        this.edit_lead_data.lead_id = this.single_customer.lead_id;
        this.edit_lead_data.lead_name = this.single_customer.lead_name;
        this.edit_lead_data.lead_phone = this.single_customer.lead_phone;
        this.edit_lead_data.lead_email = this.single_customer.lead_email;
        this.edit_lead_data.lead_national_id =
          this.single_customer.lead_national_id;
        this.edit_lead_data.lead_nationality =
          this.single_customer.lead_nationality;
        this.edit_lead_data.lead_other_phone =
          this.single_customer.lead_other_phone;
        this.edit_lead_data.lead_birthday = this.single_customer.lead_birthday;
        this.edit_lead_data.lead_address = this.single_customer.lead_address;
        this.edit_lead_data.lead_district = this.single_customer.lead_district;
        this.edit_lead_data.sharing_percentage =
          this.single_customer.sharing_percentage;
        this.edit_lead_data.customer_type = this.single_customer.customer_type;
      }
    });
  }

  deleteLead(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this customer!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .deleteLead(this.reservation_details.id, id)
          .subscribe(
            (res: any) => {
              swal("Success", "Customer deleted successfully", "success");
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  editLeadModalModalClose() {}

  editLeadModalSubmit(leadId?, modal?) {
    const payload = this.current_edit_lead_data;
    if (this.edit_lead_data['lead_phone_error']) {
      swal("Invalid Primary Phone", this.edit_lead_data['lead_phone_error'] || "Please enter a valid phone number", "error");
      return;
    }
    if (this.edit_lead_data['lead_other_phone_error']) {
      swal("Invalid Third Phone", this.edit_lead_data['lead_other_phone_error'] || "Please enter a valid phone number", "error");
      return;
    }
    this.slimLoadingBarService.start();
    this.reservationService
      .editLeadInReservation(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          // Close modal if it exists (for old modal implementation)
          if (modal && modal.close) {
            modal.close();
          }
          // Show success message
          swal("Success", "Customer information updated successfully", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  cancelReservationReasonModalSubmit(modal) {
    const payload = {
      cancel_reason: this.cancel_reason,
      cancel_date: this.cancel_date,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .cancelReservationReasonDate(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  onCloseTeamTreeModalModalClose() {}

  // Collect from CDB methods
  onOpenCollectFromCDB(payment, modal) {
    this.activeCollectFromCDBPayment = payment;
    this.collectFromCDB = {
      collection_date: "",
      cdb_id: null,
    };
    modal.open();
  }

  onOpenCollectFromCDBModal() {
    // Reset submitting flag
    this.collectFromCDBSubmitting = false;
    // Load available CDB payments
    this.loadAvailableCDBPayments();
  }

  loadAvailableCDBPayments() {
    // Filter payments based on the specified conditions
    this.availableCDBPayments = this.payment_collections.filter((payment) => {
      return (
        payment.type == 5 &&
        payment.is_reconcile_cdb == 0 &&
        (payment.status == "fully-collected" ||
          (payment.partially_method == 4 && payment.final_cheque_received == 1))
      );
    });
  }

  submitCollectFromCDB(modal) {
    if (this.collectFromCDBSubmitting) return;

    if (!this.collectFromCDB.collection_date) {
      swal("Error", "Please select a collection date", "error");
      return;
    }
    if (!this.collectFromCDB.cdb_id) {
      swal("Error", "Please select a CDB payment", "error");
      return;
    }

    const payload = {
      id: this.activeCollectFromCDBPayment.id,
      cdb_id: this.collectFromCDB.cdb_id,
      collection_date: this.collectFromCDB.collection_date,
    };

    this.collectFromCDBSubmitting = true;
    this.slimLoadingBarService.start();
    if (this.is_collect_fine) {
      this.reservationService
        .collectFineFromCDB(this.reservationId, payload)
        .subscribe(
          (res: any) => {
            swal("Success", "Collected from CDB successfully", "success");
            modal.close();
            this.getPaymentCollection(this.reservationId);
            this.getFines(this.reservation_details.id);
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        )
        .add(() => {
          this.collectFromCDBSubmitting = false;
          this.slimLoadingBarService.complete();
        });
    } else {
      this.reservationService
        .collectFromCDB(this.reservationId, payload)
        .subscribe(
          (res: any) => {
            swal("Success", "Collected from CDB successfully", "success");
            modal.close();
            this.getPaymentCollection(this.reservationId);
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        )
        .add(() => {
          this.collectFromCDBSubmitting = false;
          this.slimLoadingBarService.complete();
        });
    }
  }

  reactivateReservation() {
    swal({
      title: "Are you sure?",
      text: "Re-activate this reservation!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .reactivateReservation(this.reservation_details.id)
          .subscribe(
            (data) => {
              this.getReservation();
              swal("Woohoo!", "Re-activated succesfully!", "success");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.errorHandlerService.handleErorr(err);
            },
            () => this.slimLoadingBarService.complete()
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  /** Start of Change Contract Type Modal */

  get contractTypeFromContractForm() {
    return this.contractForm.get("contract_type").value;
  }

  contractTypeModalOpen() {}

  contractTypeModalClose() {}

  contractTypeModalSubmit(modal) {
    const payload = this.contractForm.value;
    this.slimLoadingBarService.start();
    this.reservationService
      .changeContractType(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          this.slimLoadingBarService.complete();
          modal.close();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.reset();
        }
      );
  }
  /** End of Change Contract Type Modal  */

  changePaymentMethodToContract(event) {
    // this.methods.forEach(element => {
    //   if (element.plan_name == event) {
    //     this.reservation_fees = element.downpayment_percentage;
    //   }
    // });
  }

  getPaymentTermsByProjectId(project_id) {
    console.log(project_id);
    this.userService.getProjectPaymentTerms(project_id).subscribe(
      (res) => {
        const arr: any = res;
        this.payment_plans = arr;
        console.log(this.payment_plans);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  openUnitLAyoutGallery(images, index) {
    this._staticMasterPlanImages = [];
    for (let i = 0; i < images.length; i++) {
      const src = images[i].url;
      const caption = " ";
      const thumb = images[i].url;
      const album = {
        src: src,
        caption: caption,
        thumb: thumb,
      };
      this._staticMasterPlanImages.push(album);
    }
    console.log(this._staticMasterPlanImages);
    this._lightbox.open(this._staticMasterPlanImages, index);
  }

  prevSlide() {
    if (this.currentSlide == 0) {
      this.currentSlide =
        this.reservation_details.unit.layout_images.length - 1;
      return;
    } else if (this.currentSlide == 1) {
      this.currentSlide = 0;
      return;
    } else {
      this.currentSlide--;
      return;
    }
  }

  nextSlide() {
    if (
      this.currentSlide ==
      this.reservation_details.unit.layout_images.length - 1
    ) {
      this.currentSlide = 0;
      return;
    } else {
      this.currentSlide++;
      return;
    }
  }

  /*
   * Payment Collections Starts
   */
  pageChange(event) {
    console.log(event);
  }

  deleteSharedCommissionFromAgent(index) {
    this.sharedAgentsCommissions.removeAt(index);
  }

  overSeaContractSentModalOpen() {}

  overSeaContractSentModalubmit(modal) {
    if (!this.oversea_contract_sent_date) {
      swal("error", "enter oversea contract send date", "error");
    }
    const payload = {
      send_date: this.oversea_contract_sent_date,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Sent Oversea Contract!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .sentOverSeaContract(this.reservation_details.id, payload)
          .subscribe(
            (data) => {
              this.getReservation();
              swal(
                "Woohoo!",
                "Oversea contract date set successfully!",
                "success"
              );
              modal.close();
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  saveContractDate(contractEl: NgModel, modal) {
    if (!contractEl.value) {
      swal("error", "Enter Contract Date", "error");
    }
    const payload = {
      contract_date: contractEl.value,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Sent Contract Date!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .changeContractDate(this.reservation_details.id, payload)
          .subscribe(
            (data) => {
              this.getReservation();
              swal("Woohoo!", "Contract Date set successfully!", "success");
              modal.close();
              contractEl.control.patchValue("");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  saveDeliveryDate(deliveryEl: NgModel, modal) {
    if (!deliveryEl.value) {
      swal("error", "Enter Delivery Date", "error");
    }
    const payload = {
      delivery_date: this.delivery_date,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Sent Delivery Date!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .changeDeliveryDate(this.reservation_details.id, payload)
          .subscribe(
            (data) => {
              this.getReservation();
              swal("Woohoo!", "Delivery Date set successfully!", "success");
              modal.close();
              deliveryEl.control.patchValue("");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  getPaymentCollection(reservation_id) {
    this.reservationService
      .getPaymentCollectionForAReservation(reservation_id)
      .subscribe(
        (res: any) => {
          this.payment_collections = res.map((c) => {
            if (c.receipts) {
              c.collect_types = Array.from(
                new Set(c.receipts.map((r) => r.type_string))
              ).join(", ");
            }
            c.db_date = c.date;
            return c;
          });
          this.intialTotalChequeDeveloperAmount = 0;
          this.intialTotalChequeSharingAmount = 0;
          this.payment_collections.forEach((c) => {
            if (
              this.reason_exclude_from_calculation.includes(c.request_reason) &&
              (c.status === "recall-request" ||
                c.status === "pending-recall" ||
                c.status === "recall")
            ) {
              return;
            }
            if (
              c.status === "recall-cancelled" ||
              c.status === "pending-cancelled" ||
              c.status === "cancelled" ||
              c.status === "bounced-cancelled"
            ) {
              return;
            }
            if (c.installment_type === "Fine") return;
            if (
              c.sharing_type_text == "Sharing" &&
              c.type != "4" &&
              c.installment_type != "Extra" &&
              c.installment_type != "CDB"
            ) {
              this.intialTotalChequeSharingAmount += +c.amount;
            }
            if (
              c.sharing_type_text == "Developer" &&
              c.type != "4" &&
              c.installment_type != "Extra" &&
              c.installment_type != "CDB"
            ) {
              this.intialTotalChequeDeveloperAmount += +c.amount;
            }
          });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getFines(reservation_id) {
    this.reservationService
      .getReservationFines({
        filter_reservation: reservation_id,
        paginate: false,
      })
      .subscribe(
        (res: any) => {
          // remove data from fines
          this.fines = res.map((c) => {
            if (c.receipts) {
              c.collect_types = Array.from(
                new Set(c.receipts.map((r) => r.type_string))
              ).join(", ");
            }
            return c;
          });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  // Fines paid by cheque are created as a cheque book payment, so they are
  // view only here and every action on them must be done from the Cheque Book.
  isViewOnlyFine(fine) {
    if (!fine) return false;

    const chequeBookPayment = fine.new_cheque;

    return (
      fine.status === "under-collection" ||
      fine.status === "under_collection" ||
      fine.manage_from_cheque_book === true ||
      fine.manage_from_cheque_book === 1 ||
      fine.is_cheque_book_payment === true ||
      fine.is_cheque_book_payment === 1 ||
      (+fine.partially_method === 4 &&
        chequeBookPayment &&
        chequeBookPayment.installment_type === "Fine" &&
        +chequeBookPayment.final_cheque_received === 1)
    );
  }

  getFineDisplayStatus(fine) {
    if (!fine) return "";

    const status =
      this.isViewOnlyFine(fine) && fine.new_cheque && fine.new_cheque.status
        ? fine.new_cheque.status
        : fine.status;

    return this.formatFineStatus(status);
  }

  formatFineStatus(status) {
    if (!status) return "";
    const labels: any = {
      "under-collection": "Under Collection",
      under_collection: "Under Collection",
    };
    return labels[status] || status;
  }

  acceptPaymentCollection(collection_id, index) {
    swal({
      title: "Are you sure?",
      text: "You will collect!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, collect it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        const payload = {
          status: "collected",
        };
        this.slimLoadingBarService.start();
        this.reservationService
          .updatePaymentCollectionStatus(collection_id, payload)
          .subscribe(
            (res: any) => {
              this.slimLoadingBarService.complete();
              // this.getPaymentCollections();
              this.payment_collections[index].status = "collected";
              swal("success", "Accepted Payment Successfully", "success");
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  rejectPaymentCollection(collection_id, index) {
    swal({
      title: "Are you sure?",
      text: "You will reject!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        const payload = {
          status: "bounced",
        };
        this.slimLoadingBarService.start();
        this.reservationService
          .updatePaymentCollectionStatus(collection_id, payload)
          .subscribe(
            (res: any) => {
              this.slimLoadingBarService.complete();
              // this.getPaymentCollections();
              this.payment_collections[index].status = "bounced";
              swal("success", "Bounced Payment Successfully", "success");
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  onPaymentTypeChange() {
    if (this.payment_type == "down_payment") {
      this.deposit_amount = null;
    } else if (this.payment_type == "deposit") {
    }
  }
  /*
   * Payment Collections Ends
   */
  accountApproveSaving = false;

  completeDownPaymentModalOpen(reservation_details) {}
  completeDownPaymentModalClose() {}
  completeDownPaymentSubmit(reservation_details, completeDownPaymentModal) {
    // if ()
    if (!this.complete_down_payment_amount) {
      swal("error", "you must enter an amount first", "error");
      return;
    }
    if (this.slip_type == "5") {
      if (!this.commission_settlement_user_id) {
        swal(
          "Error",
          "Missing data, commission settlement user is a mandatory",
          "error"
        );
        return;
      }
    }
    if (this.slip_type == "6") {
      if (!this.share_holder_name) {
        swal("Error", "Missing data, share holder is a mandatory", "error");
        return;
      }
    }
    let payload: any = {
      amount_received:
        this.payment_type == "deposit"
          ? this.deposit_amount
          : this.complete_down_payment_amount,
      // slip_number: this.slip_number,
      type: this.slip_type,
      lead_id: this.slip_customer,
    };
    if (this.slip_type == "4") {
      payload.cheque_number = this.cheque_number;
      payload.due_date = this.due_date;
      delete payload.date;
    } else {
      payload.date = this.collection_date;
    }
    if (
      this.slip_type == "2" ||
      this.slip_type == "3" ||
      this.slip_type == "4"
    ) {
      payload.bank_id = this.bank_id;
    }
    if (
      this.slip_type == "1" ||
      this.slip_type == "2" ||
      this.slip_type == "3"
    ) {
      payload.store_status = this.store_status;
    }
    if (
      this.slip_type == "1" ||
      this.slip_type == "2" ||
      this.slip_type == "3"
    ) {
      payload.transaction_number = this.transaction_number;
    }
    if (this.slip_type == 5) {
      payload.commission_settlement_user_id =
        this.commission_settlement_user_id;
    }
    if (this.slip_type == 6) {
      payload.share_holder_name = this.share_holder_name;
    }
    if (
      this.collection_date &&
      this.isDateGreaterThanToday(this.collection_date)
    ) {
      swal("collection date can not be greater than today", "", "error");
      return;
    }
    if (this.slip_type == "2" || this.slip_type == "3") {
      if (!this.transaction_number) {
        swal("error", "Transaction Number is required", "error");
        return;
      }
    }
    this.slimLoadingBarService.start();
    this.accountApproveSaving = true;
    this.reservationService
      .completeDownPayment(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.complete_down_payment_amount = null;
          this.slimLoadingBarService.complete();
          swal("success", "", "success");
          completeDownPaymentModal.close();
          this.getReservation();
        },
        (err) => {
          this.slimLoadingBarService.reset();
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.accountApproveSaving = false;
      });
  }

  printPaymentsPdf() {
    this.slimLoadingBarService.start();
    this.projectsService
      .printPaymentsPdf(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.projectsService.printHtml(res.url);
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.slimLoadingBarService.reset();
          console.log(err);
        }
      );
  }
  printChequeModalSubmit() {
    if (!this.selectedChequeTemplateId) {
      swal("warning", "Please select cheque template");
      return;
    }

    if (!this.selectedChequePrintIds || this.selectedChequePrintIds.length === 0) {
      swal("warning", "There is no selected Cheques");
      return;
    }

    const payload = {
      ids: this.selectedChequePrintIds,
      cheque_template_id: this.selectedChequeTemplateId,
    };
    this.slimLoadingBarService.start();
    this.reservationService.printChequesV2(this.reservationId, payload).subscribe(
      (res: any) => {
        const windowPrt = window.open(res.url, "", "");
        if (windowPrt) {
          windowPrt.focus();
        }
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  printReciptModalSubmit(id) {
    this.slimLoadingBarService.start();
    this.projectsService.printRecipt(id).subscribe(
      (res: any) => {
        this.projectsService.printHtml(res);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getChequesTempaltes() {
    this.projectsService.getBanks().subscribe(
      (res: any) => {
        this.banks = res;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  cancelSendOverseasContract() {
    swal({
      title: "Are you sure?",
      text: "You will cancel send overseas contract!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelSendOverseasContract(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled send overseas contract successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancelContractReview() {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract review!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelContractReview(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract review successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancelContractSignedByClient() {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract signed by client!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelContractSignedByClient(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract signed by client successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancelContractApprove() {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract approve!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelContractApprove(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract approve successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancelContractDelivered() {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract delivered!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelContractDelivered(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract delivered successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  downloadReservation() {
    this.slimLoadingBarService.start();
    this.reservationService
      .downloadReservation(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          window.open(res.url);
        },
        (err) => {
          this.slimLoadingBarService.reset();
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  downloadFile(url) {
    window.open(url, "_blank");
  }

  exportFinalPaymentPlan() {
    this.reservationService
      .exportFinalPaymentPlan(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.downloadFile(res);
        },
        (err) => {}
      );
  }

  importFinalPaymentPlan() {
    this.reservationService
      .importFinalPaymentPlan(
        this.reservation_details.id,
        this.finalPaymentPlanFile
      )
      .subscribe(
        (res) =>
          swal("Success", "Payment plan uploaded successfully", "success"),
        (err) => this.errorHandlerService.handleErorr(err)
      );
  }

  onImportPlanChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      reader.onload = () => {
        this.finalPaymentPlanFile = {
          file_name: file.name,
          file: (<string>reader.result).split(",")[1],
        };
        this.importFinalPaymentPlan();
      };
    }
  }

  cancelCommission() {
    swal({
      title: "Are you sure?",
      text: "You will cancel comissions!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelComissions(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal("Success", "Cancelled comissions successfully", "success");
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancelExtraDiscount() {
    swal({
      title: "Are you sure?",
      text: "You will cancel Extra Discount!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelExtraDiscount(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled Extra Discount successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  printFinalPaymentPlan() {
    this.slimLoadingBarService.start();
    this.reservationService
      .printFinalPaymentPlan(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          window.open(res.url);
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  deleteFinalPaymentCollection() {
    swal({
      title: "Are you sure?",
      text: "You will delete the Final Payment Plan Collection!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .deleteFinalPaymentPlanCollection(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              this.slimLoadingBarService.complete();
              swal(
                "Success",
                "Deleted Final Payment Plan Collection",
                "success"
              );
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  checkPhoneValid(event: any) {
    const pattren = /[0-9\+]/;
    console.log(event.keyCode);
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattren.test(inputChar)) {
      event.preventDefault();
    }
  }

  customerSource = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    const data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}leads?keyword=${keyword}&without_freezed=${true}`)
        .map((res: any) => {
          if (res.data.length == 0) {
            const arr = [];
            return arr;
          } else {
            this.arrSearch = [];
            this.customersData = res.data;
            res.data.forEach((e) => {
              this.arrSearch.push(`${e.name} / ${e.id}`);
            });
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };
  getCustomerDetails(reservation) {
    console.log("chooosen", this.customersData);

    if (!this.chosenCustomer) {
      swal("Lead name can not be empty!");
    } else {
      if (this.customersData.length == 0) {
        swal("No Lead with that name.");
      } else {
        let found = false;
        this.customersData.forEach((element) => {
          const leadId = this.chosenCustomer.replace(/\s/g, "").split("/")[1];
          if (element.id == leadId) {
            this.addCustomerForm.lead_id = element.id;
            found = true;

            this.addCustomerForm.lead_name = element.name;
            this.addCustomerForm.lead_phone = element.phone;
            this.addCustomerForm.lead_email = element.email;
            this.addCustomerForm.lead_national_id = element.national_num;
            this.addCustomerForm.lead_nationality = element.national_num;
            this.addCustomerForm.lead_other_phone = element.phone_2;
            this.addCustomerForm.lead_birthday = element.date_of_birth;
            this.addCustomerForm.lead_address = element.address;
            this.addCustomerForm.lead_district = element.location;
            this.addCustomerForm.phone_without_code = element.phone_without_code;
            this.addCustomerForm.code = element.code;
            this.addCustomerForm.phone_3_without_code = element.phone_3_without_code;
            this.addCustomerForm.code_3 = element.code_3;
            this.addCustomerForm.phone_2_without_code = element.phone_2_without_code;
            this.addCustomerForm.code_2 = element.code_2;
            this.addCustomerForm.sharing_percentage =
              element.sharing_percentage;
            this.addCustomerForm.customer_type = null;
          }
        });
        if (!found) swal("No Lead with that name.");
      }
    }
  }

  openAddCustomerDialog(): void {
    const dialogRef = this.dialog.open(AddCustomerDialogComponent, {
      width: '60vw',
      height: '85vh',
      data: {
        reservation_id: this.reservation_details.id,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getReservation()
      }
    });
  }

  submitAddCustomer(formData: any) {
    // Validation
    if (formData.phone_error) {
      swal("Invalid Primary Phone", formData.phone_error || "Please enter a valid phone number", "error");
      return;
    }
    if (formData.other_phone_error) {
      swal("Invalid Third Phone", formData.other_phone_error || "Please enter a valid phone number", "error");
      return;
    }
    if (!formData.lead_id) {
      swal("Lead ID can not be empty", "Click on get info button to get the lead.", "error");
      return;
    }
    if (!formData.lead_name) {
      swal("Client Name can not be empty", "", "error");
      return;
    }
    if (!formData.lead_phone) {
      swal("Client Phone can not be empty", "", "error");
      return;
    }

    // Call the backend endpoint
    this.slimLoadingBarService.start();
    this.reservationService
      .addLead(this.reservation_details.id, formData)
      .subscribe(
        (res) => {
          this.getReservation();
          swal("Customer added successfully", "", "success");
          this.chosenCustomer = "";
          // Reset the form data
          this.setNull(this.addCustomerForm);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        },
        () => this.slimLoadingBarService.complete()
      );
  }

  // Legacy methods for backward compatibility
  addCustomerModalOpen(reservation) {
    this.openAddCustomerDialog();
  }

  addCustomerModalSubmit(reservation, modal) {
    // This method is now handled by the dialog
  }

  addCustomerModalClose(modal) {
    // This method is now handled by the dialog
  }

  setNull(obj) {
    this.setAll(obj, null);
  }
  setAll(obj, val) {
    Object.keys(obj).forEach(function (index) {
      obj[index] = val;
    });
  }

  ownerSource = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    const data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}leads?keyword=${keyword}&without_freezed=${true}`)
        .pipe(
          map((res: any) => {
            if (res.data.length == 0) {
              const arr = [];
              return arr;
            } else {
              this.ownerArrSearch = [];
              this.ownersData = res.data;
              res.data.forEach((e) => {
                this.ownerArrSearch.push(`${e.name} / ${e.id}`);
              });
              return this.ownerArrSearch;
            }
          })
        );
    } else {
      return of([]);
    }
  };

  getOwnerCustomerDetails() {
    console.log("chooosen", this.ownersData);

    if (!this.chosenOwner) {
      swal("Lead name can not be empty!");
    } else {
      if (this.ownersData.length == 0) {
        swal("No Lead with that name.");
      } else {
        let found = false;
        this.ownersData.forEach((element) => {
          const leadId = this.chosenOwner.replace(/\s/g, "").split("/")[1];
          if (element.id == leadId) {
            console.log(element);
            this.addOwnerForm.lead_id = element.id;
            found = true;
            this.addOwnerForm = {
              lead_id: element.id,
              lead_name: element.name,
              lead_phone: element.phone,
              lead_home_phone: element.phone_2,
              lead_other_phone: element.phone_3,
              lead_email: element.email,
              lead_address: element.address,
              lead_national_id: element.national_num,
              lead_nationality: element.nationality,
              lead_district: element.location,
              lead_birthday: element.date_of_birth,
              lead_issue_date: element.national_issue_date,
              lead_marital_status: element.marital_status,
              lead_job_title: element.job_title,
              lead_workplace: element.workplace,
              lead_work_address: element.work_address,
              lead_fax_number: element.fax_num,
              is_overseas: element.is_overseas,
              ownership_transfer_amount:
                this.reservation_details.unit.project.ownership_transfer_amount,
            };
          }
        });
        if (!found) swal("No Lead with that name.");
      }
    }
  }

  addOwnershipExec(modal) {
    if (!this.addOwnerForm.lead_id)
      swal(
        "Lead ID can not be empty",
        "Click on get info button to get the lead.",
        "error"
      );
    else if (!this.addOwnerForm.lead_phone)
      swal("Client Name can not be empty", "", "error");
    else if (!this.addOwnerForm.lead_name)
      swal("Client Phone can not be empty", "", "error");
    else {
      console.log(this.addOwnerForm);
      //call the back end point
      this.slimLoadingBarService.start();
      this.reservationService
        .addOwnerShip(this.reservation_details.id, {
          ...this.addOwnerForm,
          reservation_id: this.reservation_details.id,
        })
        .subscribe(
          (res) => {
            this.getReservation();
            swal(
              "Ownership transfer request added successfully",
              "",
              "success"
            );
            this.chosenOwner = "";

            //Set all object key to null after submission
            this.setNull(this.addOwnerForm);
            this.getOwnershipTransfersRequests(this.reservationId);
            modal.close();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          },
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  getOwnershipTransfers(reservation_id) {
    this.slimLoadingBarService.start();
    this.reservationService.getOwnershipTransfers(reservation_id).subscribe(
      (res) => {
        this.ownershipTransfers = res;
        console.log(this.ownershipTransfers);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getOwnershipTransfersRequests(reservation_id) {
    this.slimLoadingBarService.start();
    this.reservationService
      .getOwnershipTransfersRequests(reservation_id)
      .subscribe(
        (res) => {
          this.ownershipTransfersRequests = res;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.slimLoadingBarService.reset();
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  goToLead(lead) {
    this.router.navigate(["/pages/leads"], {
      queryParams: {
        lead_id: lead.id,
      },
    });
  }

  reactivateOwnerTransferRequest(owner) {
    if (this.approveOwnerTransferRequestIsLoading) return;
    swal({
      title: "Are you sure?",
      text: "You will reactivate this ownership transfer request!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reactivate it!",
      cancelButtonText: "No.",
    }).then((result) => {
      if (result.value) {
        this.approveOwnerTransferRequestIsLoading = true;
        this.slimLoadingBarService.start();
        this.reservationService
          .reactivateOwnerTransferRequest(owner.id, {})
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Ownership transfer request reactivated successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
              this.getOwnershipTransfersRequests(this.reservationId);
              this.approveOwnerTransferRequestIsLoading = false;
            },
            (err) => {
              this.errorHandlerService.handleErorr(err);
              this.slimLoadingBarService.reset();
              this.approveOwnerTransferRequestIsLoading = false;
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  approvePaymentOwnerTransferRequest(owner) {
    if (this.approveOwnerTransferRequestIsLoading) return;
    this.disabledApprovePaymentOwnerTransferRequestIsLoading = true;
    swal({
      title: "Are you sure?",
      text: "You will approve payment this ownership transfer request!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve payment it!",
      cancelButtonText: "No.",
    }).then((result) => {
      if (result.value) {
        this.approveOwnerTransferRequestIsLoading = true;
        this.slimLoadingBarService.start();
        this.reservationService
          .approvePaymentOwnerTransferRequest(owner.id, {})
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Ownership transfer request payment approved successfully",
                "success"
              ).then(() => {
                this.disabledApprovePaymentOwnerTransferRequestIsLoading =
                  false;
              });
              this.slimLoadingBarService.complete();
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
              this.getOwnershipTransfersRequests(this.reservationId);
              this.approveOwnerTransferRequestIsLoading = false;
            },
            (err) => {
              this.errorHandlerService.handleErorr(err);
              this.slimLoadingBarService.reset();
              this.approveOwnerTransferRequestIsLoading = false;
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  approveCustomerOwnerTransferRequest(owner) {
    if (this.approveOwnerTransferRequestIsLoading) return;
    swal({
      title: "Are you sure?",
      text: "You will approve customer this ownership transfer request!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve customer it!",
      cancelButtonText: "No.",
    }).then((result) => {
      if (result.value) {
        this.approveOwnerTransferRequestIsLoading = true;
        this.slimLoadingBarService.start();
        this.reservationService
          .approveCustomerOwnerTransferRequest(owner.id, {})
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Ownership transfer request customer approved successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
              this.getOwnershipTransfersRequests(this.reservationId);
              this.approveOwnerTransferRequestIsLoading = false;
            },
            (err) => {
              this.errorHandlerService.handleErorr(err);
              this.slimLoadingBarService.reset();
              this.approveOwnerTransferRequestIsLoading = false;
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  deleteOwnershipTransferRequest(owner) {
    if (this.disabledOwnerTransferRequestIsLoading) return;
    swal({
      title: "Are you sure?",
      text: "You will delete this transfer request!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No. keep it!",
    }).then((result) => {
      if (result.value) {
        this.disabledOwnerTransferRequestIsLoading = true;
        this.slimLoadingBarService.start();
        this.reservationService
          .deleteOwnershipTransferRequest(this.reservation_details.id, owner.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Ownership transfer request deleted successfully!",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
              this.getOwnershipTransfersRequests(this.reservationId);
              this.disabledOwnerTransferRequestIsLoading = false;
            },
            (err) => {
              this.errorHandlerService.handleErorr(err);
              this.slimLoadingBarService.reset();
              this.disabledOwnerTransferRequestIsLoading = false;
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  rejectOwnershipTransferRequest(owner) {
    if (this.disabledOwnerTransferRequestIsLoading) return;
    swal({
      title: "Are you sure?",
      text: "You will reject this transfer request!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject it!",
      cancelButtonText: "No. keep it!",
    }).then((result) => {
      if (result.value) {
        this.disabledOwnerTransferRequestIsLoading = true;
        this.slimLoadingBarService.start();
        this.reservationService
          .rejectOwnershipTransferRequest(this.reservation_details.id, owner.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Ownership transfer request rejected successfully!",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
              this.getOwnershipTransfersRequests(this.reservationId);
              this.disabledOwnerTransferRequestIsLoading = false;
            },
            (err) => {
              this.errorHandlerService.handleErorr(err);
              this.slimLoadingBarService.reset();
              this.disabledOwnerTransferRequestIsLoading = false;
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  openContractReviewModal(ownership_id, modal) {
    this.ownership_id = ownership_id;
    modal.open();
  }

  contractReviewSubmit(modal) {
    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    const formModel = this.filesForm.value;
    console.log(formModel);
    const data: any = {
      id: this.ownership_id,
      date: formModel.date,
    };
    if (formModel.receipt) {
      data.receipt = formModel.receipt.value;
      data.file_name = formModel.receipt.filename;
    }
    if (formModel.signed) {
      data.scan_url = formModel.signed.value;
      data.file_name2 = formModel.signed.filename;
    }
    console.log(data);
    this.reservationService
      .OwnershipContractReview(this.ownership_id, data)
      .subscribe(
        (data) => {
          console.log(data);
          this.getOwnershipTransfersRequests(this.reservationId);
          this.getReservation();
          this.getOwnershipTransfers(this.reservationId);
          this.slimLoadingBarService.complete();
          modal.close();
          swal("Woohoo!", "Contractor Approved!", "success");
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  ownerShipCancelContractReview(ownership_id) {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract review!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .ownerShipCancelContractReview(ownership_id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract review successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getOwnershipTransfersRequests(this.reservationId);
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  openOwnershipContractSignedByClientModal(ownership_id, modal) {
    this.ownership_id = ownership_id;
    modal.open();
  }

  ownershipContractSignedByClientModalSubmit(modal) {
    if (!this.contract_signed_by_client_date) {
      swal("Error", "Please select a date", "error");
      return;
    }
    const selectedDate = new Date(this.contract_signed_by_client_date);
    const today = new Date();
    today.setHours(23, 59, 59, 999);

    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 15);
    minDate.setHours(0, 0, 0, 0);

    if (selectedDate > today || selectedDate < minDate) {
      swal("Error", "Contract date must be within the last 15 days up to today.", "error");
      return;
    }

    const payload = {
      date: this.contract_signed_by_client_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .ownerContractSignedByClient(this.ownership_id, payload)
      .subscribe(
        (data) => {
          this.getOwnershipTransfersRequests(this.reservationId);
          this.getReservation();
          this.getOwnershipTransfers(this.reservationId);
          swal("Woohoo!", "Contract signed by client succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  openOwnershipReservationFormSignedModal(ownership_id, modal) {
    this.ownership_id = ownership_id;
    modal.open();
  }

  ownershipReservationFormSignedSubmit(modal) {
    const payload = {
      date: this.reservation_form_signed_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .ownershipReservationFormSignedSubmit(this.ownership_id, payload)
      .subscribe(
        (data) => {
          this.getOwnershipTransfersRequests(this.reservationId);
          this.getReservation();
          this.getOwnershipTransfers(this.reservationId);
          swal("Woohoo!", "Reservation Form signed succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  ownershipCancelContractSignedByClient(ownership_id) {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract signed by client!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .ownershipCancelContractSignedByClient(ownership_id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract signed by client successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getOwnershipTransfersRequests(this.reservationId);
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  openOwnershipContractApproveModal(ownership_id, modal) {
    this.ownership_id = ownership_id;
    modal.open();
  }

  ownershipContractApproveModalSubmit(modal) {
    const payload = {
      date: this.contract_approve_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .ownershipContractApprove(this.ownership_id, payload)
      .subscribe(
        (data) => {
          this.getOwnershipTransfersRequests(this.reservationId);
          this.getReservation();
          this.getOwnershipTransfers(this.reservationId);
          swal("Woohoo!", "Contract approved succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  ownershipCancelContractApprove(ownership_id) {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract approve!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .ownershipCancelContractApprove(ownership_id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract approve successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getOwnershipTransfersRequests(this.reservationId);
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  openContractDileveredModal(ownership_id, modal) {
    this.ownership_id = ownership_id;
    modal.open();
  }

  ownershipContractDileveredModalSubmit(modal) {
    const payload = {
      date: this.contract_dilever_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .ownershipContractDilevered(this.ownership_id, payload)
      .subscribe(
        (data) => {
          this.getOwnershipTransfersRequests(this.reservationId);
          this.getReservation();
          this.getOwnershipTransfers(this.reservationId);
          swal("Woohoo!", "Contract delivered succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  ownershipCancelContractDelivered(ownership_id) {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract delivered!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .ownershipCancelContractDelivered(ownership_id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract delivered successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getOwnershipTransfersRequests(this.reservationId);
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  openOwnershipSendByCourierModal(ownership_id, modal) {
    this.ownership_id = ownership_id;
    modal.open();
  }

  ownershipSendCourierDate(el: NgModel, modal) {
    if (!el.value) {
      swal("error", "Enter Send Courier Date", "error");
    }
    const payload = {
      date: el.value,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Send By Courier Date!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .ownershipSendCourierDate(this.ownership_id, payload)
          .subscribe(
            (data) => {
              this.getOwnershipTransfersRequests(this.reservationId);
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
              swal("Woohoo!", "Send By Courier set successfully!", "success");
              modal.close();
              el.control.patchValue("");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  openOwnershipReceviedFromCourierModal(ownership_id, modal) {
    this.ownership_id = ownership_id;
    modal.open();
  }

  ownershipReceviedFromCourier(el: NgModel, modal) {
    if (!el.value) {
      swal("error", "Enter Recevied From Courier Date", "error");
    }
    const payload = {
      date: el.value,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Recevied From Courier Date!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .ownershipReceviedFromCourier(this.ownership_id, payload)
          .subscribe(
            (data) => {
              this.getOwnershipTransfersRequests(this.reservationId);
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
              swal(
                "Woohoo!",
                "Recevied From Courier set successfully!",
                "success"
              );
              modal.close();
              el.control.patchValue("");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  ownershipPrintPaymentPlan(owner_id: any) {
    this.slimLoadingBarService.start();
    this.reservationService.ownershipPrintPaymentPlan(owner_id).subscribe(
      (data) => {
        swal("Woohoo!", "successfully!", "success");
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  openOwnershipActionChequeRecievedModal(ownership_id, modal) {
    this.ownership_id = ownership_id;
    modal.open();
  }

  ownershipActionChequeRecieved(modal) {
    const data = {
      date: this.cheque_recieved_date,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .ownershipActionChequeRecieved(this.ownership_id, data)
      .subscribe(
        () => {
          modal.close();
          this.getOwnershipTransfersRequests(this.reservationId);
          this.getReservation();
          this.getOwnershipTransfers(this.reservationId);
          swal("Woohoo!", "cheque Recieved succesfully!", "success");
        },
        (err) => {
          if (err) {
            this.errorHandlerService.handleErorr(err);
          }
        },
        () => this.slimLoadingBarService.complete()
      );
  }

  openCancelChequeRecievedModal(ownership_id, modal) {
    swal({
      title: "Are you sure?",
      text: "cheque Recieved Will be Cancelled!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .ownershipCancelChequeRecieved(ownership_id)
          .subscribe(
            (data) => {
              this.getOwnershipTransfersRequests(this.reservationId);
              this.getReservation();
              this.getOwnershipTransfers(this.reservationId);
              swal(
                "Woohoo!",
                "cheque Recieved Cancelled succesfully!",
                "success"
              );
            },
            (err) => console.log(err),
            () => this.slimLoadingBarService.complete()
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }


  // ====== cheques book ======

  enablePaymentCollectionEdit(enable_or_disable: boolean): void {
    this.slimLoadingBarService.start();
    this.enable_edit_payment_collections = enable_or_disable;
    this.payment_collections = this.payment_collections.map((payment) => {
      if (
        payment.status === "fully-collected" &&
        !payment.final_cheque_received &&
        (payment.partially_method == "2" || payment.partially_method == "3")
      ) {
        return {
          ...payment,
          can_edit: enable_or_disable,
          can_edit_location: enable_or_disable,
        };
      }
      if (
        payment.final_cheque_received ||
        payment.delivered_to_customer ||
        payment.status === "fully-collected" ||
        (payment.send_to_treasury &&
          payment.is_treasury_approve &&
          payment.partially_method === "4")
      ) {
        return {
          ...payment,
          can_edit: false,
          can_edit_location: false,
        };
      } else {
        return {
          ...payment,
          can_edit: enable_or_disable,
          can_edit_location: enable_or_disable,
        };
      }
    });
    console.log(this.payment_collections);
    if (enable_or_disable) {
      this.onChequeAmountChanged();
    } else {
      this.getPaymentCollection(this.reservationId);
    }
    this.slimLoadingBarService.complete();
  }

  // reminder
  oOpenEnableReminder(id, modal, type?) {
    if (id) this.current_active_cheque = id;
    if (type) this.enableRemiderType = type;
    else this.enableRemiderType = null;
    modal.open();
  }

  oOpenDisableReminder(id, modal, type?) {
    if (id) this.current_active_cheque = id;
    if (type) this.disableReminderType = type;
    else this.disableReminderType = null;
    modal.open();
  }

  enableSelectedReminder(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.oOpenEnableReminder(null, modal, "multiple");
    }
  }

  disableSelectedReminder(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.oOpenDisableReminder(null, modal, "multiple");
    }
  }

  printReciptCheque(payment) {
    print_template(printReceiptPdf, payment, this.reservation_details);
  }

  // collect
  onOpenCollectCheque(payment, modal, type?, new_payment_after_cancel?) {
    if (payment && payment.id) this.current_active_cheque = payment.id;
    if (type) this.chequeCollectType = type;
    else this.chequeCollectType = null;
    console.log(this.chequeCollectType);
    if (payment) this.active_cheque_book_row = payment;
    console.log(this.active_cheque_book_row);
    this.collection_date = this.active_cheque_book_row.collection_date;
    this.collect_type = "fully-collected";
    this.partially_method = this.active_cheque_book_row.partially_method;
    this.store_status = this.active_cheque_book_row.store_status;
    this.transaction_number = this.active_cheque_book_row.transaction_number;
    this.bank_id = this.active_cheque_book_row.bank_id;
    this.chequeCollectCustomer = this.active_cheque_book_row.lead_id;
    this.partially_data = this.active_cheque_book_row.cheque_number;
    this.cheque_amount = this.active_cheque_book_row.amount;
    this.requireValidCollectLocation();
    console.log(modal);
    modal.open();
    new_payment_after_cancel &&
      (this.active_cheque_book_row.new_payment_after_cancel =
        new_payment_after_cancel);
    console.log(this.collect_type);
  }

  collectSelectedCheque(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.collect_type = "fully-collected";
      this.onOpenCollectCheque(null, modal, "multiple");
    }
  }

  onFileSelect(event) {
    let reader = new FileReader();
    this.file_name = null;
    this.file = null;
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.file_name = file.name;
        this.file = (reader.result as any).split(",")[1];
      };
    }
  }

  vendorObservableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}search_vendor_code/${keyword}`)
        .pipe(
          map((res: any) => {
            console.log(res.data.length);
            if (res.data.length == 0) {
              let arr = [];
              return arr;
            } else {
              this.vendorArrSearch = [];
              this.vendors = [];
              this.vendors = res.data.vendors;

              res.data.vendors.forEach((v) => {
                this.vendorArrSearch.push(`${v.vendor_name}`);
              });
              return this.vendorArrSearch;
            }
          })
        );
    } else {
      return of([]);
    }
  };

  onVendorSelected(vendor) {
    this.vendor_code = this.vendors.filter((v) => v.vendor_name == vendor)[0].vendor_code;
    this.vendor_name = vendor;
  }

  shareholderObservableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}search_shareholder_code/${keyword}`)
        .pipe(
          map((res: any) => {
            console.log(res.data.length);
            if (res.data.length == 0) {
              let arr = [];
              return arr;
            } else {
              this.shareholderArrSearch = [];
              this.shareholders = [];
              this.shareholders = res.data.shareholders;

              res.data.shareholders.forEach((v) => {
                this.shareholderArrSearch.push(`${v.shareholder_name}`);
              });
              return this.shareholderArrSearch;
            }
          })
        );
    } else {
      return of([]);
    }
  };

  onShareholderSelected(shareholder, paymentRow?) {
    const selectedShareholder = this.shareholders.filter(
      (v) => v.shareholder_name == shareholder
    )[0];
    this.shareholder_name = shareholder;
    this.share_holder_name = shareholder;

    if (!selectedShareholder) {
      if (paymentRow) {
        paymentRow.shareholder_code = null;
        paymentRow.shareholder_name = null;
        paymentRow.share_holder_name = null;
      } else {
        this.shareholder_code = null;
      }
      return;
    }

    if (paymentRow) {
      paymentRow.shareholder_code = selectedShareholder.shareholder_code;
      paymentRow.shareholder_name = selectedShareholder.shareholder_name;
      paymentRow.share_holder_name = selectedShareholder.shareholder_name;
    } else {
      this.shareholder_code = selectedShareholder.shareholder_code;
    }
  }

  // collect fine
  onOpenCollectChequeFine(id, modal, type?) {
    if (id) this.current_active_cheque_fine = id;
    if (type) this.chequeCollectTypeFine = type;
    else this.chequeCollectTypeFine = null;
    console.log(this.chequeCollectTypeFine);
    modal.open();
  }

  collectSelectedChequeFine(modal) {
    const selectedFines = this.fines.filter((list) => list.checked == true);
    if (selectedFines.length == 0) {
      swal("warning", "There is no selected Fines");
    } else {
      this.collect_type = "fully-collected";
      this.onOpenCollectChequeFine(null, modal, "multiple");
    }
  }

  collectFinesModalSubmitting = false;
  submitCollectChequeFine(modal) {
    this.disable_collect_action = true;
    if (this.collectFinesModalSubmitting) return;
    let payload;
    if (this.chequeCollectTypeFine == "multiple") {
      const selectedFines = this.fines.filter((list) => list.checked == true);
      payload = {
        ids: selectedFines.map((cheque) => cheque.id),
        status: this.collect_type_fines,
        lead_id: this.chequeCollectCustomerFines,
        partially_method: this.partially_method_fines,
        collection_date: this.collection_date_fines,
        currency_code: this.currency_code,
      };
    } else {
      payload = {
        ids: [this.current_active_cheque_fine],
        status: this.collect_type_fines,
        lead_id: this.chequeCollectCustomerFines,
        partially_method: this.partially_method_fines,
        collection_date: this.collection_date_fines,
        currency_code: this.currency_code,
      };
      if (this.collect_type_fines == "partially-collected") {
        payload.is_partially_collect = true;

        payload.amount_received = this.cheque_amount_fines;
        if (payload.partially_method == "3") {
          payload.partially_data = this.partially_data_fines;
        }
      }
    }
    this.collectFinesModalSubmitting = true;
    this.slimLoadingBarService.start();
    this.reservationService
      .collectChequeFine(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          this.disable_collect_action = false;
          swal("Woohoo!", "Collected!", "success");
          modal.close();
          this.collect_type_fines = null;
          this.current_active_cheque_fine = null;
          this.cheque_amount_fines = null;
          this.partially_method_fines = null;
          this.partially_data_fines = null;
          this.collection_date_fines = "";
          this.chequeCollectCustomerFines = "";
          this.getReservation();
          this.getFines(this.reservation_details.id);
          this.getPaymentCollection(this.reservation_details.id);
          this.onCheckAllToggleFines(false);
        },
        (err) => {
          this.disable_collect_action = false;
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.collectFinesModalSubmitting = false;
      });
  }

  cdb_form = {
    amount: 0,
    date: "",
  };

  // Add CDB Form
  openaddCDB() {
    this.cdb_form = {
      amount: 0,
      date: "",
    };
  }

  submitaddCDB(modal) {
    this.slimLoadingBarService.start();
    this.reservationService
      .addCDB(this.reservationId, this.cdb_form)
      .subscribe(
        (res: any) => {
          swal("Woohoo!", "Collected!", "success");
          modal.close();
          this.getPaymentCollection(this.reservationId);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.slimLoadingBarService.complete();
      });
  }
  // reject
  onOpenRejectCheque(id, modal, type = "single", location_bounce?) {
    if (id) this.current_active_cheque = id;
    if (type) this.chequeRejectType = type;
    else this.chequeRejectType = null;
    this.store_status = this.store_banks.find(
      (a) => a.name == "Treasury Safe"
    ).id;
    console.log(this.chequeRejectType);
    modal.open();
  }

  // reject
  onOpenRejectChequeFine(id, modal, type?) {
    if (id) this.current_active_cheque_fine = id;
    if (type) this.chequeRejectTypeFine = type;
    else this.chequeRejectTypeFine = null;
    console.log(this.chequeRejectTypeFine);
    modal.open();
  }

  rejectSelectedCheque(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.collect_type = "fully-collected";
      this.onOpenRejectCheque(null, modal, "multiple");
    }
  }

  onCheckAllToggle(event) {
    this.check_all = event;
    this.payment_collections.forEach((e) => {
      if (this.check_all) {
        e.checked = true;
      } else {
        e.checked = false;
      }
    });
  }

  onCheckAllToggleFines(event) {
    this.check_all = event;
    this.fines.forEach((e) => {
      if (this.check_all) {
        e.checked = true;
      } else {
        e.checked = false;
      }
    });
  }

  shouldApplyListEditsToPayment(payment, payment_index, index) {
    return (
      payment_index > index && payment.status === "under-collection"
    );
  }

  onBankBlur(event, index) {
    this.payment_collections.forEach((payment, payment_index) => {
      if (this.ListEdits_inputs) {
        if (
          !this.shouldApplyListEditsToPayment(payment, payment_index, index) ||
          payment.final_cheque_received
        )
          return;
        this.payment_collections[payment_index].bank_id =
          this.payment_collections[index].bank_id;
      } else if (this.DeveloperEdits_inputs && this.SharingEdits_inputs) {
        if (
          payment.status === "cancelled" ||
          payment.status === "fully-collected" ||
          payment.final_cheque_received
        )
          return;
        if (payment_index > index) {
          this.payment_collections[payment_index].bank_id =
            this.payment_collections[index].bank_id;
        }
      } else if (this.DeveloperEdits_inputs) {
        if (payment.sharing_type_text === "Developer") {
          if (
            payment.status === "cancelled" ||
            payment.status === "fully-collected" ||
            payment.final_cheque_received
          )
            return;
          if (payment_index > index) {
            this.payment_collections[payment_index].bank_id =
              this.payment_collections[index].bank_id;
          }
        }
      } else if (this.SharingEdits_inputs) {
        if (payment.sharing_type_text === "Sharing") {
          if (
            payment.status === "cancelled" ||
            payment.status === "fully-collected" ||
            payment.final_cheque_received
          )
            return;
          if (payment_index > index) {
            this.payment_collections[payment_index].bank_id =
              this.payment_collections[index].bank_id;
          }
        }
      }
    });
  }
  onStoreBankBlur(event, index) {
    this.payment_collections.forEach((payment, payment_index) => {
      if (this.ListEdits_inputs) {
        if (!this.shouldApplyListEditsToPayment(payment, payment_index, index))
          return;
        this.payment_collections[payment_index].store_status =
          this.payment_collections[index].store_status;
      } else if (this.DeveloperEdits_inputs && this.SharingEdits_inputs) {
        if (payment.status === "cancelled") return;
        if (payment_index > index) {
          this.payment_collections[payment_index].store_status =
            this.payment_collections[index].store_status;
        }
      } else if (this.DeveloperEdits_inputs) {
        if (payment.sharing_type_text === "Developer") {
          if (payment.status === "cancelled") return;
          if (payment_index > index) {
            this.payment_collections[payment_index].store_status =
              this.payment_collections[index].store_status;
          }
        }
      } else if (this.SharingEdits_inputs) {
        if (payment.sharing_type_text === "Sharing") {
          if (payment.status === "cancelled") return;
          if (payment_index > index) {
            this.payment_collections[payment_index].store_status =
              this.payment_collections[index].store_status;
          }
        }
      }
    });
  }
  onPartiallyMethodBlur(event, index) {
    this.payment_collections.forEach((payment, payment_index) => {
      if (payment.status === "cancelled") return;
      if (payment_index > index) {
        this.payment_collections[payment_index].partially_method =
          this.payment_collections[index].partially_method;
      }
    });
  }

  onChequeNumberBlur(event, index, cheque_number_value) {
    if (typeof this.payment_collections[index].cheque_number == "number") {
      this.payment_collections.forEach((payment, payment_index) => {
        if (this.ListEdits_inputs) {
          if (
            !this.shouldApplyListEditsToPayment(payment, payment_index, index) ||
            payment.final_cheque_received
          )
            return;
          this.payment_collections[payment_index].cheque_number =
            cheque_number_value + 1;
          cheque_number_value =
            this.payment_collections[payment_index].cheque_number;
        } else if (this.DeveloperEdits_inputs) {
          if (payment.sharing_type_text === "Developer") {
            if (
              payment.status === "cancelled" ||
              payment.status === "fully-collected" ||
              payment.final_cheque_received
            )
              return;
            if (payment_index > index) {
              this.payment_collections[payment_index].cheque_number =
                cheque_number_value + 1;
              cheque_number_value =
                this.payment_collections[payment_index].cheque_number;
            }
          } else {
            return payment;
          }
        } else if (this.SharingEdits_inputs) {
          if (payment.sharing_type_text === "Sharing") {
            if (
              payment.status === "cancelled" ||
              payment.status === "fully-collected" ||
              payment.final_cheque_received
            )
              return;
            if (payment_index > index) {
              this.payment_collections[payment_index].cheque_number =
                cheque_number_value + 1;
              cheque_number_value =
                this.payment_collections[payment_index].cheque_number;
            }
          } else {
            return payment;
          }
        }
      });
    }
  }
  onOpenUploadScannedCheque(id, modal) {
    this.current_active_cheque = id;
    modal.open();
  }

  onOpenCheque(cheque, modal) {
    this.current_active_full_cheque = cheque;
    modal.open();
  }

  savePaymnetcollection() {
    this.disableSavePaymentCollection = true;
    this.slimLoadingBarService.start();
    this.projectsService
      .updateChequeBook(this.reservation_details.id, this.payment_collections)
      .subscribe(
        (res: any) => {
          this.disableSavePaymentCollection = false;
          this.enablePaymentCollectionEdit(false);
          this.getReservation();
          swal("Success", "", "success");
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.disableSavePaymentCollection = false;
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  allowedIsBulk(payment) {
    if (payment.is_bulk == 1) {
      if (
        this.reason_exclude_from_calculation.includes(payment.request_reason) &&
        (payment.status === "recall-request" ||
          payment.status === "pending-recall" ||
          payment.status === "recall")
      ) {
        return false;
      }
      if (
        payment.status === "recall-cancelled" ||
        payment.status === "pending-cancelled" ||
        payment.status === "cancelled"
      ) {
        return false;
      }
      return true;
    }
    return false;
  }

  onChequeAmountChanged() {
    this.totalChequeBookAmount = 0;
    this.totalCDBAmount = 0;
    this.totalChequeSharingAmount = 0;
    this.totalChequeDeveloperAmount = 0;
    this.payment_collections.map((c, index) => {
      if (
        this.reason_exclude_from_calculation.includes(c.request_reason) &&
        (c.status === "recall-request" ||
          c.status === "pending-recall" ||
          c.status === "recall")
      ) {
        return;
      }
      if (
        c.status === "recall-cancelled" ||
        c.status === "pending-cancelled" ||
        c.status === "cancelled" ||
        c.status === "bounced-cancelled"
      ) {
        return;
      }
      if (c.installment_type === "Fine") return;
      if (
        c.installment_type == "Down Payment" ||
        c.installment_type == "Installment" ||
        c.installment_type == "Eoi"
      ) {
        // console.log("counting", index);
        // console.log(c);
        if (c.sharing_type_text == "Sharing") {
          this.totalChequeSharingAmount += +c.amount;
        }
        if (c.sharing_type_text == "Developer") {
          this.totalChequeDeveloperAmount += +c.amount;
        }
        this.totalChequeBookAmount += +c.amount + c.early_payment_discount || 0;
      } else if (c.installment_type == "CDB")
        this.totalCDBAmount += +c.amount || 0;
    }, 0);
    console.log("totalChequeSharingAmount", this.totalChequeSharingAmount);
  }

  DATE_FORMAT = "yyyy-MM-dd";
  onChequeDateChanged(event, index) {
    const date = parse(
      this.payment_collections[index].date,
      this.DATE_FORMAT,
      new Date()
    );
    const db_date = parse(
      this.payment_collections[index].db_date,
      this.DATE_FORMAT,
      new Date()
    );

    let day_of_month = getDate(date);
    console.log(day_of_month);

    const monthsDiff = differenceInCalendarMonths(date, db_date);
    this.payment_collections.forEach((payment, payment_index) => {
      if (this.ListEdits_inputs) {
        if (!this.shouldApplyListEditsToPayment(payment, payment_index, index))
          return;

        let current_date = parse(
          payment.db_date,
          this.DATE_FORMAT,
          new Date()
        );
        current_date = setDate(current_date, 1);
        current_date = addMonths(current_date, monthsDiff);

        let last_day_of_month = getDate(lastDayOfMonth(current_date));

        current_date = setDate(
          current_date,
          day_of_month > last_day_of_month ? last_day_of_month : day_of_month
        );

        payment.date = format(current_date, this.DATE_FORMAT);
      } else if (this.DeveloperEdits_inputs && this.SharingEdits_inputs) {
        if (payment.status === "cancelled") return;
        if (payment_index > index) {
          let current_date = parse(
            payment.db_date,
            this.DATE_FORMAT,
            new Date()
          );
          current_date = setDate(current_date, 1);
          current_date = addMonths(current_date, monthsDiff);

          let last_day_of_month = getDate(lastDayOfMonth(current_date));

          current_date = setDate(
            current_date,
            day_of_month > last_day_of_month ? last_day_of_month : day_of_month
          );

          payment.date = format(current_date, this.DATE_FORMAT);
        }
      } else if (this.DeveloperEdits_inputs) {
        if (payment.sharing_type_text === "Developer") {
          if (payment.status === "cancelled") return;
          if (payment_index > index) {
            let current_date = parse(
              payment.db_date,
              this.DATE_FORMAT,
              new Date()
            );
            current_date = setDate(current_date, 1);
            current_date = addMonths(current_date, monthsDiff);

            let last_day_of_month = getDate(lastDayOfMonth(current_date));

            current_date = setDate(
              current_date,
              day_of_month > last_day_of_month
                ? last_day_of_month
                : day_of_month
            );

            payment.date = format(current_date, this.DATE_FORMAT);
          }
        }
      } else if (this.SharingEdits_inputs) {
        if (payment.sharing_type_text === "Sharing") {
          if (payment.status === "cancelled") return;
          if (payment_index > index) {
            let current_date = parse(
              payment.db_date,
              this.DATE_FORMAT,
              new Date()
            );
            current_date = setDate(current_date, 1);
            current_date = addMonths(current_date, monthsDiff);

            let last_day_of_month = getDate(lastDayOfMonth(current_date));

            current_date = setDate(
              current_date,
              day_of_month > last_day_of_month
                ? last_day_of_month
                : day_of_month
            );

            payment.date = format(current_date, this.DATE_FORMAT);
          }
        }
      }
    });
  }

  assignPrintSharingType(sharingType: number) {
    this.printSharingType = sharingType;
  }

  submitPrintPaymentCollectioModal(modal) {
    const payload = {
      developer_id: +this.developer_id,
      cheque_book_name: this.cheque_book_name,
      name_on_cheques: this.name_on_cheques,
      sharing_type: this.printSharingType,
    };
    this.slimLoadingBarService.start();
    this.projectsService
      .printChequBook(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          window.open(res.url);
          swal("Success", "", "success");
          this.slimLoadingBarService.complete();
          modal.close();
          this.getReservation();
          modal.close();
          this.developer_id = null;
          this.printSharingType = null;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  submitEnableReminder(modal) {
    let payload;
    if (this.enableRemiderType == "multiple") {
      const selectedCheques = this.payment_collections.filter(
        (list) => list.checked == true
      );
      payload = {
        ids: selectedCheques.map((cheque) => cheque.id),
        send_reminder: 1,
        reminder_reason: this.reminder_reason,
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        send_reminder: 1,
        reminder_reason: this.reminder_reason,
      };
    }
    this.slimLoadingBarService.start();
    this.reservationService
      .enableOrDisableReminderCheque(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          this.reminder_reason = "";
          this.getReservation();
          this.onCheckAllToggle(false);
          this.enableRemiderType = null;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  submitDisableReminder(modal) {
    let payload;
    if (this.disableReminderType == "multiple") {
      const selectedCheques = this.payment_collections.filter(
        (list) => list.checked == true
      );
      payload = {
        ids: selectedCheques.map((cheque) => cheque.id),
        send_reminder: 0,
        reminder_reason: this.reminder_reason,
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        send_reminder: 0,
        reminder_reason: this.reminder_reason,
      };
    }
    this.slimLoadingBarService.start();
    this.reservationService
      .enableOrDisableReminderCheque(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          this.reminder_reason = "";
          this.getReservation();
          this.onCheckAllToggle(false);
          this.disableReminderType = null;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  submitRejectCheque(modal) {
    console.log(this.reject_reason);
    console.log(this.bounce_date);
    console.log(this.store_status);
    if (!this.reject_reason || !this.bounce_date || !this.store_status) {
      swal("Bounce Reason or Bounce Date or Location is empty", "", "error");
      return;
    }
    let payload: any = {
      ids: [this.current_active_cheque],
      status: "bounced",
      reject_reason: this.reject_reason,
      bounce_reason: this.reject_reason,
      reject_comment: this.reject_reason == "other" ? this.reject_comment : "",
    };
    if (!this.bounce_date) {
      swal("error", "bounce date required", "error");
      return;
    }
    if (!this.store_status) {
      swal("error", "Location required", "error");
      return;
    }
    payload.bounce_date = this.bounce_date;
    payload.store_status = this.store_status;
    this.slimLoadingBarService.start();
    this.reservationService
      .collectCheque(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          this.current_active_cheque = null;
          this.cheque_amount = null;
          this.reject_reason = null;
          this.reject_comment = null;
          this.getReservation();
          this.onCheckAllToggle(false);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  cancle_formdata = {
    early_payment_discount: 0,
    cancel_for: "early_payment",
    date: "",
    partially_method: "",
    cheque_number: "",
    store_status: null,
    bank_id: null,
    currency_code: "EGP",
    transaction_number: "",
    due_date: "",
  };
  onOpenCancelCheque(id, modal) {
    this.current_active_cheque = id;
    modal.open();
  }

  cancelModalSubmitting = false;
  submitCancelCheque(modal) {
    if (this.cancelModalSubmitting) return;
    if (this.cancle_formdata.currency_code != "EGP" && !this.exchange_rate) {
      swal(
        "error",
        "Exchange Rate is needed if the currency is not EGP",
        "error"
      );
      return;
    }
    let payload;
    if (this.cancle_formdata.cancel_for === "under-collection") {
      payload = {
        ids: [this.current_active_cheque],
        status: "cancelled",
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        status: "cancelled",
        early_payment_discount: this.cancle_formdata.early_payment_discount,
        date: this.cancle_formdata.date,
        partially_method: this.cancle_formdata.partially_method,
        currency_code: this.cancle_formdata.currency_code,
        bank_id: this.cancle_formdata.bank_id,
        store_status: this.cancle_formdata.store_status,
        exchange_rate: this.exchange_rate,
        cheque_number: this.cancle_formdata.cheque_number,
        transaction_number: this.cancle_formdata.transaction_number,
        due_date: this.cancle_formdata.due_date,
      };
    }

    this.collectModalSubmitting = true;
    this.slimLoadingBarService.start();
    this.reservationService.cancelForDiscount(payload.ids, payload).subscribe(
      (res: any) => {
        this.cancle_formdata = {
          early_payment_discount: 0,
          cancel_for: "early_payment",
          date: "",
          partially_method: "",
          cheque_number: "",
          store_status: null,
          bank_id: null,
          currency_code: "EGP",
          transaction_number: "",
          due_date: "",
        };
        this.current_active_cheque = null;
        modal.close();
        this.getReservation();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    )
    .add(() => {
      this.collectModalSubmitting = false;
    });
  }

  deleteFine(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this fine!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        let payload = {
          ids: id,
        };
        this.slimLoadingBarService.start();
        this.reservationService
          .deleteReservationFine(this.reservation_details.id, payload)
          .subscribe(
            (res: any) => {
              swal("Success", "Deleted Fine successfully", "success");
              this.slimLoadingBarService.complete();
              this.getFines(this.reservation_details.id);
              this.getReservation();
              this.getPaymentCollection(this.reservation_details.id);
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancel_fine_form: any = {
    id: null,
    cancel_date: null,
  };

  openCancelFineModal(fine, modal) {
    this.cancel_fine_form = {
      id: fine.id,
      cancel_date: null,
    };
    modal.open();
  }

  cancelFineModalSubmitting = false;
  submitCancelFineModal(modal) {
    if (this.cancelFineModalSubmitting) return;
    if (!this.cancel_fine_form.cancel_date) {
      swal("Cancel date is required", "", "error");
      return;
    }
    if (!this.cancel_fine_form.id) return;

    this.cancelFineModalSubmitting = true;
    this.slimLoadingBarService.start();
    this.reservationService
      .cancelFine(this.cancel_fine_form.id, {
        cancel_date: this.cancel_fine_form.cancel_date,
      })
      .subscribe(
        (res: any) => {
          swal("Success", "Fine cancelled successfully", "success");
          this.cancel_fine_form = {
            id: null,
            cancel_date: null,
          };
          modal.close();
          this.getFines(this.reservation_details.id);
          this.getReservation();
          this.getPaymentCollection(this.reservation_details.id);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.slimLoadingBarService.complete();
        this.cancelFineModalSubmitting = false;
      });
  }

  submitRejectChequeFine(modal) {
    let payload;
    if (this.chequeRejectTypeFine == "multiple") {
      const selectedFines = this.fines.filter((list) => list.checked == true);
      payload = {
        ids: selectedFines.map((cheque) => cheque.id),
        status: "bounced",
        reject_reason: this.reject_reason_fine,
        reject_comment:
          this.reject_reason_fine == "other" ? this.reject_comment_fine : "",
      };
    } else {
      payload = {
        ids: [this.current_active_cheque_fine],
        status: "bounced",
        reject_reason: this.reject_reason_fine,
        reject_comment:
          this.reject_reason_fine == "other" ? this.reject_comment_fine : "",
      };
    }
    this.slimLoadingBarService.start();
    this.reservationService
      .collectChequeFine(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          this.current_active_cheque_fine = null;
          this.cheque_amount_fine = null;
          this.reject_reason_fine = null;
          this.reject_comment_fine = null;
          this.getReservation();
          this.onCheckAllToggle(false);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  collectModalSubmitting = false;
  submitCollectCheque(modal) {
    this.disable_collect_action = true;
    console.log(this.collect_type);
    if (this.currency_code != "EGP" && !this.exchange_rate) {
      swal(
        "error",
        "Exchange Rate is needed if the currency is not EGP",
        "error"
      );
      return;
    }
    if (this.collectModalSubmitting) return;
    let payload;
    if (this.chequeCollectType == "multiple") {
      const selectedCheques = this.payment_collections.filter(
        (list) => list.checked == true
      );
      payload = {
        ids: selectedCheques.map((cheque) => cheque.id),
        status: this.collect_type,
        lead_id: this.chequeCollectCustomer,
        partially_method: this.partially_method,
        collection_date: this.collection_date,
        exchange_rate: this.exchange_rate,
        currency_code: this.currency_code,
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        status: this.collect_type,
        lead_id: this.chequeCollectCustomer,
        partially_method: this.partially_method,
        collection_date: this.collection_date,
        exchange_rate: this.exchange_rate,
        currency_code: this.currency_code,
      };
      if (this.collect_type == "partially-collected") {
        payload.amount_received = this.cheque_amount;
        if (payload.partially_method == "3") {
          if (!this.partially_data) {
            payload.partially_data = this.partially_data;
          } else {
            swal("error", "Partially Data Is Required", "error");
            this.disable_collect_action = false;
            return;
          }
        }
      }
    }
    // if (
    //   this.collect_type === "partially-collected" &&
    //   this.partially_method != 4
    // ) {
    //   payload.transaction_number = this.transaction_number;
    // }
    // if (this.isDateGreaterThanToday(this.collection_date)) {
    //   swal("collection date can not be greater than today", "", "error");
    //   return;
    // }
    // if (this.slip_type === "2" || this.slip_type === "3") {
    //   if (!this.transaction_number) {
    //     swal("error", "Transaction Number is required", "error");
    //     return;
    //   }
    // }
    if (this.partially_method == "2" || this.partially_method == "3") {
      if (this.file) {
        payload.file = this.file;
        payload.file_name = this.file_name;
      } else {
        swal("error", "File Is Required", "error");
        this.disable_collect_action = false;
        return;
      }
    }

    if (
      this.partially_method == "1" ||
      this.partially_method == "2" ||
      this.partially_method == "3"
    ) {
      if (this.transaction_number) {
        payload.transaction_number = this.transaction_number;
      } else {
        swal("error", "Transaction Number Is Required", "error");
        this.disable_collect_action = false;
        return;
      }
    }

    if(this.partially_method == 6) {
      payload.shareholder_code = this.shareholder_code
      payload.shareholder_name = this.shareholder_name
      payload.share_holder_name = this.share_holder_name
    }

    if(this.partially_method == 7) {
      payload.vendor_code = this.vendor_code
      payload.vendor_name = this.vendor_name
      payload.developer_id = this.developer_id
    }

    if (this.partially_method == "4") {
      payload.bank_id = this.bank_id;
      if (this.partially_data) {
        payload.partially_data = this.partially_data;
      } else {
        swal("error", "Cheque Number is required", "error");
        this.disable_collect_action = false;
        return;
      }
    }

    if (
      this.partially_method == "1" ||
      this.partially_method == "2" ||
      this.partially_method == "3" ||
      this.partially_method == "4"
    ) {
      if (this.store_status && this.isAllowedCollectLocation(this.store_status)) {
        payload.store_status = this.store_status;
      } else {
        const message =
          this.partially_method == "4"
            ? "Bank location is required"
            : "Location is required";
        swal("error", message, "error");
        this.disable_collect_action = false;
        return;
      }
    }
    if (this.active_cheque_book_row.new_payment_after_cancel) {
      payload.new_payment_after_cancel = 1;
    }
    this.collectModalSubmitting = true;
    this.slimLoadingBarService.start();
    console.log(payload);
    this.reservationService
      .collectCheque(this.reservationId, payload, {})
      .subscribe(
        (res: any) => {
          this.disable_collect_action = false;
          console.log(res);
          swal("Woohoo!", "Collected!", "success");
          modal.close();
          this.collect_type = null;
          this.current_active_cheque = null;
          this.cheque_amount = null;
          this.partially_method = null;
          this.partially_data = null;
          this.collection_date = "";
          this.chequeCollectCustomer = "";
          this.getReservation();
          this.onCheckAllToggle(false);
        },
        (err) => {
          this.disable_collect_action = false;
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.collectModalSubmitting = false;
      });
  }


  onOpenPaymentRefundRequest(list, modal) {
    this.activeRefundPayment = list;
    this.paymentRefundRequestData = {
      date: "",
      refund_amount: null,
    };
    modal.open();
  }

  onOpenApprovePaymentRefund(list, modal) {
    this.activeRefundPayment = list;
    this.approvePaymentRefundDate = "";
    modal.open();
  }

  onOpenRejectPaymentRefund(list, modal) {
    this.activeRefundPayment = list;
    this.rejectPaymentRefundDate = "";
    modal.open();
  }

  uploadScannedChequeSubmit(modal) {
    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    const formModel = Object.assign({}, this.uploadScannedChequeForm.value);
    console.log(formModel);
    if (!formModel.scannedCheque) {
      swal("Oops...", "Files can not be empty!", "error");
    } else {
      const data = {
        // receipt: formModel.receipt.value,
        // scan_url: formModel.signed.value,
        // id: reservationId,
        // file_name2: formModel.signed.filename,
        // file_name: formModel.receipt.filename,
        image_value: formModel.scannedCheque.value,
        image_name: formModel.scannedCheque.filename,
      };
      console.log(data);
      this.reservationService
        .uploadScannedCheque(this.current_active_cheque, data)
        .subscribe(
          (data) => {
            console.log(data);
            this.getReservation();
            this.getPaymentCollection(this.reservationId);
            this.slimLoadingBarService.complete();
            modal.close();
            this.uploadScannedChequeForm.reset();
            swal("Woohoo!", "Contractor Approved!", "success");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
    }
  }

  handleUploadScannedCheque(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      this.file_name = file.name;
      reader.onload = () => {
        // this.filesForm.get("receipt").setValue({
        //   filename: file.name,
        //   filetype: file.type,
        //   value: (reader.result as any).split(",")[1],
        // });
        this.uploadScannedChequeForm.get("scannedCheque").setValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any).split(",")[1],
        });
      };
    }
  }

  printSelectedCheque(printChequeModal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length === 0) {
      swal("warning", "There is no selected Cheques");
      return;
    }

    const ids = selectedCheques.map((cheque) => cheque.id);
    const bankIds = selectedCheques
      .map((cheque) => Number(cheque.bank_id))
      .filter((id) => Number.isFinite(id) && id > 0);

    if (bankIds.length !== selectedCheques.length) {
      swal("warning", "All selected cheques must have a bank");
      return;
    }

    const uniqueBanks = Array.from(new Set(bankIds));
    if (uniqueBanks.length > 1) {
      swal("warning", "Please select cheques from the same bank only");
      return;
    }

    this.openPrintTemplateModal(ids, uniqueBanks[0], printChequeModal);
  }

  printCheque(id, bank_id, printChequeModal) {
    const normalizedBankId = Number(bank_id);
    if (!Number.isFinite(normalizedBankId) || normalizedBankId <= 0) {
      swal("warning", "This cheque has no bank selected");
      return;
    }
    this.openPrintTemplateModal([id], normalizedBankId, printChequeModal);
  }

  openPrintTemplateModal(ids, bankId, modal) {
    if (!ids || ids.length === 0) {
      swal("warning", "There is no selected Cheques");
      return;
    }

    this.resetChequePrintModalState();
    this.selectedChequePrintIds = ids;
    this.selectedChequePrintRows = (this.payment_collections || []).filter(
      (row) => ids.indexOf(Number(row && row.id)) >= 0
    );
    this.selectedPrintBankId = bankId;
    const currentBank = (this.banks || []).find(
      (bank) => Number(bank.id) === Number(bankId)
    );
    this.selectedPrintBankName = (currentBank && currentBank.name) || `Bank #${bankId}`;

    this.slimLoadingBarService.start();
    this.reservationService.getChequeTemplatesByBank(bankId).subscribe(
      (res: any) => {
        const rows = Array.isArray(res) ? res : (res && res.data) || [];
        this.chequeTemplatesByBank = rows
          .filter((template) => Number(template && template.bank_id) === Number(bankId))
          .map((template) => ({
            ...template,
            display_name:
              (template && template.template_name) ||
              (template && template.bank_name) ||
              `Template #${template && template.id}`,
            preview_url: this.resolveTemplatePreviewUrl(template),
          }));
        if (this.chequeTemplatesByBank.length === 0) {
          swal("warning", "No cheque templates found for this bank");
          this.slimLoadingBarService.complete();
          return;
        }
        this.selectedChequeTemplateId = null;
        modal.open();
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  onChequeTemplateSelectionChange() {
    this.selectedChequeTemplateDetails = null;
    this.selectedChequeTemplateDimensions = null;
    this.selectedChequeTemplateImageDimensions = null;
    this.selectedPrintTemplatePreviewUrl = null;
    if (!this.selectedChequeTemplateId) {
      return;
    }

    this.isChequeTemplateDetailsLoading = true;
    this.projectsService.getBankChequeById(this.selectedChequeTemplateId).subscribe(
      (res: any) => {
        const template = (res && res.data) || res || null;
        this.selectedChequeTemplateDetails = template;
        this.selectedChequeTemplateDimensions = this.extractChequeTemplateDimensions(template);
        this.selectedPrintTemplatePreviewUrl = this.resolveTemplatePreviewUrl(template);
        this.loadSelectedTemplateImageDimensions(this.selectedPrintTemplatePreviewUrl);
        this.isChequeTemplateDetailsLoading = false;
      },
      (err) => {
        this.isChequeTemplateDetailsLoading = false;
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  resetChequePrintModalState() {
    this.chequeTemplatesByBank = [];
    this.selectedChequeTemplateId = null;
    this.selectedPrintBankId = null;
    this.selectedPrintBankName = "";
    this.selectedPrintTemplatePreviewUrl = null;
    this.selectedChequePrintIds = [];
    this.selectedChequePrintRows = [];
    this.selectedChequeTemplateDetails = null;
    this.selectedChequeTemplateDimensions = null;
    this.selectedChequeTemplateImageDimensions = null;
    this.isChequeTemplateDetailsLoading = false;
  }

  getChequePreviewContainerStyle() {
    const effectiveDimensions = this.getEffectiveChequePreviewDimensions();
    if (!effectiveDimensions) {
      return {};
    }
    return {
      width: `${effectiveDimensions.width}cm`,
      height: `${effectiveDimensions.height}cm`,
    };
  }

  getPrintChequeModalClass(): string {
    const effectiveDimensions = this.getEffectiveChequePreviewDimensions();
    const width = effectiveDimensions ? effectiveDimensions.width : 0;
    const height = effectiveDimensions ? effectiveDimensions.height : 0;
    const mediumWidthCm = 19;
    const mediumHeightCm = 10;

    if (!width || !height || (width <= mediumWidthCm && height <= mediumHeightCm)) {
      return "print-cheque-modal modal-md";
    }

    if (width >= 26 || height >= 13) {
      return "print-cheque-modal print-cheque-modal-dynamic modal-size-xxl";
    }
    return "print-cheque-modal print-cheque-modal-dynamic modal-size-xl";
  }

  extractChequeTemplateDimensions(template) {
    const variables = (template && template.variables) || {};
    const raw =
      variables.Dimensions ||
      variables.dimensions ||
      template.Dimensions ||
      template.dimensions ||
      {};

    const width =
      this.normalizePreviewDimension(raw.width) ||
      this.normalizePreviewDimension(raw.witdh) ||
      this.normalizePreviewDimension(template.width);
    const height =
      this.normalizePreviewDimension(raw.height) ||
      this.normalizePreviewDimension(raw.higth) ||
      this.normalizePreviewDimension(template.height);

    return width && height ? { width: width, height: height } : null;
  }

  loadSelectedTemplateImageDimensions(imageUrl) {
    if (!imageUrl || this.selectedChequeTemplateDimensions) {
      return;
    }

    const image = new Image();
    image.onload = () => {
      const width = this.normalizeImageDimensionToCm(image.naturalWidth || image.width);
      const height = this.normalizeImageDimensionToCm(image.naturalHeight || image.height);
      this.selectedChequeTemplateImageDimensions =
        width && height ? { width: width, height: height } : null;
    };
    image.onerror = () => {
      this.selectedChequeTemplateImageDimensions = null;
    };
    image.src = imageUrl;
  }

  getEffectiveChequePreviewDimensions() {
    return this.selectedChequeTemplateDimensions || this.selectedChequeTemplateImageDimensions;
  }

  toFinitePreviewDimension(value) {
    const normalized = Number(String(value == null ? "" : value).replace(/[^\d.]/g, ""));
    return Number.isFinite(normalized) && normalized > 0 ? normalized : null;
  }

  normalizePreviewDimension(value) {
    const finiteValue = this.toFinitePreviewDimension(value);
    if (!finiteValue) {
      return null;
    }
    return finiteValue;
  }

  normalizeImageDimensionToCm(value) {
    const finiteValue = this.toFinitePreviewDimension(value);
    if (!finiteValue) {
      return null;
    }
    return finiteValue / this.PX_PER_CM;
  }

  get selectedChequePrintTotalAmount() {
    return (this.selectedChequePrintRows || []).reduce((total, cheque) => {
      const amount = this.toValidChequeAmount(this.getChequeRowAmount(cheque));
      return total + (amount || 0);
    }, 0);
  }

  get previewChequeAmount() {
    const firstCheque = (this.selectedChequePrintRows || [])[0] || {};
    const amount = this.toValidChequeAmount(firstCheque.amount || firstCheque.cheque_amount);
    return amount || 0;
  }

  get previewChequeDate() {
    const firstCheque = (this.selectedChequePrintRows || [])[0] || {};
    return firstCheque.due_date || "";
  }

  get previewChequeAmountArabicText() {
    const numericAmount = this.previewChequeAmount;
    const templateFallback = String(
      (this.selectedChequeTemplateDetails &&
        this.selectedChequeTemplateDetails.variables &&
        this.selectedChequeTemplateDetails.variables.amount_text &&
        this.selectedChequeTemplateDetails.variables.amount_text.value) ||
        ""
    ).trim();
    if (!numericAmount || numericAmount <= 0 || typeof Tafgeet === "undefined") {
      return templateFallback;
    }
    try {
      const parsed = new Tafgeet(numericAmount, "EGP").parse();
      const normalizedParsed = String(parsed || "").trim();
      if (!normalizedParsed || normalizedParsed.indexOf("undefined") >= 0) {
        return templateFallback;
      }
      return normalizedParsed;
    } catch (error) {
      return templateFallback;
    }
  }

  getChequePreviewFieldStyle(fieldName) {
    const defaults = {};
    const field =
      this.selectedChequeTemplateDetails &&
      this.selectedChequeTemplateDetails.variables &&
      this.selectedChequeTemplateDetails.variables[fieldName];
    if (!field) {
      return defaults;
    }
    const style: any = {
      ...defaults,
      top: field.top || "auto",
      right: field.right || "auto",
      bottom: field.bottom || "auto",
      left: field.left || "auto",
      "max-width": "100px",
      "white-space": "nowrap",
    };
    if (fieldName === "beneficiary_name") {
      const hasLeft = style.left && style.left !== "auto";
      const hasRight = style.right && style.right !== "auto";
      if (!hasLeft && hasRight) {
        style.left = "auto";
      }
    }
    if (this.isChequePreviewSpacedDateFormat()) {
      const digitSpacing = Number(field.digit_spacing);
      if (Number.isFinite(digitSpacing) && digitSpacing >= 0) {
        style["letter-spacing.px"] = digitSpacing;
      }
    }
    return style;
  }

  getChequePreviewDateStyle() {
    const field =
      this.selectedChequeTemplateDetails &&
      this.selectedChequeTemplateDetails.variables &&
      this.selectedChequeTemplateDetails.variables.date;
    if (!field) {
      return {};
    }

    const style: any = {
      display: "inline-block",
      position: "absolute",
      right: field.right || "auto",
      top: field.top || "auto",
      fontFamily: "Times",
      fontSize: "18px",
      maxWidth: "100px",
      zIndex: 10,
      direction: "ltr",
      textAlign: "center",
      cursor: "move",
      color: "#000",
    };

    if (this.isChequePreviewSpacedDateFormat()) {
      const digitSpacing = Number(field.digit_spacing);
      if (Number.isFinite(digitSpacing) && digitSpacing >= 0) {
        style["letter-spacing.px"] = digitSpacing;
      }
    }

    return style;
  }

  getChequePreviewFieldValue(fieldName) {
    const field =
      this.selectedChequeTemplateDetails &&
      this.selectedChequeTemplateDetails.variables &&
      this.selectedChequeTemplateDetails.variables[fieldName];
    const templateValue = String((field && field.value) || "").trim();
    if (fieldName === "date") {
      const displayValue = String(
        (this.selectedChequeTemplateDetails &&
          this.selectedChequeTemplateDetails.variables &&
          this.selectedChequeTemplateDetails.variables.date &&
          this.selectedChequeTemplateDetails.variables.date.display_value) ||
          ""
      ).trim();
      if (displayValue) {
        return displayValue;
      }
      const formattedValue = String(
        (this.selectedChequeTemplateDetails &&
          this.selectedChequeTemplateDetails.variables &&
          this.selectedChequeTemplateDetails.variables.date &&
          this.selectedChequeTemplateDetails.variables.date.formatted_value) ||
          ""
      ).trim();
      if (formattedValue) {
        return formattedValue;
      }
      const fallbackTemplateDate = templateValue;
      const rawDate = this.previewChequeDate
        ? format(new Date(this.previewChequeDate), "yyyy-MM-dd")
        : fallbackTemplateDate;
      return this.formatChequePreviewDate(rawDate);
    }
    if (fieldName === "amount") {
      if (this.selectedChequePrintRows && this.selectedChequePrintRows.length) {
        if (this.previewChequeAmount > 0) {
          return "#" + Number(this.previewChequeAmount).toFixed(2) + "#";
        }
        const formattedTemplateAmount = String(
          (this.selectedChequeTemplateDetails &&
            this.selectedChequeTemplateDetails.variables &&
            this.selectedChequeTemplateDetails.variables.amount_text &&
            this.selectedChequeTemplateDetails.variables.amount_text.amountAfterFormat) ||
            ""
        ).trim();
        return formattedTemplateAmount || templateValue;
      }
      const formattedTemplateAmount = String(
        (this.selectedChequeTemplateDetails &&
          this.selectedChequeTemplateDetails.variables &&
          this.selectedChequeTemplateDetails.variables.amount_text &&
          this.selectedChequeTemplateDetails.variables.amount_text.amountAfterFormat) ||
          ""
      ).trim();
      return formattedTemplateAmount || templateValue;
    }
    if (fieldName === "amount_text") {
      return this.previewChequeAmountArabicText || templateValue;
    }
    if (fieldName === "beneficiary_name") {
      return templateValue;
    }
    return templateValue;
  }

  isChequePreviewSpacedDateFormat() {
    return (
      Number(
        (this.selectedChequeTemplateDetails &&
          this.selectedChequeTemplateDetails.variables &&
          this.selectedChequeTemplateDetails.variables.date &&
          this.selectedChequeTemplateDetails.variables.date.format) ||
          this.DATE_FORMAT_STANDARD
      ) === this.DATE_FORMAT_SPACED_DDMMYYYY
    );
  }

  getChequePreviewLinearText() {
    const linear =
      this.selectedChequeTemplateDetails &&
      this.selectedChequeTemplateDetails.variables &&
      this.selectedChequeTemplateDetails.variables.linear;
    if (linear && linear.selected === false) {
      return "";
    }
    return String((linear && linear.value) || "").trim();
  }

  getChequePreviewCheckStyle() {
    return {
      ...this.getChequePreviewContainerStyle(),
      "background-image": "url('" + (this.selectedPrintTemplatePreviewUrl || "") + "')",
      "background-repeat": "no-repeat",
      "background-size": "100%",
      "background-position": "top left",
    };
  }

  private formatChequePreviewDate(value) {
    const normalized = String(value || "").trim();
    if (!this.isChequePreviewSpacedDateFormat()) {
      return normalized;
    }
    const isoMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!isoMatch) {
      return normalized;
    }
    return isoMatch[3] + isoMatch[2] + isoMatch[1];
  }

  private resolveTemplatePreviewUrl(template) {
    const fullUrl = String((template && template.full_url) || "").trim();
    if (fullUrl) {
      return encodeURI(fullUrl);
    }
    const relativeUrl = String((template && template.url) || "").trim();
    if (!relativeUrl) {
      return null;
    }
    const normalizedBase = String(environment.api_raw_base_url || "").replace(/\/+$/, "");
    const normalizedPath = relativeUrl.charAt(0) === "/" ? relativeUrl : "/" + relativeUrl;
    return encodeURI(normalizedBase + normalizedPath);
  }

  private getNestedValue(target, path, defaultValue = null) {
    let current = target;
    for (let i = 0; i < path.length; i++) {
      if (current === null || current === undefined) {
        return defaultValue;
      }
      current = current[path[i]];
    }
    return current === undefined || current === null ? defaultValue : current;
  }

  private toEnglishDigits(value) {
    return String(value == null ? "" : value)
      .replace(/[\u0660-\u0669]/g, (c) => String(c.charCodeAt(0) - 0x0660))
      .replace(/[\u06f0-\u06f9]/g, (c) => String(c.charCodeAt(0) - 0x06f0));
  }

  private normalizeChequeAmountString(value) {
    const englishDigits = this.toEnglishDigits(value).replace(/,/g, ".");
    let output = "";
    let hasDot = false;
    let hasMinus = false;
    for (let i = 0; i < englishDigits.length; i++) {
      const ch = englishDigits[i];
      if (ch === "-" && !output && !hasMinus) {
        output += ch;
        hasMinus = true;
        continue;
      }
      if (ch >= "0" && ch <= "9") {
        output += ch;
        continue;
      }
      if (ch === "." && !hasDot) {
        output += ch;
        hasDot = true;
      }
    }
    return output;
  }

  private toValidChequeAmount(value) {
    const normalized = this.normalizeChequeAmountString(value);
    const amount = Number(normalized);
    return Number.isFinite(amount) && amount > 0 ? amount : null;
  }

  getChequeRowAmount(cheque) {
    if (!cheque) {
      return 0;
    }
    if (cheque.amount !== undefined && cheque.amount !== null) {
      return cheque.amount;
    }
    if (cheque.cheque_amount !== undefined && cheque.cheque_amount !== null) {
      return cheque.cheque_amount;
    }
    return 0;
  }

  showCheque(id) {
    const payload = {
      ids: [id],
      print_status: 1,
    };
    this.reservationService
      .hideOrShowCheque(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          this.getPaymentCollection(this.reservationId);
          this.slimLoadingBarService.complete();
          swal("success", "Show successfully", "success");
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.reset();
        }
      );
  }

  hideCheque(id) {
    const payload = {
      ids: [id],
      print_status: 0,
    };
    this.reservationService
      .hideOrShowCheque(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          this.getPaymentCollection(this.reservationId);
          swal("success", "Hide successfully", "success");
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.reset();
        }
      );
  }

  deleteCheque(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this cheque!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        let payload = {
          ids: [id],
        };
        this.slimLoadingBarService.start();
        this.reservationService.deleteCheque(payload).subscribe(
          (res) => {
            this.slimLoadingBarService.complete();
            swal("success", "Cheque deleted successfully", "success");
            this.getPaymentCollection(this.reservationId);
          },
          (err) => {
            this.slimLoadingBarService.reset();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  bulkDeleteCheques() {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
      return;
    }
    swal({
      title: "Are you sure?",
      text: "You will delete selected cheques!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete them!",
      cancelButtonText: "No, keep them",
    }).then((result) => {
      if (result.value) {
        const payload = {
          ids: selectedCheques.map((cheque) => cheque.id),
        };
        this.slimLoadingBarService.start();
        this.reservationService.deleteCheque(payload).subscribe(
          (res) => {
            this.slimLoadingBarService.complete();
            swal("success", "Cheques deleted successfully", "success");
            this.getPaymentCollection(this.reservationId);
          },
          (err) => {
            this.slimLoadingBarService.reset();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  getdevelopers() {
    this.slimLoadingBarService.start();
    this.userService.getDevelopers().subscribe(
      (data: any) => {
        this.developers = data;
        console.log(this.developers);
      },
      (err) => {},
      () => this.slimLoadingBarService.complete()
    );
  }

  async uploadScanned(event: any, document_id: number, fileInput) {
    let scanned_document_files_uploads = [];
    let selectedFiles = event.target.files;
    let onParsingEnd = new Promise((resolve, reject) => {
      for (let i = 0; i < selectedFiles.length; i++) {
        let file = selectedFiles[i];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {
          let attach = {
            name: file.name,
            type: file.type,
            src: (reader.result as any as any).split(",")[1],
          };
          await scanned_document_files_uploads.push(attach);
          if (i + 1 == selectedFiles.length)
            resolve(scanned_document_files_uploads);
        };
      }
    });
    onParsingEnd.then((data) => {
      console.log(data);
      this.slimLoadingBarService.start();
      this.reservationService
        .uploadScannedFiles(this.reservationId, document_id, {
          scanned_files: data,
        })
        .subscribe(
          (res) => {
            console.log(fileInput);
            fileInput.value = null;
            this.slimLoadingBarService.complete();
            this.getReservationsDocuments();
            swal("Success", "scanned document added successfully", "success");
          },
          (err) => {
            this.slimLoadingBarService.reset();
          }
        );
    });
  }

  applyScanned(id) {
    console.log(id);
    this.slimLoadingBarService.start();
    this.reservationService.applyScanned(this.reservationId, id).subscribe(
      (res) => {
        swal("Success", "apply scanned successfully", "success");
        this.slimLoadingBarService.complete();
        this.getReservationsDocuments();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  addChequeBook(modal) {
    this.slimLoadingBarService.start();
    if (this.add_cheque.due_date == null || this.add_cheque.due_date == "") {
      swal("Due Date can not be empty", "", "error");
      this.slimLoadingBarService.reset();
      return;
    }
    if (
      Number(this.add_cheque.partially_method) === 4 &&
      (!this.add_cheque.cheque_book_name ||
        !this.add_cheque.cheque_number ||
        !this.add_cheque.bank_id ||
        !this.add_cheque.name_on_cheques)
    ) {
      swal("Please complete all cheque book details", "", "error");
      this.slimLoadingBarService.reset();
      return;
    }
    if (this.add_cheque.type != 3) delete this.add_cheque.maintenance_type;
    this.reservationService
      .addCheque(this.reservationId, this.add_cheque)
      .subscribe(
        (res) => {
          this.slimLoadingBarService.complete();
          modal.close();
          swal("Success", "Cheque added successfully", "success");
          this.getPaymentCollection(this.reservationId);
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  add_fineModal = {
    submitting: false,
    reservaton_id: "",
    payload: {
      amount: 0,
      num_days_late: 0,
      collection_cheque_id: null,
      fine_date: null,
      type: null,
    },
  };

  openDelayFineModal(modal, cheque) {
    this.add_fineModal = {
      submitting: false,
      reservaton_id: cheque.reservation_id,
      payload: {
        amount: 0,
        num_days_late: 0,
        collection_cheque_id: cheque.id,
        fine_date: "",
        type: "",
      },
    };
    modal.open();
  }

  submitting_add_fine = false;
  addDelayFineToCheque(modal) {
    this.submitting_add_fine = true;
    if (!this.add_fineModal.payload.type) {
      swal("error", "You have to choose a type for the fine!", "error");
      this.submitting_add_fine = false;
      return;
    }
    if (!this.add_fineModal.payload.amount) {
      swal("error", "You have to enter an amount for the fine!", "error");
      this.submitting_add_fine = false;
      return;
    }
    if (!this.slip_type) {
      swal("error", "You have to choose a method for the fine!", "error");
      this.submitting_add_fine = false;
      return;
    }
    if (!this.add_fineModal.payload.fine_date) {
      swal("error", "You have to enter a date for the fine!", "error");
      this.submitting_add_fine = false;
      return;
    }
    if (this.add_fineModal.payload.amount <= 0) {
      swal("error", "You have to enter a valid amount for the fine!", "error");
      this.submitting_add_fine = false;
      return;
    }
    const isValid = this.validatingPayloadForAccountantApproveAndAddFine();
    if (!isValid) return;
    this.add_fineModal.submitting = true;
    this.slimLoadingBarService.start();
    this.submitting_add_fine = true;
    const payload = {
      ...this.getPaylodForAccountantApproveAndAddFine(),
      ...this.add_fineModal.payload,
      slip_number: this.slip_number,
      partially_method: this.slip_type,
      cheque_number: this.cheque_number,
      currency_code: this.currency_code,
      exchange_rate: this.exchange_rate
    };
    this.reservationService
      .addDelayFine(this.add_fineModal.reservaton_id, payload)
      .subscribe(
        (res: any) => {
          this.submitting_add_fine = false;
          swal("Success", "", "success");
          this.getPaymentCollection(this.reservationId);
          this.getFines(this.reservationId);
          modal.close();
        },
        (err) => {
          this.submitting_add_fine = false;
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.submitting_add_fine = false;
      });
  }

  onTypeChange(type) {
    switch (type) {
      case "1":
        this.cheque_number = undefined;
        this.due_date = undefined;
        break;
      case "2":
      case "3":
        this.due_date = undefined;
        break;
      case "4":
        this.store_status = undefined;
        this.transaction_number = undefined;
        this.collection_date = undefined;
        break;
    }
  }

  enableOrDisableChequeInputs(payment, index) {
    console.log(payment);
    this.handleChangePartiallyMethod(payment, index);
    // console.log(this.payment_collections);
  }

  handleChangePartiallyMethod(payment, index) {
    this.payment_collections = this.payment_collections.map((item) =>
      item.id === payment.id
        ? this.applyCollectMethodSettings(item, payment.partially_method)
        : item
    );
    console.log(this.payment_collections);
    this.payment_collections = this.payment_collections.map(
      (curr_payment, payment_index) => {
        // debugger;
        if (this.ListEdits_inputs) {
          if (
            !this.shouldApplyListEditsToPayment(
              curr_payment,
              payment_index,
              index
            ) ||
            !curr_payment.can_edit ||
            !this.ListEdits_inputs ||
            curr_payment.final_cheque_recived == 1 ||
            curr_payment.final_cheque_received ||
            curr_payment.status == "fully_collected"
          )
            return curr_payment;
          return this.applyCollectMethodSettings(
            curr_payment,
            payment.partially_method
          );
        }

        if (
          this.SharingEdits_inputs &&
          payment.sharing_type_text === "Sharing"
        ) {
          if (
            !curr_payment.can_edit ||
            payment_index <= index ||
            !this.SharingEdits_inputs ||
            curr_payment.final_cheque_recived == 1 ||
            curr_payment.status == "fully_collected"
          )
            return curr_payment;
          if (curr_payment.sharing_type_text === "Sharing") {
            return this.applyCollectMethodSettings(
              curr_payment,
              payment.partially_method
            );
          } else {
            return curr_payment;
          }
        }

        if (
          this.DeveloperEdits_inputs &&
          payment.sharing_type_text === "Developer"
        ) {
          if (
            !curr_payment.can_edit ||
            payment_index <= index ||
            !this.DeveloperEdits_inputs ||
            curr_payment.final_cheque_recived == 1 ||
            curr_payment.status == "fully_collected"
          )
            return curr_payment;
          if (curr_payment.sharing_type_text === "Developer") {
            return this.applyCollectMethodSettings(
              curr_payment,
              payment.partially_method
            );
          } else {
            return curr_payment;
          }
        }

        return curr_payment;
      }
    );
    console.log(this.payment_collections);
  }

  private applyCollectMethodSettings(payment: any, partiallyMethod: any) {
    const isCash = String(partiallyMethod) === "1";

    return {
      ...payment,
      partially_method: partiallyMethod,
      disable_location: false,
      disable_bank: isCash,
      bank_id: isCash ? null : payment.bank_id,
      store_status: null,
    };
  }

  finalChequeSelected() {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    const payload = {
      ids: selectedCheques.map((cheque) => cheque.id),
    };
    this.execFinalChequeRecieved(payload);
  }

  startFine(cheque_id) {
    swal({
      title: "Are you sure?",
      text: "You want to start fine for this cheque",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
      }
    });
  }

  endFine(cheque_id) {
    swal({
      title: "Are you sure?",
      text: "You want to start fine for this cheque",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
      }
    });
  }

  addBulkCheque(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length <= 1) {
      swal("you need to select at least two cheques", "", "error");
      return;
    }
    this.add_bulk_cheque_amount = selectedCheques.reduce(
      (acc, curr) => acc + curr.amount,
      0
    );
    modal.open();
    // this.execFinalChequeRecieved(payload);
  }

  submitBulkChequeModal(modal) {
    if (!this.add_bulk_cheque_amount)
      swal("Error", "Amount can not be empty", "error");
    else {
      const payload = {
        ids: this.payment_collections
          .filter((list) => list.checked == true)
          .map((payment) => payment.id),
        amount: this.add_bulk_cheque_amount,
      };
      this.slimLoadingBarService.start();
      this.reservationService.addBulkCheque(payload).subscribe(
        (data) => {
          modal.close();
          this.getReservation();
          swal("Woohoo!", "Added bulk cheque succesfully!", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  assignListPayment(payment: any) {
    this.list = payment;
  }

  finalChequeRecieved() {
    const payload = {
      ids: [this.list.id],
      final_cheque_received_date: this.final_cheque_received_date,
    };
    this.execFinalChequeRecieved(payload);
  }

  execFinalChequeRecieved(payload) {
    this.slimLoadingBarService.start();
    this.reservationService.finalChequeRecieved(payload).subscribe(
      (res) => {
        this.getPaymentCollection(this.reservation_details.id);
        swal("Success", "final cheque recieved successfully", "success");
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  deliveredToCustomer(payment) {
    if (payment.bulk_serial) {
      const paymentsWithSamelBulkSerial = this.payment_collections.filter(
        (list) =>
          list.bulk_serial == payment.bulk_serial && payment.id != list.id
      );
      const includedStatueses = [
        "cancelled",
        "bounced-cancelled",
        "recall-cancelled",
      ];
      const paymentWithValidStatus = paymentsWithSamelBulkSerial.filter(
        (list) => includedStatueses.includes(list.status)
      );
      if (
        paymentsWithSamelBulkSerial.length !== paymentWithValidStatus.length
      ) {
        swal(
          "error",
          "You can not deliver this cheque to customer, bulk cheque is not cancelled",
          "error"
        );
        return;
      }
    }
    const payload = {
      ids: [payment.id],
    };
    this.execDeliveredToCustomer(payload);
  }

  execDeliveredToCustomer(payload) {
    this.slimLoadingBarService.start();
    this.reservationService.deliveredToCustomer(payload).subscribe(
      (res) => {
        this.getPaymentCollection(this.reservation_details.id);
        swal("Success", "Delivered to Customer successfully", "success");
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  sendCourierDate(el: NgModel, modal) {
    if (!el.value) {
      swal("error", "Enter Send Courier Date", "error");
    }
    const payload = {
      date: el.value,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Send By Courier Date!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .sendCourierDate(this.reservation_details.id, payload)
          .subscribe(
            (data) => {
              this.getReservation();
              swal("Woohoo!", "Send By Courier set successfully!", "success");
              modal.close();
              el.control.patchValue("");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  receviedFromCourier(el: NgModel, modal) {
    if (!el.value) {
      swal("error", "Enter Recevied From Courier Date", "error");
    }
    const payload = {
      date: el.value,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Recevied From Courier Date!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .receviedFromCourier(this.reservation_details.id, payload)
          .subscribe(
            (data) => {
              this.getReservation();
              swal(
                "Woohoo!",
                "Recevied From Courier set successfully!",
                "success"
              );
              modal.close();
              el.control.patchValue("");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  approvePaymentRequest(ids, type?, modal?) {
    this.disable_submit_action = true;
    console.log(type);
    let payload: any = {
      ids,
      type: type,
      request_reason: this.request_reason,
      request_date: this.request_date,
    };
    if (type === "recall") {
      if (!this.request_date) {
        swal("request date is required", "", "error");
        this.disable_submit_action = false;
        return;
      }
      if (!this.request_reason) {
        swal("request reason is required", "", "error");
        this.disable_submit_action = false;
        return;
      }
    }
    if (type === "cancelled") payload.cancelled_date = this.request_date;
    if (type) payload.type = type;
    if (type === "recall-request") {
      if (!this.request_date) {
        swal("request date is required", "", "error");
        this.disable_submit_action = false;
        return;
      }
    }
    if (type === "pending-recall" || type === "bounced") {
      if (!this.store_status) {
        swal("location is required", "", "error");
        this.disable_submit_action = false;
        return;
      }
      if (!this.request_date) {
        swal("request date is required", "", "error");
        this.disable_submit_action = false;
        return;
      }
      payload.store_status = this.store_status;
    }
    if (type == "pending-cancelled") {
      if (!this.request_reason || !this.request_date || !this.store_status) {
        swal("request date or reason is empty", "", "error");
        this.disable_submit_action = false;
        return;
      }
      payload.bounce_reason = this.request_reason;
      payload.bounce_date = this.request_date;
      payload.store_status = this.store_status;
    }
    if (type == "bounced") {
      payload.location = this.location_bounce;
      payload.bounce_reason = this.request_reason;
      if (this.isDateGreaterThanToday(this.request_date)) {
        swal("bounce date can not be greater than today", "", "error");
        this.disable_submit_action = false;
        return;
      }
      payload.store_status = this.store_banks.find(
        (bank) => bank.name === "Treasury Safe"
      ).id;
    }
    console.log(payload);
    if (modal) modal.close();
    this.slimLoadingBarService.start();
    this.reservationService.approvePaymentRequest(payload).subscribe(
      (res) => {
        this.disable_submit_action = false;
        swal("approved successfully", "", "success");
        this.getPaymentCollection(this.reservation_details.id);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.disable_submit_action = false;
        this.slimLoadingBarService.reset();
      }
    );
  }

  approvePaymentRequestForRedposit(list, modal) {
    modal.open();
    this.active_cheque_book_row = list;
  }

  approvePaymentRequestForRedpositModalSubmit(modal) {
    if (!this.store_status || !this.redeposit_date) {
      swal("request date or location is required", "", "error");
      return;
    }
    let payload: any = {
      store_status: this.store_status,
      redeposit_date: this.redeposit_date,
    };
    console.log(payload);
    this.slimLoadingBarService.start();
    this.paymentService.approveRedepositRequest(
      this.active_cheque_book_row.id,
      payload
    ).subscribe(
      (res) => {
        modal.close();
        swal("approved successfully", "", "success");
        this.getPaymentCollection(this.reservation_details.id);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  rejectRedepositRequest(payment) {
    this.slimLoadingBarService.start();
    this.paymentService.rejectRedepositRequest(payment.id).subscribe(
      (res) => {
        swal("rejected successfully", "", "success");
        this.getPaymentCollection(this.reservation_details.id);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  rejectPaymentRequest(ids) {
    let payload: any = {
      ids,
    };
    console.log(payload);
    this.slimLoadingBarService.start();
    this.reservationService.rejectPaymentRequest(payload).subscribe(
      (res) => {
        swal("rejected successfully", "", "success");
        this.getPaymentCollection(this.reservation_details.id);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  rejectCancelRequest(ids) {
    const allowedRoles = ["Admin", "Treasury Accountant", "A.R Accountant"];
    const payments = (this.payment_collections || []).filter((payment) =>
      ids.includes(payment.id)
    );
    if (!allowedRoles.includes(this.userProfile?.role)) {
      swal("You are not allowed to reject cancel requests", "", "error");
      return;
    }
    if (payments.length !== ids.length || payments.some((payment) => payment.status !== "pending-cancelled")) {
      swal("Only pending-cancelled payments can be rejected", "", "error");
      return;
    }
    swal({
      title: "Reject cancel request",
      input: "text",
      inputPlaceholder: "Rejection reason",
      showCancelButton: true,
      confirmButtonText: "Reject",
      inputValidator: (value) => !value && "Rejection reason is required",
    }).then((result) => {
      if (!result.value) return;
      this.slimLoadingBarService.start();
      forkJoin(
        ids.map((id) =>
          this.reservationService.rejectCancelRequest(id, {
            reject_reason: result.value,
          })
        )
      )
        .subscribe(
          () => {
            swal("Cancel request rejected successfully", "", "success");
            this.getPaymentCollection(this.reservation_details.id);
          },
          (err) => this.errorHandlerService.handleErorr(err)
        )
        .add(() => this.slimLoadingBarService.complete());
    });
  }

  eoiObservableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get<any[]>(`${baseUrl}eois/get_available_eois_to_link?serial=${keyword}`)
        .map((res: any[]) => {
          console.log(res);
          if (res.length === 0) {
            let arr = [];
            return arr;
          }
          this.eoisArrSearch = [];
          this.eoiDataFromSearch = res;
          res.forEach((e) => {
            this.eoisArrSearch.push(
              `${e.serial} / ${e.eoi_id} / ${e.eoi_value}`
            );
          });
          console.log(this.eoisArrSearch);
          return this.eoisArrSearch;
        });
    } else {
      return Observable.of([]);
    }
  };

  linkEoiModalSubmit(id, modal) {
    if (this.eoiValue > this.chosenEoi.split(" / ")[2]) {
      swal(
        "error",
        "Eoi value should be less than the current Eoi value",
        "error"
      );
      return;
    }
    if (this.chosenEoi) {
      const payload = {
        eoi_id: this.chosenEoi.split(" / ")[1],
        eoi_value: this.eoiValue,
      };
      this.slimLoadingBarService.start();
      this.reservationService
        .linkEOIToReservation(this.reservation_details.id, payload)
        .subscribe(
          (res) => {
            this.getReservation();
            this.getPaymentCollection(this.reservationId);
            modal.close();
            this.chosenEoi = null;
            this.chosen_eoi = null;
            swal("Success", "Linked EOI Successfully", "success");
            this.slimLoadingBarService.complete();
          },
          (err) => {
            modal.close();
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.reset();
          }
        );
    }
  }

  getRejectReaasons() {
    this.slimLoadingBarService.start();
    this.reservationService.getAllRejectReasons().subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        this.reject_reasons = res;
        console.log("reasons : ", res);
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  assignSelectedCheque(list) {
    this.list = list;
  }

  makePaymentRequests(type, ids, modal) {
    if (type === "Redeposit Request") {
      if (!this.request_date) {
        swal("request date or reason is empty", "", "error");
        return;
      }
    }
    if (type === "Recall Request") {
      if (!this.request_date || !this.request_reason) {
        swal("request date or reason is empty", "", "error");
        return;
      }
    }
    if (type === "Redeposit Request") {
      if (this.isDateGreaterThanToday(this.request_date)) {
        swal("request date can not be greater than today", "", "error");
        return;
      }
    }
    if (type === "Cancel Request" || type === "recall") {
      if (!this.request_date || !this.request_reason) {
        swal("request date or reason is empty", "", "error");
        return;
      }
    }
    if (type === "Cancel Request") {
      if (this.isDateGreaterThanToday(this.request_date)) {
        swal("request date can not be greater than today", "", "error");
        return;
      }
    }

    if (type === "Redeposit Request") {
      const paymentIds = Array.isArray(ids) ? ids : [ids];
      const payload = {
        request_date: this.request_date,
      };

      this.slimLoadingBarService.start();
      forkJoin(
        paymentIds.map((payment) =>
          this.paymentService.redepositRequestStatus(payment, payload)
        )
      ).subscribe(
        () => {
          swal("request made successfully", "", "success");
          this.getPaymentCollection(this.reservation_details.id);
          this.slimLoadingBarService.complete();
          if (modal) modal.close();
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
      return;
    }

    const payload = {
      ids,
      type: type,
      request_reason: this.request_reason,
      request_date: this.request_date,
    };
    // console.log(payload);
    this.slimLoadingBarService.start();
    this.reservationService.makePaymentRequests(payload).subscribe(
      (res) => {
        swal("request made successfully", "", "success").then(() => {
          if (res) {
            this.active_cheque_book_row = {
              id: res,
            };
            if(type == "Cancel Request" || type === "recall" || type === "Recall Request") {
              this.onOpenCollectCheque(
                this.active_cheque_book_row,
                this.collectCheque,
                false,
                1
              );
            }
          }
        });
        this.getPaymentCollection(this.reservation_details.id);
        this.slimLoadingBarService.complete();
        if (modal) modal.close();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  openCancelRequest(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    modal.open();
  }

  openRecallRequest(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    modal.open();
  }

  openRedeopsitRequest(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    modal.open();
  }

  openApproveRecallRequest(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    console.log(type);
    modal.open();
  }

  openApproveRequestAsRecallModal(modal, type, ids, list) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    if (list.request_reason === "Early Payment") {
      this.request_reason = "Early Payment";
    }
    modal.open();
  }

  openApproveRequestAsCancelledModal(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    modal.open();
  }

  openApproveRequestAsBounceModal(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    this.store_status = this.store_banks.find(
      (a) => a.name == "Treasury Safe"
    ).id;
    modal.open();
  }

  approvePendingRecall(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    this.store_status = this.store_banks.find(
      (a) => a.name == "Treasury Safe"
    ).id;
    console.log(type);
    modal.open();
  }

  goToUnit(id) {
    this.router.navigate([`/pages/project/view-reservation/${id}`]);
  }

  isDateGreaterThanToday(date) {
    const inputDate = new Date(date);
    const today = new Date();

    if (inputDate > today) {
      return true;
    }
    return false;
  }

  openEditSingleLead(modal, lead) {
    // Open Material Dialog instead of the old modal
    const dialogRef = this.dialog.open(EditCustomerDialogComponent, {
      width: '60vw',
      height: '95vh',
      data: {
        reservation_details: this.reservation_details,
        customer: lead,
        mode: 'edit',
        title: 'Edit Customer Info'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getReservation()
      }
    });
  }

  downloadUnitStatement() {
    this.slimLoadingBarService.start();
    this.reservationService
      .getUnitStatement(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          window.open(res.url);
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  printReservation() {
    // swal("Print Design Not Available", "", "info");
    // return;
    this.reservation_details.contract_type === "sale" &&
      print_template(
        printSaleReservationFile,
        this.reservation_details,
        this.payment_collections
      );
  }

  getMinAvailableSelectedDate(): string {
    if (!this.reservation_details.created_at) {
      return format(new Date(), "yyyy-MM-dd");
    }

    try {
      const parsedDate = parse(
        this.reservation_details.created_at,
        "dd/MM/yyyy hh:mm:ss a",
        new Date()
      );
      return !isNaN(parsedDate.getTime())
        ? format(parsedDate, "yyyy-MM-dd")
        : format(new Date(), "yyyy-MM-dd");
    } catch {
      return format(new Date(), "yyyy-MM-dd");
    }
  }

  minSelectedDateToday() {
    return format(new Date(), "yyyy-MM-dd");
  }

  getMaxContractDate(): string {
    return format(new Date(), "yyyy-MM-dd");
  }

  getMinContractDate(): string {
    const date = new Date();
    date.setDate(date.getDate() - 15);
    return format(date, "yyyy-MM-dd");
  }

  printImg(src) {
    this.projectsService.printImg(src);
  }

  assignBrokerIncentive(modal) {
    const payload = {
      broker_incentive_id: this.broker_incentive_id,
    };
    this.slimLoadingBarService.start();
    this.userService
      .assign_broker_incentive(this.reservation_details.id, payload)
      .subscribe(
        (res) => {
          swal("Assign Broker Incentive Successfully", "", "success");
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  assignBrokerPartner(modal) {
    if (!this.partner_broker_id) {
      swal("Please select partner broker", "", "error");
      return;
    }
    const payload = {
      partner_broker_id: this.partner_broker_id,
    };
    this.slimLoadingBarService.start();
    this.userService
      .assign_partner_broker(this.reservation_details.id, payload)
      .subscribe(
        (res) => {
          swal("Assign Broker Partner Successfully", "", "success");
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  assignApproveCollectChequeModal() {
    this.approveCollect.bank_id = +this.active_cheque_book_row.bank_id;
    this.approveCollect.cheque_number =
      +this.active_cheque_book_row.cheque_number;
    this.approveCollect.transaction_number =
      +this.active_cheque_book_row.transaction_number;
    this.approveCollect.store_status =
      +this.active_cheque_book_row.store_status;
    this.approveCollect.partially_method =
      +this.active_cheque_book_row.partially_method;
    this.approveCollect.collection_date =
      +this.active_cheque_book_row.collection_date;
    this.approveCollect.id = +this.active_cheque_book_row.id;
  }

  approvePendingCollect(modal) {
    const payload = {
      ...this.approveCollect,
      ids: [this.approveCollect.id],
    };
    if (this.approveCollect.partially_method != 4) {
      delete payload.cheque_number;
    } else {
      delete payload.transaction_number;
      delete payload.store_status;
    }
    if (payload.partially_method == "4" && !payload.cheque_number) {
      swal("cheque number is required", "", "error");
      return;
    }
    if (
      (payload.partially_method == "3" || payload.partially_method == "2") &&
      !payload.transaction_number
    ) {
      swal("transaction number is required", "", "error");
      return;
    }
    if (
      (payload.partially_method == "3" || payload.partially_method == "2") &&
      !payload.store_status
    ) {
      swal("Location is required", "", "error");
      return;
    }
    if (
      (payload.partially_method === "2" ||
        payload.partially_method === "3" ||
        payload.partially_method === "4") &&
      !payload.bank_id
    ) {
      swal("Customer Bank is required", "", "error");
      return;
    }
    if (!payload.collection_date) {
      swal("Collection Date is required", "", "error");
      return;
    }
    this.slimLoadingBarService.start();
    this.reservationService.approvePendingCollected(payload).subscribe(
      (res: any) => {
        swal("Success", "Payment Approved Successfully!", "success");
        this.slimLoadingBarService.complete();
        this.getPaymentCollection(this.reservation_details.id);
        modal.close();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  assignApproveCollectChequeFinesModal(payment) {
    this.approveCollect.bank_id = payment.bank_id;
    this.approveCollect.cheque_number = payment.cheque_number;
    this.approveCollect.transaction_number = payment.transaction_number;
    this.approveCollect.store_status = +payment.store_status;
    this.approveCollect.partially_method = payment.partially_method;
    this.approveCollect.collection_date = payment.collection_date;
    this.approveCollect.id = payment.id;
  }

  approvePendingCollectFines(modal) {
    const payload = {
      ...this.approveCollect,
      ids: [this.approveCollect.id],
    };
    if (this.approveCollect.partially_method != 4) {
      delete payload.cheque_number;
    } else {
      delete payload.transaction_number;
      delete payload.store_status;
    }
    if (payload.partially_method == "4" && !payload.cheque_number) {
      swal("cheque number is required", "", "error");
      return;
    }
    if (
      (payload.partially_method == "3" || payload.partially_method == "2") &&
      !payload.transaction_number
    ) {
      swal("transaction number is required", "", "error");
      return;
    }
    if (
      (payload.partially_method == "3" || payload.partially_method == "2") &&
      !payload.store_status
    ) {
      swal("Location is required", "", "error");
      return;
    }
    if (
      (payload.partially_method === "2" ||
        payload.partially_method === "3" ||
        payload.partially_method === "4") &&
      !payload.bank_id
    ) {
      swal("Customer Bank is required", "", "error");
      return;
    }
    if (!payload.collection_date) {
      swal("Collection Date is required", "", "error");
      return;
    }
    this.slimLoadingBarService.start();
    this.reservationService.approveCollectFine(payload).subscribe(
      (res: any) => {
        swal("Success", "Payment Approved Successfully!", "success");
        this.slimLoadingBarService.complete();
        this.getReservation();
        modal.close();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  rejectCollectFine(list) {
    swal({
      title: "Are you sure?",
      text: "You will Reject this fine!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        const payload = {
          ids: [list.id],
        };
        this.slimLoadingBarService.start();
        this.reservationService.rejectCollectFine(payload).subscribe(
          (res: any) => {
            swal("Woohoo!", "Collected!", "success");
            this.getReservation();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        );
      }
    });
  }

  rejectPendingCollect(payment) {
    swal({
      title: "Are you sure?",
      text: "You will reject this payment!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        const payload = {
          ids: [payment.id],
        };
        this.slimLoadingBarService.start();
        this.reservationService.rejectPendingCollected(payload).subscribe(
          (res: any) => {
            swal("Success", "Payment Rejected Successfully!", "success");
            this.slimLoadingBarService.complete();
            this.getPaymentCollection(this.reservation_details.id);
          },
          (err) => {
            this.slimLoadingBarService.reset();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  downloadDocument(document, receipt) {
    const payment = { ...document, receipts: [receipt] };
    print_template(printReceiptPdf, payment, this.reservation_details);
  }

  getReservationPaymentMethodName(): string {
    return resolvePaymentMethod(
      this.reservation_details,
      {},
      this.reservation_details
    ).paymentMethod;
  }

  printPartnerCheque() {
    this.slimLoadingBarService.start();
    this.reservationService
      .printPartnerCheque(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          window.open(res.url);
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  sendReservationToERP() {
    swal({
      title: "Are you sure?",
      text: "You will send this reservation to ERP!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .sendReservationToERP(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else {
        swal("Cancelled", "", "warning");
      }
    });
  }

  refundRequestModalSubmit(modal) {
    if (this.isRefundRequestLoading) {
      return;
    }
    const payload = {
      refund_reason: this.refundReason,
    };
    if (!this.refundReason) {
      swal("You have to provide a refund reason", "", "error");
      return;
    }
    if (this.refundReason == "termination") {
      if (!this.terminationReason) {
        swal("You have to provide a termination reason", "", "error");
        return;
      }
      payload["termination_reason"] = this.terminationReason;
    }

    this.isRefundRequestLoading = true;
    this.slimLoadingBarService.start();

    swal({
      title: "Processing Refund Request",
      text: "Please wait while your request is being processed...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      onOpen: () => {
        swal.showLoading();
      },
    });

    this.reservationService
      .refundRequest(this.reservation_details.id, JSON.stringify(payload))
      .subscribe(
        (data) => {
          this.isRefundRequestLoading = false;
          modal.close();
          this.getReservation();
          swal("Woohoo!", "Refund Request Submitted Successfully!", "success");
        },
        (err) => {
          this.isRefundRequestLoading = false;
          this.errorHandlerService.handleErorr(err);
        },
        () => {
          this.isRefundRequestLoading = false;
          this.slimLoadingBarService.complete();
        }
      );
  }

  approveRefundRequestModalSubmit(modal) {
    if (this.isApproveRefundRequestLoading) {
      return;
    }
    if (!this.approve_refund_date) {
      swal("Approve Refund Date is required", "", "error");
      return;
    }
    const payload = {
      collected_fines_amount: this.reservation_details.collected_fines,
      fines_amount_returned: this.fines_amount_returned,
      approve_refund_date: this.approve_refund_date,
      refund_collected_amount: this.reservation_details.total_collected,
      refund_company_amount: this.refund_company_amount,
      refund_discount_amount: this.refund_discount_amount,
      total_amount: this.total_amount,
    };
    this.isApproveRefundRequestLoading = true;
    this.slimLoadingBarService.start();

    swal({
      title: "Processing Approval",
      text: "Please wait while your request is being processed...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      onOpen: () => {
        swal.showLoading();
      },
    });

    this.reservationService
      .approveRefundRequest(
        this.reservation_details.id,
        JSON.stringify(payload)
      )
      .subscribe(
        (data) => {
          this.isApproveRefundRequestLoading = false;
          modal.close();
          this.getReservation();
          swal("Woohoo!", "Approved Refund Request Successfully!", "success");
        },
        (err) => {
          this.isApproveRefundRequestLoading = false;
          this.errorHandlerService.handleErorr(err);
        },
        () => {
          this.isApproveRefundRequestLoading = false;
          this.slimLoadingBarService.complete();
        }
      );
  }

  updateTotalAmount() {
    if (this.refund_company_amount) {
      this.refund_company_amount = Number(this.refund_company_amount);
      if (this.reservation_details.status == "Refund-Return To Company") {
        this.total_amount =
          this.reservation_details.total_collected + this.refund_company_amount;
      }
    }
    if (this.refund_discount_amount) {
      this.refund_discount_amount = Number(this.refund_discount_amount);
      if (
        this.reservation_details.status == "Refund-Termination" ||
        this.reservation_details.status == "Refund-Customer Cancelled"
      ) {
        this.total_amount =
          this.reservation_details.total_collected -
          this.refund_discount_amount;
      }
    }
  }

  rejectRefundRequest() {
    swal({
      title: "Are you sure Reject Refund Request?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        swal({
          title: "Rejecting Refund Request",
          text: "Please wait while your request is being processed...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          onOpen: () => {
            swal.showLoading();
          },
        });
        this.reservationService
          .rejectRefundRequest(this.reservation_details.id)
          .subscribe(
            (data) => {
              this.getReservation();
              swal("Woohoo!", "Reject Refund Request Successfully!", "success");
            },
            (err) => {
              this.errorHandlerService.handleErorr(err);
            },
            () => this.slimLoadingBarService.complete()
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  reservationObservableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}reservations/filter/unit?rf_serial=${keyword}`)
        .map((res: any) => {
          console.log(res.data.length);
          if (res.data.length == 0) {
            let arr = [];
            return arr;
          } else {
            this.reservationsArrSearch = [];
            if (this.unit_type == "contracted_unit") {
              res.data = res.data.filter(
                (e) =>
                  e.is_accountant_approved == 1 &&
                  e.approve_refund_date == null
              );
            } else {
              res.data = res.data.filter((e) => e.is_accountant_approved == 0);
            }
            this.reservationDataFromSearch = res.data;
            res.data.forEach((e) => {
              this.reservationsArrSearch.push(`${e.unit_serial} / ${e.id}`);
            });
            return this.reservationsArrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  transferToAnotherUnitModalSubmit(id, modal) {
    if (this.chosenReservation) {
      const payload = {
        reservation_id: this.chosenReservation.split(" / ")[1],
      };
      this.slimLoadingBarService.start();
      this.reservationService
        .transferToAnotherUnit(
          this.reservation_details.id,
          JSON.stringify(payload)
        )
        .subscribe(
          (data) => {
            this.chosenReservation = null;
            this.chosen_reservation = null;
            swal("Success", "Reservation Transferred Successfully", "success");
            this.slimLoadingBarService.complete();
            this.getReservation();
            modal.close();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  approveTransferToAnotherUnit() {
    swal({
      title: "Are you sure?",
      text: "Approve Transfer To Another Unit!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
    }).then(() => {
      this.reservationService
        .approveTransferToAnotherUnit(this.reservationId)
        .subscribe(
          (res) => {
            this.getReservation();
          },
          (err) => {
            swal("Error", err.error.message, "error");
          }
        );
    });
  }

  changeChequeCollectType(event) {
    if (event === "fully-collected") {
      this.cheque_amount = this.active_cheque_book_row.amount;
    } else {
      this.cheque_amount = null;
    }
  }

  calculateEquvalentAmount() {
    if (
      this.currency_code != "EGP" &&
      this.exchange_rate &&
      this.cheque_amount
    ) {
      this.equivalent_in_currency = (
        this.cheque_amount / this.exchange_rate
      ).toFixed(2);
    }
  }

  assignFineModal() {
    this.change_reservation_fine = {
      fine_percentage: this.reservation_details.fine_percentage,
      fine_type: +this.reservation_details.fine_type,
      is_fine_calc: this.reservation_details.is_fine_calc,
    };
  }

  assigTotalAmount() {
    this.total_amount = this.reservation_details.total_collected;
  }

  submitChangeReservationFine() {
    if (
      this.change_reservation_fine.fine_percentage > 100 ||
      this.change_reservation_fine.fine_percentage < 0
    ) {
      swal("Fine Percentage should be between 0 to 100", "", "error");
      return;
    }

    this.reservationService
      .changeReservationFine(
        this.change_reservation_fine,
        this.reservation_details.id
      )
      .subscribe(
        (res) => {
          this.getReservation();
        },
        (err) => this.errorHandlerService.handleErorr(err)
      );
  }

  createRentDetailsForm(data?) {
    const rentDetails = (data && data.rent_details) || {};
    const getValue = (key) => {
      if (rentDetails[key] !== undefined && rentDetails[key] !== null) {
        return rentDetails[key];
      }
      if (data && data[key] !== undefined && data[key] !== null) {
        return data[key];
      }
      return "";
    };
    const normalizeNumber = (value) => {
      if (value === "" || value === null || value === undefined) {
        return "";
      }
      return +value;
    };
    this.rentDetailsForm = this.fb.group({
      contract_type: [data && data.contract_type ? data.contract_type : "rent"],
      company_name: [getValue("company_name"), Validators.required],
      company_address: [getValue("company_address")],
      company_info: [getValue("company_info")],
      commercial_register: [getValue("commercial_register"), Validators.required],
      commercial_register_name: [getValue("commercial_register_name")],
      commercial_register_address: [getValue("commercial_register_address")],
      commercial_register_issue_date: [getValue("commercial_register_issue_date")],
      person_authorized_to_sign_the_contract_job: [
        getValue("person_authorized_to_sign_the_contract_job"),
      ],
      person_authorized_to_sign_the_contract_id: [
        getValue("person_authorized_to_sign_the_contract_id"),
      ],
      person_authorized_to_sign_the_contract_address: [
        getValue("person_authorized_to_sign_the_contract_address"),
      ],
      person_authorized_to_sign_the_contract_name: [
        getValue("person_authorized_to_sign_the_contract_name"),
      ],
      rent_value: [getValue("rent_value"), Validators.required],
      rent_start_date: [getValue("rent_start_date"), Validators.required],
      rent_end_date: [getValue("rent_end_date"), Validators.required],
      rent_years_num: [getValue("rent_years_num"), Validators.required],
      indoor_area: [getValue("indoor_area")],
      outdoor_area: [getValue("outdoor_area")],
      annual_increase_rate: [getValue("annual_increase_rate")],
      taxes_percentage: [normalizeNumber(getValue("taxes_percentage"))],
      insurance_period: [normalizeNumber(getValue("insurance_period"))],
      installment_interval: [normalizeNumber(getValue("installment_interval"))],
      indoor_meter_maintenance: [getValue("indoor_meter_maintenance")],
      outdoor_meter_maintenance: [getValue("outdoor_meter_maintenance")],
      maintenance_interval: [normalizeNumber(getValue("maintenance_interval"))],
      grace_period: [normalizeNumber(getValue("grace_period"))],
      tax_card_number: [getValue("tax_card_number")],
      water_status: [getValue("water_status")],
      electricity_status: [getValue("electricity_status")],
      elevator_cards: [getValue("elevator_cards")],
      locker_number: [getValue("locker_number")],
      golf_car_service: [getValue("golf_car_service")],
      air_conditioning_space: [getValue("air_conditioning_space")],
      marketing_fees: [getValue("marketing_fees")],
      sales_differences: [getValue("sales_differences")],
      finishing_insurance: [getValue("finishing_insurance")],
      indoor_meter_fees: [getValue("indoor_meter_fees")],
      outdoor_meter_fees: [getValue("outdoor_meter_fees")],
      maintenance_indoor_meter_fees: [getValue("maintenance_indoor_meter_fees")],
      maintenance_outdoor_meter_fees: [getValue("maintenance_outdoor_meter_fees")],
      marketing_fees_months: [getValue("marketing_fees_months")],
      revenue_share_percentage: [getValue("revenue_share_percentage")],
    });
  }

  editRentDetailsModalOpen() {
    this.createRentDetailsForm(this.reservation_details);
  }

  editRentDetailsModalClose() {}

  editRentDetailsModalSubmit(modal) {
    if (this.rentDetailsForm && this.rentDetailsForm.invalid) {
      swal("Please fill required fields.", "", "warning");
      return;
    }
    const payload = {
      ...this.rentDetailsForm.value,
      contract_type: "rent",
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .editRentDetails(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          this.slimLoadingBarService.complete();
          modal.close();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.reset();
        }
      );
  }

  finalApproveRefundRequestModalSubmit(modal) {
    if (this.isFinalApproveRefundRequestLoading) {
      return;
    }
    if (!this.final_approve_refund_date) {
      swal("Approve Refund Date is required", "", "error");
      return;
    }
    const payload = {
      final_approve_refund_date: this.final_approve_refund_date,
    };
    this.isFinalApproveRefundRequestLoading = true;
    this.slimLoadingBarService.start();

    swal({
      title: "Processing Final Approval",
      text: "Please wait while your request is being processed...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      onOpen: () => {
        swal.showLoading();
      },
    });

    this.reservationService
      .finalApproveRefundRequest(
        this.reservation_details.id,
        JSON.stringify(payload)
      )
      .subscribe(
        (data) => {
          this.isFinalApproveRefundRequestLoading = false;
          modal.close();
          this.getReservation();
          swal("Woohoo!", "Approved Refund Request Successfully!", "success");
        },
        (err) => {
          this.isFinalApproveRefundRequestLoading = false;
          if (err) {
            this.errorHandlerService.handleErorr(err);
          }
        },
        () => {
          this.isFinalApproveRefundRequestLoading = false;
          this.slimLoadingBarService.complete();
        }
      );
  }

    onTransferReservationAmountChange(
    reservation: TransferToContractedUnitReservation,
    value: string
  ) {
    if (value === null || value === undefined) {
      reservation.amount = null;
      reservation.amountDisplay = "";
      return;
    }
    const normalized = value.toString().replace(/,/g, "");
    const cleaned = normalized.replace(/[^0-9.]/g, "");
    if (!cleaned) {
      reservation.amount = null;
      reservation.amountDisplay = "";
      return;
    }
    const parts = cleaned.split(".");
    const integerPartRaw = parts[0] || "";
    const decimalPartRaw = parts.slice(1).join("");
    const limitedDecimalPart = decimalPartRaw.slice(0, 2);
    const hasDecimalPoint = cleaned.includes(".");
    const hasTrailingDecimal = hasDecimalPoint && cleaned.endsWith(".");
    const normalizedInteger =
      integerPartRaw.replace(/^0+(?=\d)/, "") ||
      (hasDecimalPoint && !integerPartRaw ? "0" : integerPartRaw);
    const formattedInteger = normalizedInteger
      ? normalizedInteger.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : "0";
    let formattedValue = formattedInteger;
    if (hasDecimalPoint) {
      formattedValue += ".";
      formattedValue += limitedDecimalPart;
      if (hasTrailingDecimal && !limitedDecimalPart) {
        // Keep trailing dot to allow typing decimals
      }
    }
    reservation.amountDisplay = formattedValue;
    const numericString =
      limitedDecimalPart.length > 0
        ? `${normalizedInteger || "0"}.${limitedDecimalPart}`
        : normalizedInteger || (hasDecimalPoint ? "0" : "");
    const parsedValue = parseFloat(numericString);
    reservation.amount = isNaN(parsedValue)
      ? null
      : this.roundCurrency(parsedValue);
  }

  resetTransferToContractedUnitState() {
    this.transferToContractedUnitSelection = null;
    this.transferToContractedUnitReservations = [];
  }

  removeTransferReservation(index: number) {
    this.transferToContractedUnitReservations.splice(index, 1);
  }


  transferToContractedUnitModalSubmit(id, modal) {
    if (!this.transferToContractedUnitReservations.length) {
      swal("Please add at least one reservation", "", "error");
      return;
    }
    const invalidAmount = this.transferToContractedUnitReservations.find(
      (reservation) => reservation.amount === null || reservation.amount <= 0
    );
    if (invalidAmount) {
      swal(
        "Each reservation must have an amount greater than zero",
        "",
        "error"
      );
      return;
    }
    if (
      Math.abs(this.transferRemainingAmount) >= this.transferAmountTolerance
    ) {
      swal("Remaining amount must equal zero before submitting", "", "error");
      return;
    }
    const payload = {
      reservations: this.transferToContractedUnitReservations.map(
        (reservation) => ({
          reservation_id: reservation.id,
          amount: reservation.amount,
        })
      ),
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .transferToContractedUnit(
        this.reservation_details.id,
        JSON.stringify(payload)
      )
      .subscribe(
        () => {
          this.resetTransferToContractedUnitState();
          this.chosenReservation = null;
          this.chosen_reservation = null;
          swal("Success", "Reservation Transferred Successfully", "success");
          this.slimLoadingBarService.complete();
          this.getReservation();
          modal.close();
        },
        (err) => {
          if (err) {
            this.errorHandlerService.handleErorr(err);
          }
        },
        () => this.slimLoadingBarService.complete()
      );
  }

  onTransferReservationSelected(value: string) {
    this.transferToContractedUnitSelection = value;
  }

  onTransferReservationCleared() {
    this.transferToContractedUnitSelection = null;
  }

  parseNumberValue(value: any): number | null {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    const parsedValue = parseFloat(value);
    if (isNaN(parsedValue)) {
      return null;
    }

    return parsedValue;
  }

  getNumericValueFromReservation(keys: string[]): number | null {
    if (!this.reservation_details) {
      return null;
    }

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const directValue = this.parseNumberValue(this.reservation_details[key]);
      if (directValue !== null) {
        return directValue;
      }

      if (this.reservation_details.percentage_value) {
        const percentageValue = this.parseNumberValue(
          this.reservation_details.percentage_value[key]
        );
        if (percentageValue !== null) {
          return percentageValue;
        }
      }
    }

    return null;
  }

  refreshPartnerCommissionUi() {
    const unitPrice = this.parseNumberValue(
      this.reservation_details && this.reservation_details.unit_price
    );
    const agentPercent = this.getNumericValueFromReservation([
      "agent_commission_percentage",
      "agent_commission_percent",
      "agent_percentage",
      "sales_agent_percentage",
      "sales_commission_percentage",
      "commission_percentage",
      "commission_rate",
    ]);
    const brokerPercent = this.getNumericValueFromReservation([
      "broker_commission_percentage",
      "broker_commission_percent",
      "broker_percentage",
    ]);
    const ambassadorPercent = this.getNumericValueFromReservation([
      "ambassador_commission_percentage",
      "ambassador_commission_percent",
      "ambassador_percentage",
    ]);

    let externalTotalPercent = 0;
    let hasData = false;

    if (agentPercent !== null) {
      externalTotalPercent += agentPercent;
      hasData = true;
    }

    if (brokerPercent !== null) {
      externalTotalPercent += brokerPercent;
      hasData = true;
    }

    if (ambassadorPercent !== null) {
      externalTotalPercent += ambassadorPercent;
      hasData = true;
    }

    const partnerPercent = hasData
      ? this.partnerCommissionBasePercent - externalTotalPercent
      : null;
    const partnerAmount =
      partnerPercent !== null && unitPrice !== null
        ? (unitPrice * partnerPercent) / 100
        : null;

    this.partnerCommissionUi = {
      agentPercent: agentPercent,
      brokerPercent: brokerPercent,
      ambassadorPercent: ambassadorPercent,
      externalTotalPercent: hasData ? externalTotalPercent : null,
      partnerPercent: partnerPercent,
      partnerAmount: partnerAmount,
      isExceeded:
        externalTotalPercent !== null &&
        externalTotalPercent > this.partnerCommissionBasePercent,
      hasData: hasData,
    };
  }

  addReservationToContractedUnitList() {
    const reservationId = this.parseReservationSelection(
      this.transferToContractedUnitSelection
    );
    if (!reservationId) {
      return;
    }
    if (
      this.transferToContractedUnitReservations.some(
        (reservation) => reservation.id === reservationId
      )
    ) {
      swal("Reservation already added", "", "info");
      return;
    }
    const reservationData = this.reservationDataFromSearch
      ? this.reservationDataFromSearch.find(
          (reservation) => reservation.id === reservationId
        )
      : null;
    if (!reservationData) {
      swal("Unable to find reservation details", "", "error");
      return;
    }
    this.transferToContractedUnitReservations.push(
      this.buildTransferReservation(reservationData)
    );
    this.transferToContractedUnitSelection = null;
  }

  private buildTransferReservation(
    reservationData: any
  ): TransferToContractedUnitReservation {
    const serial =
      (reservationData && reservationData.unit_serial) ||
      (reservationData && reservationData.reservation_serial) ||
      (reservationData && reservationData.rf_serial) ||
      `#${reservationData && reservationData.id}`;
    const customerName =
      (reservationData && reservationData.customer_name) ||
      (reservationData &&
        reservationData.customer &&
        reservationData.customer.name) ||
      (reservationData && reservationData.lead && reservationData.lead.name) ||
      (reservationData &&
        reservationData.client &&
        reservationData.client.name) ||
      (reservationData && reservationData.owner_name);
    return {
      id: reservationData.id,
      sharing_leads: reservationData.sharing_leads,
      serial,
      customerName,
      amount: null,
      amountDisplay: "",
    };
  }

  private parseReservationSelection(selection: string | null): number | null {
    if (!selection) {
      return null;
    }
    const [, reservationId] = selection.split(" / ");
    const id = Number(reservationId);
    return Number.isNaN(id) ? null : id;
  }

  submitApproveTransferToAnotherUnit() {
    swal({
      title: "Are you sure?",
      text: "Approve Transfer To Another Unit!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
    }).then((result) => {
      if (!result.value) {
        return;
      }
      this.slimLoadingBarService.start();
      this.reservationService
        .approveTransferToAnotherUnit(this.reservationId)
        .subscribe(
          (res) => {
            swal("Success", "Transfer approved successfully", "success");
            this.transfer_payment_as = ""; // Reset
            this.getReservation();
          },
          (err) => {
            swal("Error", err.error.message, "error");
          },
          () => this.slimLoadingBarService.complete()
        );
    });
  }

  approveTransferToContractedUnit() {
    swal({
      title: "Are you sure?",
      text: "Approve Transfer To Contacted Unit!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
    }).then((result) => {
      if (result.value) {
        this.reservationService
          .approveTransferToContractedUnit(this.reservationId)
          .subscribe(
            (res) => {
              this.getReservation();
            },
            (err) => {
              swal("Error", err.error.message, "error");
            }
          );
      }
    });
  }

  openDeliveredToCustomer(list, modal) {
    if (list === null) {
      const selectedPayments = this.payment_collections.filter(
        (payment) => payment.checked == true
      );
      if (selectedPayments.length === 0) {
        swal("No payments selected", "", "error");
        return;
      }
      this.current_active_full_cheque = selectedPayments;
      this.current_active_cheque = selectedPayments;
      modal.open();
      return;
    }
    modal.open();
    this.current_active_full_cheque = list;
    this.current_active_cheque = list;
  }

  // Payment Refund Request Actions

  submitPaymentRefundRequest() {
    swal({
      title: "Are you sure?",
      text: "Submit Payment Refund Request!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Submit it!",
    }).then((result) => {
      if (result.value) {
        this.paymentService.refundRequestPayment(this.activeRefundPayment.id)
        .subscribe(
          (res: any) => {
            swal(
              "Success",
              "Payment refund request submitted successfully",
              "success"
            );
            this.getPaymentCollection(this.reservationId);
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        )
        .add(() => {
          this.paymentRefundRequestSubmitting = false;
          this.slimLoadingBarService.complete();
        });
      } else {
        swal("Cancelled", "Payment refund request not submitted", "error");
      }
    })
  }

  submitApprovePaymentRefund() {
    swal({
      title: "Are you sure?",
      text: "Approve Payment Refund!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
    }).then((result) => {
      if (result.value) {
        this.paymentService.approveRefundRequestPayment(this.activeRefundPayment.id)
        .subscribe(
          (res: any) => {
            swal(
              "Success",
              "Payment refund request approved successfully",
              "success"
            );
            this.getPaymentCollection(this.reservationId);
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        )
        .add(() => {
          this.paymentRefundRequestSubmitting = false;
          this.slimLoadingBarService.complete();
        });
      } else {
        swal("Cancelled", "Payment refund request not approved", "error");
      }
    })
  }

  submitRejectPaymentRefund() {
    swal({
      title: "Are you sure?",
      text: "Reject Payment Refund!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reject it!",
    }).then((result) => {
      if (result.value) {
        this.paymentService.rejectRefundRequestPayment(this.activeRefundPayment.id)
        .subscribe(
          (res: any) => {
            swal(
              "Success",
              "Payment refund request rejected successfully",
              "success"
            );
            this.getPaymentCollection(this.reservationId);
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        )
        .add(() => {
          this.paymentRefundRequestSubmitting = false;
          this.slimLoadingBarService.complete();
        });
      } else {
        swal("Cancelled", "Payment refund request not rejected", "error");
      }
    })
  }

  // Split CDB
  splitCDB(modal, amount) {
    const splitAmount = +amount;
    const paymentAmount = +this.active_cheque_book_row.amount;
    if (!splitAmount || splitAmount <= 0) {
      swal("Amount is required", "", "error");
      return;
    }
    if (splitAmount > paymentAmount) {
      swal("Amount cannot be greater than payment amount", "", "error");
      return;
    }
    const payload = {
      amount,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .splitCdbPayment(this.active_cheque_book_row.id, payload)
      .subscribe(
        () => {
          this.getPaymentCollection(this.reservationId);
          this.splitCDBAmount = null;
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err)
      )
      .add(() => {
        this.slimLoadingBarService.complete();
      });
  }

  // CDB Request Refund Payments Actions

  cdbRequestCrPaymentRefund(payment) {
    swal({
      title: "Are you sure?",
      text: "You will request refund!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, request it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.paymentService.cdbRequestCrPaymentRefund(payment.id).subscribe(
          () => {
            this.getPaymentCollection(this.reservationId);
            swal("Success", "Refund Requested Successfully", "success");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cdbApproveCrPaymentRefund(payment) {
    swal({
      title: "Are you sure?",
      text: "You will approve refund!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.paymentService.cdbApproveCrPaymentRefund(payment.id).subscribe(
          () => {
            this.getPaymentCollection(this.reservationId);
            swal("Success", "Refund Approved Successfully", "success");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cdbRejectCrPaymentRefund(payment) {
    swal({
      title: "Are you sure?",
      text: "You will reject refund!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.paymentService.cdbRejectCrPaymentRefund(payment.id).subscribe(
          () => {
            this.getPaymentCollection(this.reservationId);
            swal("Success", "Refund Rejected Successfully", "success");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/reservation-view/reservation-view.component.ts